/* SOFT RIOT · Zarah Skull
   Bewegung ist ein Gewürz, kein Hauptgericht. Alles funktioniert auch ohne JS so gut es geht. */
(() => {
  'use strict';

  const theme = window.theme || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Währung ----------
     Shopify rechnet Mindestbeträge von Rabatten mit dem aktuellen Wechselkurs um.
     Denselben Kurs stellt Shopify im Browser bereit (window.Shopify.currency.rate). */
  const Currency = {
    isForeign() { return Boolean(theme.currency && theme.shopCurrency && theme.currency !== theme.shopCurrency); },
    rate() {
      const r = parseFloat(window.Shopify?.currency?.rate);
      return r > 0 ? r : 1;
    },
    convert(cents) { return Math.round(Number(cents) * this.rate()); }
  };

  /* ---------- Geld formatieren ---------- */
  function formatMoney(cents, { whole = false } = {}) {
    if (Currency.isForeign()) {
      const digits = whole ? 0 : 2;
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: theme.currency, minimumFractionDigits: digits, maximumFractionDigits: digits
      }).format(Number(cents) / 100);
    }
    const format = theme.moneyFormat || '{{amount_with_comma_separator}} €';
    const value = Number(cents) / 100;
    const fmt = (n, dec, thousands, decimal) => {
      const [int, frac] = n.toFixed(dec).split('.');
      const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + decimal + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Aktionen im Warenkorb ---------- */
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (str, map) => Object.keys(map).reduce((s, k) => s.split(`[${k}]`).join(map[k]), str || '');

  const Promo = {
    // Zuletzt erreichte Staffelstufe je Ort (Schublade/Seite) für den Sticker-Moment
    lastRank(key, value) {
      try {
        if (value === undefined) {
          const v = sessionStorage.getItem(`promo-rank-${key}`);
          return v === null ? null : Number(v);
        }
        sessionStorage.setItem(`promo-rank-${key}`, String(value));
      } catch (_) { /* Speicher nicht verfügbar */ }
      return null;
    },

    bar(progress, marks = '') {
      return `<div class="tiers__bar" aria-hidden="true"><span class="tiers__fill" style="--progress: ${Math.max(0, Math.min(100, progress))}%;"></span>${marks}</div>`;
    },

    miniCards(items, label, { gift = false } = {}) {
      return `<ul class="promo-picks" role="list">${items.map((p) => `
        <li class="promo-pick">
          <a href="${escapeHtml(p.url)}" class="promo-pick__img">${p.img ? `<img src="${escapeHtml(p.img)}" alt="" loading="lazy" width="80" height="80">` : ''}</a>
          <span class="promo-pick__info">
            <a href="${escapeHtml(p.url)}" class="promo-pick__title">${escapeHtml(p.title)}</a>
            <span class="promo-pick__price">${gift ? `<s>${formatMoney(p.price)}</s> ${formatMoney(0)}` : formatMoney(p.price)}</span>
          </span>
          <button type="button" class="promo-pick__add" data-quick-add="${p.id}">${escapeHtml(label)}</button>
        </li>`).join('')}</ul>`;
    },

    tiers(el, data) {
      const t = data.tiers;
      const S = data.strings;
      const conv = (cents) => (data.foreign ? Currency.convert(cents) : cents);
      const isQty = t.basis === 'qty';
      const list = t.list.map((x) => ({ min: isQty ? x.min : conv(x.min * 100), val: x.val })).sort((a, b) => a.min - b.min);
      if (!list.length) return;
      const have = isQty ? t.qty : t.base;
      const reachedIdx = list.reduce((acc, x, i) => (have >= x.min ? i : acc), -1);
      const reached = list[reachedIdx] || null;
      const next = list[reachedIdx + 1] || null;
      const valText = (x) => (t.unit === 'eur' ? `−${formatMoney(conv(x.val * 100))}` : `−${x.val} %`);
      const reward = (x) => (t.unit === 'eur' ? fill(S.rewardEur, { value: formatMoney(conv(x.val * 100)) }) : fill(S.rewardPct, { value: x.val }));
      const saveAt = (x, base) => (!x ? 0 : t.unit === 'eur' ? Math.min(base, conv(x.val * 100)) : Math.round((base * x.val) / 100));
      const saveNow = saveAt(reached, t.base);
      const gap = next ? next.min - have : 0;

      // Hauptsatz
      let msg;
      if (next) {
        msg = isQty
          ? fill(gap === 1 ? S.nextQtyOne : S.nextQtyOther, { count: gap, reward: reward(next) })
          : fill(S.nextAmount, { amount: formatMoney(gap), reward: reward(next) });
        if (reached) msg += ` <span class="promo-tiers__sub">${fill(S.current, { reward: reward(reached) })}</span>`;
      } else {
        msg = fill(S.max, { reward: reward(reached) });
      }

      // Lohnt sich: echte Euro statt Prozent
      let worth = '';
      if (t.worth) {
        if (!isQty && next) {
          const payNow = data.original - saveNow;
          const payNext = data.original + gap - saveAt(next, next.min);
          worth = payNext < payNow
            ? fill(S.worthCheaper, { min: formatMoney(next.min), pay: formatMoney(payNext), now: formatMoney(payNow) })
            : fill(S.worthSave, { min: formatMoney(next.min), save: formatMoney(saveAt(next, next.min)), now: formatMoney(saveNow) });
        } else if (reached && saveNow > 0) {
          worth = fill(S.worthQty, { save: formatMoney(saveNow) });
        }
      }
      const worthHtml = worth ? `<p class="promo-tiers__worth">${worth}</p>` : '';

      // Darstellung
      const max = list[list.length - 1].min;
      let body = '';
      if (t.style === 'receipt') {
        const row = (label, value, cls = '') => `<div class="receipt__row${cls}"><span>${label}</span><span>${value}</span></div>`;
        let rows = row(escapeHtml(S.goods), formatMoney(data.original));
        let pay = data.total;
        let payLabel = S.pay;
        if (data.discount > 0) {
          rows += data.discounts.map((d) => row(escapeHtml(d.title), `−${formatMoney(d.amount)}`)).join('');
        } else if (reached && saveNow > 0) {
          rows += row(`${escapeHtml(fill(S.tier, { reward: reward(reached) }))}<small>${escapeHtml(S.hint)}</small>`, `−${formatMoney(saveNow)}`);
          pay = data.original - saveNow;
          payLabel = S.payEst;
        }
        rows += row(escapeHtml(payLabel), formatMoney(pay), ' receipt__row--total');
        body = `<div class="receipt">${rows}<p class="receipt__scribble">${msg}</p></div>${worthHtml}`;
      } else if (t.style === 'stamps') {
        const stamps = list.map((x, i) => {
          const state = i <= reachedIdx ? ' is-reached' : x === next ? ' is-next' : '';
          const from = isQty ? fill(S.fromQty, { count: x.min }) : fill(S.fromAmount, { amount: formatMoney(x.min).replace(/[.,]00(?=\D*$)/, '') });
          const left = x === next && !isQty ? `<span class="stamp__left">${escapeHtml(fill(S.left, { amount: formatMoney(gap) }))}</span>` : '';
          return `<li class="stamp${state}" style="--tilt: ${[-7, 5, -3, 8][i % 4]}deg;"><span class="stamp__val">${valText(x)}</span><span class="stamp__min">${escapeHtml(from)}</span>${left}</li>`;
        }).join('');
        body = `<p class="promo-tiers__msg" role="status">${msg}</p><ul class="stamps" role="list">${stamps}</ul>${worthHtml}`;
      } else {
        const marks = list.map((x) => `<span class="tiers__mark${have >= x.min ? ' is-reached' : ''}" style="--pos: ${(x.min * 100) / max}%;"><span class="tiers__mark-label">${valText(x)}</span></span>`).join('');
        body = `<p class="promo-tiers__msg" role="status">${msg}</p>${this.bar((have * 100) / max, marks)}${worthHtml}`;
      }

      // Lückenfüller
      if (next && t.fillers && t.fillers.length) {
        const sorted = [...t.fillers].sort((a, b) => a.price - b.price);
        let picks = isQty ? sorted.slice(0, 3) : sorted.filter((p) => p.price >= gap).slice(0, 3);
        if (picks.length < 3 && !isQty) picks = picks.concat(sorted.filter((p) => p.price < gap).reverse().slice(0, 3 - picks.length));
        if (picks.length) body += `<p class="promo-tiers__fillers">${escapeHtml(S.fillers)}</p>${this.miniCards(picks, S.add)}`;
      }
      el.innerHTML = body;

      // Sticker-Moment, wenn seit dem letzten Mal eine neue Stufe erreicht wurde
      const key = el.closest('[data-drawer]') ? 'drawer' : 'page';
      const before = this.lastRank(key);
      this.lastRank(key, reachedIdx);
      if (t.sticker && before !== null && reachedIdx > before && reached && !reducedMotion.matches) {
        const sticker = document.createElement('span');
        sticker.className = 'promo-sticker';
        sticker.setAttribute('aria-hidden', 'true');
        sticker.textContent = `${valText(reached)}!`;
        el.closest('.promo-cart')?.appendChild(sticker);
        setTimeout(() => sticker.remove(), 2600);
      }
    },

    receipt(rows, scribble) {
      const row = ([label, value, cls = '']) => `<div class="receipt__row${cls}"><span>${label}</span><span>${value}</span></div>`;
      return `<div class="receipt">${rows.map(row).join('')}<p class="receipt__scribble">${scribble}</p></div>`;
    },

    gift(el, data) {
      const g = data.gift;
      const S = data.strings;
      const look = g.look || 'bar';
      const min = data.foreign ? Currency.convert(g.min * 100) : g.min * 100;
      const reached = g.base >= min;
      const msg = !reached
        ? fill(S.giftNext, { amount: formatMoney(min - g.base) })
        : escapeHtml(g.has ? S.giftDone : S.giftPick);
      const picks = reached && !g.has && g.items.length ? this.miniCards(g.items, S.giftAdd, { gift: true }) : '';
      const bar = reached ? '' : this.bar((g.base * 100) / min);

      if (look === 'receipt') {
        const value = reached ? `${formatMoney(0)} ✓` : escapeHtml(fill(S.left, { amount: formatMoney(min - g.base) }));
        el.innerHTML = this.receipt([
          [escapeHtml(S.goods), formatMoney(g.base)],
          [escapeHtml(fill(S.giftRow, { amount: formatMoney(min) })), value, ' receipt__row--total']
        ], msg) + picks;
      } else if (look === 'tag') {
        el.innerHTML = `<div class="gift-tag${reached ? ' is-open' : ''}" style="--progress: ${Math.min(100, (g.base * 100) / min)}%;">
          <span class="gift-tag__string" aria-hidden="true"></span>
          <p class="gift-tag__text" role="status">${msg}</p>
        </div>${picks}`;
      } else if (look === 'scratch') {
        let open = false;
        try { open = sessionStorage.getItem('promo-gift-open') === '1'; } catch (_) { /* egal */ }
        if (!reached || g.has || !picks) {
          el.innerHTML = `<p${reached ? ' class="promo-cart__done"' : ''}>${msg}</p>${bar}${reached ? '' : `<div class="gift-foil" aria-hidden="true"><span>${escapeHtml(S.giftSecret)}</span></div>`}`;
        } else if (open) {
          el.innerHTML = `<p class="promo-cart__done">${msg}</p>${picks}`;
        } else {
          el.innerHTML = `<p class="promo-cart__done">${msg}</p><div class="gift-scratch">${picks}<canvas class="scratch__canvas" aria-hidden="true"></canvas></div><button type="button" class="scratch__reveal">${escapeHtml(S.giftReveal)}</button>`;
          const card = $('.gift-scratch', el);
          const btn = $('.scratch__reveal', el);
          const reveal = scratchFoil(card, $('canvas', card), `✦ ${S.giftScratch} ✦`, () => {
            btn.remove();
            try { sessionStorage.setItem('promo-gift-open', '1'); } catch (_) { /* egal */ }
          });
          if (reveal) btn.addEventListener('click', reveal);
          else btn.remove();
        }
      } else {
        el.innerHTML = `<p${reached ? ' class="promo-cart__done"' : ''}>${msg}</p>${bar}${picks}`;
      }
    },

    ship(el, data) {
      const s = data.ship;
      const S = data.strings;
      const look = s.look || 'bar';
      const min = data.foreign ? Currency.convert(s.min * 100) : s.min * 100;
      const done = s.base >= min;
      const left = formatMoney(Math.max(0, min - s.base));
      const progress = Math.min(100, (s.base * 100) / min);
      const msg = done ? escapeHtml(S.shipDone) : fill(S.shipNext, { amount: left });
      const msgP = `<p${done ? ' class="promo-cart__done"' : ''} role="status">${msg}</p>`;

      if (look === 'receipt') {
        el.innerHTML = this.receipt([
          [escapeHtml(S.goods), formatMoney(s.base)],
          [`${escapeHtml(S.shipRow)}<small>${escapeHtml(fill(S.shipFrom, { amount: formatMoney(min) }))}</small>`, done ? `${escapeHtml(S.shipFree)} ✓` : escapeHtml(fill(S.left, { amount: left })), ' receipt__row--total']
        ], msg);
      } else if (look === 'parcel') {
        el.innerHTML = `${msgP}<div class="parcel${done ? ' is-home' : ''}" style="--progress: ${progress}%;" aria-hidden="true">
          <span class="parcel__road"><span class="parcel__box"><svg viewBox="0 0 24 24"><path d="M4 8.5 12 5l8 3.5v8L12 20l-8-3.5z"/><path d="m4 8.5 8 3.5 8-3.5M12 12v8"/></svg></span></span>
          <svg class="parcel__home" viewBox="0 0 24 24"><path d="M4 11.5 12 5l8 6.5V20h-5.5v-5h-5v5H4z"/></svg>
          ${done ? `<span class="parcel__stamp">${escapeHtml(S.shipStamp)} ✓</span>` : ''}
        </div>`;
      } else if (look === 'stamp') {
        el.innerHTML = `<div class="postage">
          <div class="postage__stamp${done ? ' is-done' : ''}" style="--progress: ${progress}%;" aria-hidden="true">
            <span class="postage__val">${done ? escapeHtml(S.shipStamp) : escapeHtml(fill(S.left, { amount: left }))}</span>
            ${done ? `<span class="postage__mark">${escapeHtml(S.shipStamp)}</span>` : ''}
          </div>
          ${msgP}
        </div>`;
      } else {
        el.innerHTML = done ? msgP : `${msgP}${this.bar(progress)}`;
      }
    },

    render(root = document) {
      $$('[data-promo]', root).forEach((box) => {
        let data;
        try { data = JSON.parse(box.dataset.promo); } catch (_) { return; }
        const tiers = $('[data-promo-tiers]', box);
        const gift = $('[data-promo-gift]', box);
        const ship = $('[data-promo-ship]', box);
        if (tiers && data.tiers) this.tiers(tiers, data);
        if (gift && data.gift) this.gift(gift, data);
        if (ship && data.ship) this.ship(ship, data);
        const bar = $('[data-promo-bar]', box);
        if (bar) this.chipBar(bar, box, data);
      });
    },

    // Kompakter Warenkorb: alle Aktionen als Chips in einer Leiste, dazu ein Mini-Fortschritt zum nächsten Ziel
    chipBar(bar, box, data) {
      const S = data.strings;
      const conv = (cents) => (data.foreign ? Currency.convert(cents) : cents);
      const chips = [];
      if (data.ship) {
        const min = conv(data.ship.min * 100);
        const done = data.ship.base >= min;
        chips.push({ done, progress: done ? 1 : data.ship.base / min, text: done ? S.barShipDone : fill(S.barShipNext, { amount: formatMoney(min - data.ship.base) }) });
      }
      if (data.tiers && data.tiers.list.length) {
        const t = data.tiers;
        const isQty = t.basis === 'qty';
        const list = t.list.map((x) => ({ min: isQty ? x.min : conv(x.min * 100), val: x.val })).sort((a, b) => a.min - b.min);
        const have = isQty ? t.qty : t.base;
        const next = list.find((x) => have < x.min);
        const reward = (x) => (t.unit === 'eur' ? `−${formatMoney(conv(x.val * 100))}` : `−${x.val} %`);
        if (next) {
          const gap = next.min - have;
          chips.push({ done: false, progress: have / next.min, text: isQty ? fill(S.barTierNextQty, { count: gap, reward: reward(next) }) : fill(S.barTierNext, { amount: formatMoney(gap), reward: reward(next) }) });
        } else {
          chips.push({ done: true, progress: 1, text: fill(S.barTierMax, { reward: reward(list[list.length - 1]) }) });
        }
      }
      if (data.gift) {
        const min = conv(data.gift.min * 100);
        const done = data.gift.base >= min;
        chips.push({ done, progress: done ? 1 : data.gift.base / min, text: done ? S.barGiftDone : fill(S.barGiftNext, { amount: formatMoney(min - data.gift.base) }) });
      }
      const holder = $('[data-promo-bar-chips]', bar);
      $$('[data-js-chip]', holder).forEach((el) => el.remove());
      holder.insertAdjacentHTML('afterbegin', chips.map((c) => `<span class="promo-chip${c.done ? ' is-done' : ''}" data-js-chip>${escapeHtml(c.text)}</span>`).join(''));
      // Fortschritt: das offene Ziel, das am nächsten dran ist
      const open = chips.filter((c) => !c.done).sort((a, b) => b.progress - a.progress)[0];
      const fillEl = $('[data-promo-bar-progress]', bar);
      if (fillEl) fillEl.style.width = `${Math.round(Math.min(1, open ? open.progress : 1) * 100)}%`;
      // Aufgeklappt bleibt aufgeklappt, auch nach einer Änderung im Warenkorb
      let expanded = false;
      try { expanded = sessionStorage.getItem('promo-bar-open') === '1'; } catch (_) { /* egal */ }
      box.classList.toggle('is-expanded', expanded);
      bar.setAttribute('aria-expanded', String(expanded));
    }
  };

  /* ---------- Warenkorb-Darstellung: Aktions-Leiste, Sticker-Knöpfe, Kassenbon-Fuß, Kartenstapel ---------- */
  const store = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { if (value) sessionStorage.setItem(key, value); else sessionStorage.removeItem(key); } catch (_) { /* egal */ } }
  };

  function setExtra(box, name) {
    $$('[data-extra]', box).forEach((btn) => btn.setAttribute('aria-expanded', String(btn.dataset.extra === name)));
    $$('[data-extra-panel]', box).forEach((panel) => { panel.hidden = panel.dataset.extraPanel !== name; });
  }

  function setReceipt(foot, open) {
    foot.classList.toggle('is-open', open);
    const btn = $('[data-foot-receipt-toggle]', foot);
    if (!btn) return;
    btn.setAttribute('aria-expanded', String(open));
    $('[data-label-open]', btn).hidden = open;
    $('[data-label-close]', btn).hidden = !open;
  }

  function setStack(stack, fanned) {
    stack.classList.toggle('is-fanned', fanned);
    const lines = $('.drawer__lines', stack);
    if (lines) lines.inert = !fanned;
    const openBtn = $('.cart-stack__open', stack);
    const closeBtn = $('.cart-stack__close', stack);
    if (openBtn) { openBtn.hidden = fanned; openBtn.setAttribute('aria-expanded', String(fanned)); }
    if (closeBtn) closeBtn.hidden = !fanned;
  }

  // Zustand nach jedem Neuzeichnen wiederherstellen
  function restoreCartUi(root = document) {
    $$('[data-cart-extras]', root).forEach((box) => setExtra(box, store.get('cart-extra')));
    $$('[data-foot-receipt]', root).forEach((foot) => setReceipt(foot, store.get('cart-receipt') === '1'));
    $$('[data-cart-stack]', root).forEach((stack) => setStack(stack, store.get('cart-stack') === '1'));
  }

  function initCartUi() {
    document.addEventListener('click', (e) => {
      const bar = e.target.closest('[data-promo-bar]');
      if (bar) {
        const box = bar.closest('.promo-cart');
        const open = !box.classList.contains('is-expanded');
        store.set('promo-bar-open', open ? '1' : '');
        $$('[data-promo-bar]').forEach((b) => {
          b.closest('.promo-cart').classList.toggle('is-expanded', open);
          b.setAttribute('aria-expanded', String(open));
        });
        return;
      }
      const extra = e.target.closest('[data-extra]');
      if (extra) {
        const box = extra.closest('[data-cart-extras]');
        const name = extra.getAttribute('aria-expanded') === 'true' ? '' : extra.dataset.extra;
        store.set('cart-extra', name);
        setExtra(box, name);
        if (name) $(`[data-extra-panel="${name}"] textarea, [data-extra-panel="${name}"] input`, box)?.focus();
        return;
      }
      const tab = e.target.closest('[data-foot-receipt-toggle]');
      if (tab) {
        const foot = tab.closest('[data-foot-receipt]');
        const open = !foot.classList.contains('is-open');
        store.set('cart-receipt', open ? '1' : '');
        setReceipt(foot, open);
        return;
      }
      const stackBtn = e.target.closest('[data-stack-toggle]');
      if (stackBtn) {
        const stack = stackBtn.closest('[data-cart-stack]');
        const fanned = !stack.classList.contains('is-fanned');
        store.set('cart-stack', fanned ? '1' : '');
        setStack(stack, fanned);
        (fanned ? $('.cart-stack__close', stack) : $('.cart-stack__open', stack))?.focus();
      }
    });

    // Kompakte Zeilen: auf dem Handy nach links wischen zum Entfernen
    let swipe = null;
    document.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'touch') return;
      const line = e.target.closest('.cart--compact .line');
      if (!line || e.target.closest('button, input, a.line__remove')) return;
      swipe = { line, x: e.clientX, y: e.clientY, dx: 0, active: false };
    }, { passive: true });
    document.addEventListener('pointermove', (e) => {
      if (!swipe) return;
      const dx = e.clientX - swipe.x;
      const dy = e.clientY - swipe.y;
      if (!swipe.active && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) swipe.active = true;
      if (!swipe.active) return;
      swipe.dx = Math.min(0, dx);
      swipe.line.classList.add('is-swiping');
      swipe.line.style.setProperty('--swipe', `${swipe.dx}px`);
    }, { passive: true });
    const end = () => {
      if (!swipe) return;
      const { line, dx, active } = swipe;
      swipe = null;
      if (!active) return;
      line.classList.remove('is-swiping');
      if (dx < -90) {
        line.style.setProperty('--swipe', '-100%');
        $('[data-line-change][data-qty="0"]', line)?.click();
      } else {
        line.style.removeProperty('--swipe');
      }
    };
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);

    restoreCartUi();
  }

  /* ---------- Rabattcode-Feld im Warenkorb ---------- */
  async function applyCodes(codes) {
    const data = await Cart.request(`${theme.routes.cartUpdate}.js`, { discount: codes.join(',') });
    Cart.render(data.sections);
    return data;
  }

  function initPromoCode() {
    const submit = async (box) => {
      const input = $('[data-promo-code-input]', box);
      const code = input.value.trim();
      if (!code) return;
      let current = [];
      try { current = JSON.parse(box.dataset.codes || '[]'); } catch (_) { current = []; }
      const msgTemplate = $('[data-promo-code-msg]', box)?.dataset.invalid || '';
      box.classList.add('is-loading');
      try {
        const data = await applyCodes([...current.filter((c) => c.toLowerCase() !== code.toLowerCase()), code]);
        const found = (data.discount_codes || []).find((c) => c.code.toLowerCase() === code.toLowerCase());
        if (!found || !found.applicable) {
          $$('[data-promo-code-msg]').forEach((m) => { m.textContent = fill(msgTemplate, { code }); });
        }
      } catch (err) {
        $$('[data-promo-code-msg]').forEach((m) => { m.textContent = err.message; });
      } finally {
        box.classList.remove('is-loading');
      }
    };

    document.addEventListener('click', async (e) => {
      const apply = e.target.closest('[data-promo-code-apply]');
      if (apply) submit(apply.closest('[data-promo-code]'));
      const remove = e.target.closest('[data-code-remove]');
      if (remove) {
        const box = remove.closest('[data-promo-code]');
        let current = [];
        try { current = JSON.parse(box.dataset.codes || '[]'); } catch (_) { current = []; }
        box.classList.add('is-loading');
        applyCodes(current.filter((c) => c !== remove.dataset.codeRemove)).catch((err) => window.alert(err.message));
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || !e.target.matches('[data-promo-code-input]')) return;
      e.preventDefault();
      submit(e.target.closest('[data-promo-code]'));
    });
  }

  /* ---------- Aktionen: Schwellen in die Kundenwährung umrechnen ---------- */
  function initPromos(root = document) {
    Promo.render(root);
    if (!Currency.isForeign()) return;

    // Stufen-Liste (Produktseite): auf ganze Einheiten aufrunden, damit die Angabe sicher reicht
    $$('[data-base-amount]', root).forEach((el) => {
      const cents = Math.ceil(Currency.convert(el.dataset.baseAmount) / 100) * 100;
      el.textContent = formatMoney(cents, { whole: true });
    });
  }

  /* ---------- Mut-Zettel: speichert den Satz als Warenkorb-Attribut ---------- */
  function initMut(root = document) {
    $$('[data-mut]', root).forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const input = $('[data-mut-input]', box);
      const count = $('[data-mut-count]', box);
      const status = $('[data-mut-status]', box);
      let timer;

      const save = () => fetch(`${theme.routes.cartUpdate}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Mut-Zettel': input.value.trim() } })
      }).then((res) => {
        if (res.ok && status) status.textContent = theme.strings.mutSaved;
      }).catch(() => {});

      input.addEventListener('input', () => {
        if (count) count.textContent = input.value.length;
        if (status) status.textContent = '';
        clearTimeout(timer);
        timer = setTimeout(save, 700);
      });
      $$('[data-mut-suggest]', box).forEach((chip) => chip.addEventListener('click', () => {
        input.value = chip.textContent.trim().slice(0, Number(input.maxLength) || 160);
        input.dispatchEvent(new Event('input'));
        input.focus();
      }));
    });
  }

  /* ---------- Der Skull schaut dir hinterher: der Kopf dreht sich leicht zum Mauszeiger ---------- */
  function initSkullWatch() {
    if (!document.documentElement.classList.contains('skull-watch') || reducedMotion.matches) return;
    let px = window.innerWidth / 2;
    let py = window.innerHeight / 3;
    let raf = 0;

    const update = () => {
      raf = 0;
      $$('.skull--watch').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (!r.width || r.bottom < 0 || r.top > window.innerHeight) return;
        const dx = px - (r.left + r.width / 2);
        const dy = py - (r.top + r.height / 2);
        const dist = Math.hypot(dx, dy) || 1;
        const pull = Math.min(1, dist / 320);
        const angle = Math.max(-14, Math.min(14, (dy / dist) * 14 * pull * (dx >= 0 ? 1 : -1)));
        el.style.setProperty('--look', `${angle.toFixed(1)}deg`);
        el.style.setProperty('--look-x', `${((dx / dist) * pull * 3).toFixed(1)}px`);
        el.style.setProperty('--look-y', `${((dy / dist) * pull * 2).toFixed(1)}px`);
      });
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(update); };

    window.addEventListener('pointermove', (e) => { px = e.clientX; py = e.clientY; schedule(); }, { passive: true });
    window.addEventListener('pointerdown', (e) => { px = e.clientX; py = e.clientY; schedule(); }, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    schedule();
  }

  /* ---------- Zeitsteuerung (Theme-Einstellungen → Zeit: …), immer nach deutscher Zeit ---------- */
  const TM = {
    cfg: {},
    offset: 0,
    fmt: null,

    /* Uhr: Europe/Berlin, im Theme-Editor optional die Vorschau-Uhr */
    berlinParts(ms) {
      if (!this.fmt) {
        this.fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', hourCycle: 'h23', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      }
      const p = {};
      this.fmt.formatToParts(new Date(ms)).forEach((x) => { p[x.type] = x.value; });
      return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second, dow: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday) };
    },
    /* Berliner Ortszeit → Zeitstempel (Sommer-/Winterzeit wird berücksichtigt) */
    at(y, m, d, h = 0, mi = 0) {
      const guess = Date.UTC(y, m - 1, d, h, mi);
      const p = this.berlinParts(guess);
      const asUtc = Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi);
      return guess - (asUtc - guess);
    },
    now() { return Date.now() + this.offset; },
    parts(ms = this.now()) { return this.berlinParts(ms); },
    /* „TT.MM.JJJJ HH:MM“, „TT.MM.JJJJ“ oder „TT.MM.“ (ohne Jahr = jedes Jahr) */
    parse(str, end = false, year) {
      const m = String(str || '').match(/(\d{1,2})\s*\.\s*(\d{1,2})\s*\.?\s*(\d{2,4})?(?:[\s,]+(\d{1,2})(?::(\d{2}))?)?/);
      if (!m) return null;
      let y = m[3] ? Number(m[3]) : (year || this.parts().y);
      if (y < 100) y += 2000;
      const hasTime = m[4] !== undefined;
      const h = hasTime ? Number(m[4]) : (end ? 23 : 0);
      const mi = hasTime ? Number(m[5] || 0) : (end ? 59 : 0);
      return { ms: this.at(y, Number(m[2]), Number(m[1]), h, mi) + (end && !hasTime ? 59999 : 0), yearly: !m[3] };
    },
    win(from, to) {
      if (!from && !to) return true;
      const n = this.now();
      const f = from ? this.parse(from) : null;
      const t = to ? this.parse(to, true) : null;
      if (f && t && f.yearly && t.yearly && t.ms < f.ms) return n >= f.ms || n <= t.ms;
      return (!f || n >= f.ms) && (!t || n <= t.ms);
    },
    left(ms) {
      const t = theme.strings.tm;
      const s = Math.max(0, Math.floor(ms / 1000));
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const mi = Math.floor((s % 3600) / 60);
      const pad = (v) => String(v).padStart(2, '0');
      if (d >= 1) return `${d} ${t.d} ${h} ${t.h}`;
      return `${pad(h)}:${pad(mi)}:${pad(s % 60)}`;
    },
    dateText(ms) {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'de', { timeZone: 'Europe/Berlin', day: 'numeric', month: 'long' }).format(new Date(ms));
    },

    init() {
      const el = document.getElementById('tm-config');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (_) { return; }
      if (this.cfg.preview) {
        const p = this.parse(this.cfg.preview);
        if (p) this.offset = p.ms - Date.now();
      }
      window.SoftRiotTM = this;
      this.occasion = this.findOccasion();
      this.applyWindows();
      this.renderLine();
      this.renderAnn();
      this.renderPromoCount();
      this.renderCart();
      this.renderFooter();
      this.initDayNight();
      this.initDrops();
      this.initRelease();
      this.toasts();
      this.overview();
      document.addEventListener('cart:changed', () => { this.renderCart(); this.renderPromoCount(); });
      document.addEventListener('shopify:section:load', () => { this.applyWindows(); this.renderPromoCount(); this.renderCart(); });
      this.tick();
      setInterval(() => this.tick(), 1000);
    },
    tick() {
      const n = this.now();
      $$('[data-tm-countdown]').forEach((c) => {
        const end = Number(c.dataset.tmCountdown) || (this.parse(c.dataset.tmCountdown)?.ms ?? 0);
        c.textContent = this.left(end - n);
      });
      $$('[data-tm-promo-count]:not([hidden])').forEach((el) => this.countTick(el, n));
      this.updateDrops(n);
      this.checkRelease(n);
      // Alles andere reicht minütlich
      const minute = Math.floor(n / 60000);
      if (minute !== this.lastMinute) {
        if (this.lastMinute !== undefined) { this.applyWindows(); this.renderLine(); this.renderAnn(); this.renderPromoCount(); }
        this.lastMinute = minute;
        const p = this.parts(n);
        document.documentElement.classList.toggle('tm-night', Boolean(this.cfg.quiet) && (p.h >= 23 || p.h < 6));
      }
    },

    /* Elemente mit Zeitfenster: data-tm-from / data-tm-to (inkl. Tagesende) / data-tm-until (exakt) */
    applyWindows(root = document) {
      const n = this.now();
      $$('[data-tm-from], [data-tm-to], [data-tm-until]', root).forEach((el) => {
        if (el.matches('[data-popup]')) return;
        let on = this.win(el.dataset.tmFrom, el.dataset.tmTo);
        if (el.dataset.tmUntil) { const u = this.parse(el.dataset.tmUntil); if (u && n >= u.ms) on = false; }
        if (el.classList.contains('tm-sec')) {
          el.dataset.state = on ? 'on' : 'off';
          const sec = el.closest('.shopify-section');
          if (sec) {
            sec.classList.toggle('tm-editor-off', !on && Boolean(this.cfg.editor));
            sec.dataset.tmNote = theme.strings.tm.hidden_note;
          }
          return;
        }
        el.hidden = !on;
        // Laufband: das Trennzeichen nach einer ausgeblendeten Nachricht mit ausblenden
        const sep = el.classList.contains('ann__item') && el.nextElementSibling?.classList.contains('ann__sep') ? el.nextElementSibling : null;
        if (sep) sep.hidden = !on;
      });
      $$('[data-tm-hide-at]', root).forEach((el) => { el.hidden = n >= Number(el.dataset.tmHideAt); });
      $$('[data-tm-live-from]', root).forEach((el) => { el.hidden = !(n >= Number(el.dataset.tmLiveFrom) && n < Number(el.dataset.tmLiveTo)); });
    },
    /* Pop-ups: Zeitraum, Wochentage, Uhrzeit */
    popupOk(popup) {
      const d = popup.dataset;
      if (!this.win(d.tmFrom, d.tmTo)) return false;
      const p = this.parts();
      if (d.tmDays === 'weekend' && p.dow !== 0 && p.dow !== 6) return false;
      if (d.tmDays === 'weekdays' && (p.dow === 0 || p.dow === 6)) return false;
      const m = String(d.tmHours || '').match(/(\d{1,2})\s*-\s*(\d{1,2})/);
      if (m) {
        const a = Number(m[1]);
        const b = Number(m[2]);
        const inside = a <= b ? p.h >= a && p.h < b : p.h >= a || p.h < b;
        if (!inside) return false;
      }
      return true;
    },
    eggOk() {
      const e = this.cfg.egg || {};
      if (e.when === 'fri13') { const p = this.parts(); return p.dow === 5 && p.d === 13; }
      if (e.when === 'dates') return this.win(e.from, e.to);
      return true;
    },
    vacation() {
      const v = this.cfg.vac;
      if (!v || !this.win(v.from, v.to)) return null;
      const end = v.to ? this.parse(v.to, true).ms : this.now();
      return { ...v, endMs: end, back: this.dateText(end + 60000) };
    },

    /* Anlässe: bewegliche Feste werden ausgerechnet */
    easter(y) {
      const a = y % 19; const b = Math.floor(y / 100); const c = y % 100; const d = Math.floor(b / 4); const e = b % 4;
      const f = Math.floor((b + 8) / 25); const g = Math.floor((b - f + 1) / 3); const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4); const k = c % 4; const l = (32 + 2 * e + 2 * i - h - k) % 7; const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31); const day = ((h + l - 7 * m + 114) % 31) + 1;
      return [month, day];
    },
    findOccasion() {
      const occ = this.cfg.occ || {};
      const p = this.parts();
      const y = p.y;
      const today = Date.UTC(y, p.m - 1, p.d);
      const day = (m, d) => Date.UTC(y, m - 1, d);
      const inRange = (a, b) => today >= a && today <= b;
      const nthDow = (m, dow, n) => { const first = new Date(Date.UTC(y, m - 1, 1)).getUTCDay(); return 1 + ((dow - first + 7) % 7) + (n - 1) * 7; };
      const [em, ed] = this.easter(y);
      const easter = day(em, ed);
      const mother = day(5, nthDow(5, 0, 2));
      const thanks = day(11, nthDow(11, 4, 4));
      const rules = [
        ['nikolaus', inRange(day(12, 5), day(12, 6))],
        ['silvester', inRange(day(12, 27), day(12, 31))],
        ['blackfriday', inRange(thanks + 864e5, thanks + 4 * 864e5)],
        ['halloween', inRange(day(10, 24), day(10, 31))],
        ['valentin', inRange(day(2, 1), day(2, 14))],
        ['muttertag', inRange(mother - 7 * 864e5, mother)],
        ['ostern', inRange(easter - 7 * 864e5, easter + 864e5)],
        ['weihnachten', inRange(day(12, 1), day(12, 24))]
      ];
      const hit = rules.find(([k, on]) => on && occ[k] !== undefined);
      return hit ? { key: hit[0], text: occ[hit[0]] } : null;
    },

    /* Zeile unter dem Header: Urlaub > Geburtstag > Anlass > Skull-Sonntag > Begrüßung (Startseite) */
    lineText() {
      const c = this.cfg;
      const p = this.parts();
      const vac = this.vacation();
      if (vac) return { text: String(vac.text || '').replace('[datum]', vac.back), kind: 'vac' };
      if (c.bday) { const b = this.parse(c.bday.date); if (b) { const bp = this.parts(b.ms); if (bp.d === p.d && bp.m === p.m) return { text: c.bday.text, kind: 'bday' }; } }
      if (this.occasion?.text) return { text: this.occasion.text, kind: 'occ' };
      if (c.sunday && p.dow === 0) return { text: c.sunday, kind: 'sunday' };
      if (c.greet && document.body.classList.contains('template-index')) {
        const g = c.greet;
        const text = p.h >= 5 && p.h < 11 ? g.morning : p.h >= 11 && p.h < 17 ? g.day : p.h >= 17 && p.h < 22 ? g.evening : g.night;
        return { text, kind: 'greet' };
      }
      return null;
    },
    renderLine() {
      const el = $('[data-tm-line]');
      if (!el) return;
      const line = this.lineText();
      el.hidden = !line?.text;
      el.textContent = line?.text || '';
      el.dataset.kind = line?.kind || '';
      el.closest('[data-header]')?.classList.toggle('has-tm-line', Boolean(line?.text));
      if (line?.kind === 'bday') this.confetti();
    },
    confetti() {
      const key = `softriot:bday:${this.parts().y}`;
      try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (_) { /* egal */ }
      if (reducedMotion.matches) return;
      const box = document.createElement('div');
      box.className = 'tm-confetti';
      box.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 40; i++) {
        const s = document.createElement('i');
        s.style.cssText = `--x:${Math.random() * 100}vw;--d:${Math.random() * 0.8}s;--r:${Math.random() * 720 - 360}deg;--c:${['var(--c-accent)', '#ffc928', '#3ec1d3', '#7c4dff'][i % 4]}`;
        box.append(s);
      }
      document.body.append(box);
      setTimeout(() => box.remove(), 4000);
    },
    /* Laufband: Anlass oder Skull-Sonntag vorne, dazu der Aktions-Countdown */
    renderAnn() {
      const slots = $$('[data-tm-ann]');
      if (!slots.length) return;
      const line = this.lineText();
      const show = line && (line.kind === 'occ' || line.kind === 'sunday' || line.kind === 'vac');
      slots.forEach((s) => { s.hidden = !show; s.textContent = show ? line.text : ''; });
    },
    /* Countdown für die Aktion, die als nächstes endet (Looks: plain, board, fuse, candle, stamp, note) */
    renderPromoCount() {
      const c = this.cfg.count || {};
      const n = this.now();
      let end = null;
      let start = null;
      (this.cfg.promos || []).forEach((pr) => {
        if (!pr.to || !this.win(pr.from, pr.to)) return;
        const e = this.parse(pr.to, true).ms;
        if (e <= n || (end && e >= end)) return;
        end = e;
        const f = pr.from ? this.parse(pr.from) : null;
        start = f && f.ms < e ? f.ms : null;
      });
      if (end && !start) start = end - 7 * 86400000;
      const text = this.countText(c, end, n);
      const look = c.look || 'plain';
      const stage = end ? this.countStage(c, end, n) : '';
      const key = `${end}|${stage}|${text}`;
      $$('[data-tm-promo-count]').forEach((el) => {
        const on = end && c[el.dataset.tmPromoCount];
        el.hidden = !on;
        if (!on || el.dataset.key === key) return;
        el.dataset.key = key;
        el.className = `tm-count tm-count--${look}${stage === 'last' ? ' is-last' : ''}`;
        el.innerHTML = this.countHtml(look, text, end, start, n);
        this.countTick(el, n);
      });
      if (c.bar && end) {
        $$('[data-tm-ann]').forEach((s) => {
          if (!s.hidden) return;
          s.hidden = false;
          s.innerHTML = this.countLine(text, `<b data-tm-countdown="${end}">${this.left(end - n)}</b>`, end);
        });
      }
    },
    countStage(c, end, n) {
      if (!c.urgent) return 'normal';
      const r = end - n;
      if (r <= 3600000) return 'last';
      const a = this.parts(end);
      const b = this.parts(n);
      if (a.y === b.y && a.m === b.m && a.d === b.d) return 'today';
      return r > 2 * 86400000 ? 'far' : 'normal';
    },
    countText(c, end, n) {
      const st = end ? this.countStage(c, end, n) : 'normal';
      return (c.urgent && c.urgent[st]) || c.text || '';
    },
    /* Platzhalter [zeit] (HTML-Baustein), [datum] und [uhr] ersetzen */
    countLine(text, timeHtml, end) {
      const clock = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' }).format(new Date(end));
      return escapeHtml(text).replace('[datum]', escapeHtml(this.dateText(end))).replace('[uhr]', clock).replace('[zeit]', timeHtml);
    },
    countHtml(look, text, end, start, n) {
      const t = theme.strings.tm;
      const left = `<b data-tm-countdown="${end}">${this.left(end - n)}</b>`;
      const span = ` data-tmc-start="${start}" data-tmc-end="${end}"`;
      if (look === 'board') {
        const line = this.countLine(text, '\u0000', end).split('\u0000');
        return `<span class="tmc-board"><span class="tmc-board__label">${line[0].trim()}</span><span class="tmc-board__tiles" data-tmc-board="${end}" role="timer" aria-label="${escapeHtml(this.left(end - n))}"></span>${line[1] ? `<span class="tmc-board__label">${line[1].trim()}</span>` : ''}</span>`;
      }
      if (look === 'fuse') {
        return `<span class="tmc-fuse"${span}><span class="tmc-fuse__text">${this.countLine(text, left, end)}</span><span class="tmc-fuse__rope" aria-hidden="true"><i class="tmc-fuse__burnt"></i><i class="tmc-fuse__spark"></i></span></span>`;
      }
      if (look === 'candle') {
        return `<span class="tmc-candle"${span}><span class="tmc-candle__stick" aria-hidden="true"><i class="tmc-candle__flame"></i><i class="tmc-candle__wax"><span class="skull"></span></i><i class="tmc-candle__plate"></i></span><span class="tmc-candle__text">${this.countLine(text, left, end)}</span></span>`;
      }
      if (look === 'stamp') {
        const when = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(end)).replace(',', ' ·');
        return `<span class="tmc-stamp"><span class="tmc-stamp__seal"><small>${escapeHtml(t.valid_until || 'Gültig bis')}</small><strong>${when}</strong></span><span class="tmc-stamp__text">${this.countLine(text, left, end)}</span></span>`;
      }
      if (look === 'note') {
        return `<span class="tmc-note"><span class="tmc-note__tape" aria-hidden="true"></span><span class="scribble">${this.countLine(text, left, end)}</span></span>`;
      }
      return `<span>${this.countLine(text, left, end)}</span>`;
    },
    /* Sekündlich: Klappziffern und Anteil der Restzeit (Lunte, Kerze) */
    countTick(root, n) {
      $$('[data-tmc-board]', root).forEach((b) => {
        const s = Math.max(0, Math.floor((Number(b.dataset.tmcBoard) - n) / 1000));
        const pad = (v) => String(v).padStart(2, '0');
        const d = Math.floor(s / 86400);
        const parts = d >= 1 ? [pad(d), pad(Math.floor((s % 86400) / 3600)), pad(Math.floor((s % 3600) / 60))] : [pad(Math.floor(s / 3600)), pad(Math.floor((s % 3600) / 60)), pad(s % 60)];
        const t = theme.strings.tm;
        const units = d >= 1 ? [t.d, t.h, t.m] : [t.h, t.m, t.s || 's'];
        const str = parts.join('');
        if (b.children.length !== 3) {
          b.innerHTML = parts.map((p, i) => `<span class="tmc-board__grp">${'<i class="tmc-board__tile"><b></b></i>'.repeat(2)}<small>${units[i]}</small></span>`).join('');
        }
        const tiles = $$('.tmc-board__tile', b);
        tiles.forEach((tile, i) => {
          const v = str[i];
          const cur = tile.firstChild;
          if (cur.textContent === v) return;
          cur.textContent = v;
          tile.classList.remove('is-flip');
          void tile.offsetWidth;
          tile.classList.add('is-flip');
        });
        $$('.tmc-board__grp small', b).forEach((u, i) => { u.textContent = units[i]; });
        b.setAttribute('aria-label', this.left(Number(b.dataset.tmcBoard) - n));
      });
      $$('[data-tmc-end]', root).forEach((x) => {
        const e = Number(x.dataset.tmcEnd);
        const st = Number(x.dataset.tmcStart);
        const f = Math.min(1, Math.max(0, (e - n) / Math.max(1, e - st)));
        x.style.setProperty('--left', f.toFixed(4));
      });
    },

    /* Warenkorb: Urlaub, „vor Weihnachten“, Geschenk-Hinweis, Geschenkverpackung */
    renderCart() {
      const c = this.cfg;
      const t = theme.strings.tm;
      $$('[data-tm-cart]').forEach((box) => {
        const notes = [];
        const vac = this.vacation();
        if (vac) notes.push(String(vac.text || '').replace('[datum]', vac.back));
        if (c.xmas) {
          const p = this.parts();
          const last = this.parse(c.xmas.last, true);
          const from = this.at(p.y, 11, 15);
          const eve = this.at(p.y, 12, 24, 23, 59);
          const n = this.now();
          if (last && n >= from && n <= eve) notes.push(n <= last.ms ? String(c.xmas.before).replace('[datum]', this.dateText(last.ms)) : c.xmas.after);
        }
        if (c.occCart && this.occasion && ['valentin', 'muttertag', 'nikolaus', 'weihnachten'].includes(this.occasion.key)) notes.push(c.occCart);
        const gift = c.gift && this.win(c.gift.from, c.gift.to);
        box.hidden = !notes.length && !gift;
        box.innerHTML = notes.map((x) => `<p class="tm-cart__note">${escapeHtml(x)}</p>`).join('')
          + (gift ? `<label class="tm-cart__gift"><input type="checkbox" data-tm-gift${box.dataset.gift ? ' checked' : ''}> <span>${escapeHtml(c.gift.label || t.gift_label)}</span></label>` : '');
        $('[data-tm-gift]', box)?.addEventListener('change', (e) => {
          const val = e.target.checked ? 'Ja' : '';
          box.dataset.gift = val;
          fetch(`${theme.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { Geschenkverpackung: val } }) }).catch(() => {});
        });
      });
    },

    /* Footer: Spruch des Monats, Tages-/Jahreszeit-Symbol bei „Gerade auf Usedom“ */
    renderFooter() {
      const p = this.parts();
      const month = this.cfg.month;
      $$('[data-tm-month]').forEach((el) => {
        const line = month ? String(month[p.m - 1] || '').trim() : '';
        el.hidden = !line;
        el.textContent = line;
      });
      $$('[data-tm-mood]').forEach((el) => {
        const sun = this.sun();
        const n = this.now();
        const night = n < sun.rise || n > sun.set;
        const season = p.m === 12 || p.m <= 2 ? '❄️' : p.m <= 5 ? '🌸' : p.m <= 8 ? '☀️' : '🍂';
        let mood = el.querySelector('.tm-mood');
        if (!mood) { mood = document.createElement('span'); mood.className = 'tm-mood'; el.append(mood); }
        mood.textContent = ` ${night ? '🌙' : season}`;
      });
    },

    /* Sonnenauf- und -untergang auf Usedom (Näherung, auf wenige Minuten genau) */
    sun() {
      const p = this.parts();
      const lat = 53.95 * Math.PI / 180;
      const lon = 14.15;
      const n = Math.floor((Date.UTC(p.y, p.m - 1, p.d) - Date.UTC(p.y, 0, 0)) / 864e5);
      const decl = 23.44 * Math.PI / 180 * Math.sin((2 * Math.PI * (284 + n)) / 365);
      const ha = Math.acos(Math.min(1, Math.max(-1, (Math.sin(-0.833 * Math.PI / 180) - Math.sin(lat) * Math.sin(decl)) / (Math.cos(lat) * Math.cos(decl))))) * 180 / Math.PI;
      const noon = 12 - lon / 15;
      const base = Date.UTC(p.y, p.m - 1, p.d);
      return { rise: base + (noon - ha / 15) * 36e5, set: base + (noon + ha / 15) * 36e5 };
    },
    initDayNight() {
      const heroes = $$('[data-tm-daynight]');
      if (!heroes.length) return;
      const update = () => {
        const s = this.sun();
        const n = this.now();
        heroes.forEach((h) => h.classList.toggle('is-night', n < s.rise || n > s.set));
      };
      update();
      setInterval(update, 60000);
    },

    /* Drop-Countdown mit Warteraum */
    initDrops() {
      $$('[data-tm-drop]').forEach((sec) => {
        const p = this.parse(sec.dataset.tmDrop);
        sec.dataset.dropMs = p ? p.ms : 0;
        $('[data-drop-room-close]', sec)?.addEventListener('click', () => {
          sec.dataset.roomClosed = '1';
          $('[data-drop-room]', sec).hidden = true;
        });
      });
    },
    updateDrops(n) {
      $$('[data-tm-drop]').forEach((sec) => {
        const end = Number(sec.dataset.dropMs);
        if (!end) return;
        const left = end - n;
        const live = left <= 0;
        const before = $('[data-drop-before]', sec);
        const after = $('[data-drop-after]', sec);
        if (before) before.hidden = live;
        if (after) after.hidden = !live;
        if (live && sec.dataset.after === 'hide' && !this.cfg.editor) sec.closest('.shopify-section').hidden = true;
        if (!live) {
          const s = Math.floor(left / 1000);
          const set = (u, v) => { const b = $(`[data-u="${u}"]`, sec); if (b) b.textContent = String(v).padStart(2, '0'); };
          set('d', Math.floor(s / 86400)); set('h', Math.floor((s % 86400) / 3600)); set('m', Math.floor((s % 3600) / 60)); set('s', s % 60);
        }
        const room = $('[data-drop-room]', sec);
        if (!room || this.cfg.editor) return;
        const mins = Number(sec.dataset.room) || 0;
        if (!live && left <= mins * 60000 && !sec.dataset.roomClosed) {
          room.hidden = false;
          $('[data-drop-room-count]', room).textContent = this.left(left).replace(/^00:/, '');
        } else if (live && !room.hidden && !room.classList.contains('is-open')) {
          // Bei 0: Figur wacht auf, der Vorhang geht auf, dann ist der Shop frei
          room.classList.add('is-open');
          setTimeout(() => { room.hidden = true; }, 2600);
        }
      });
    },

    /* Erscheinungsdatum: Kaufen erst ab dem Zeitpunkt */
    initRelease() {
      this.release = $('[data-tm-release]');
    },
    checkRelease(n) {
      const r = this.release;
      if (!r || n < Number(r.dataset.tmRelease)) return;
      r.remove();
      this.release = null;
      document.dispatchEvent(new CustomEvent('tm:released'));
    },

    /* Kleine Hinweise: Willkommen zurück, Warenkorb wartet, Merkzettel wird knapp */
    toast(text, action) {
      if (!text || $('.tm-toast')) return;
      const el = document.createElement('div');
      el.className = 'tm-toast';
      el.setAttribute('role', 'status');
      el.innerHTML = `<p>${escapeHtml(text)}</p>${action ? `<button type="button" class="btn btn--signal" data-tm-toast-go>${escapeHtml(action.label)}</button>` : ''}<button type="button" class="tm-toast__close" aria-label="${escapeHtml(theme.strings.close || '×')}" data-tm-toast-close>×</button>`;
      document.body.append(el);
      $('[data-tm-toast-go]', el)?.addEventListener('click', () => { action.run(); el.remove(); });
      $('[data-tm-toast-close]', el).addEventListener('click', () => el.remove());
      setTimeout(() => el.classList.add('is-in'), 50);
      setTimeout(() => el.remove(), 12000);
    },
    async toasts() {
      if (this.cfg.editor) return;
      const c = this.cfg;
      const t = theme.strings.tm;
      const now = Date.now();
      let last = 0;
      try { last = Number(localStorage.getItem('softriot:last-visit')) || 0; localStorage.setItem('softriot:last-visit', String(now)); } catch (_) { /* egal */ }
      // Merkt sich, seit wann etwas im Warenkorb liegt
      document.addEventListener('cart:added', () => { try { localStorage.setItem('softriot:cart-since', String(Date.now())); } catch (_) { /* egal */ } });
      const count = Number($('[data-cart-count]')?.textContent || 0);
      let since = 0;
      try { since = Number(localStorage.getItem('softriot:cart-since')) || 0; } catch (_) { /* egal */ }
      if (c.cartRemind && count > 0 && since && now - since > 864e5 && last && now - last > 30 * 60000) {
        try { localStorage.setItem('softriot:cart-since', String(now)); } catch (_) { /* egal */ }
        setTimeout(() => this.toast(c.cartRemind, { label: t.to_cart, run: () => Cart.open() }), 2500);
        return;
      }
      if (c.welcome && last && now - last > c.welcome.days * 864e5) {
        const recent = $('.hx-recent:not([hidden])');
        setTimeout(() => this.toast(c.welcome.text, recent ? { label: t.show, run: () => recent.click() } : null), 2500);
        return;
      }
      if (c.wishLow) {
        let wish = [];
        let checked = 0;
        try { wish = JSON.parse(localStorage.getItem('softriot:wish') || '[]'); checked = Number(localStorage.getItem('softriot:wish-checked')) || 0; } catch (_) { /* egal */ }
        if (!wish.length || now - checked < 864e5) return;
        try { localStorage.setItem('softriot:wish-checked', String(now)); } catch (_) { /* egal */ }
        for (const w of wish.slice(0, 6)) {
          try {
            const prod = await fetch(`${theme.routes.root.replace(/\/$/, '')}/products/${w.handle}.js`).then((r) => r.json());
            const avail = prod.variants.filter((v) => v.available).length;
            if (prod.variants.length > 2 && avail > 0 && avail <= 2) {
              this.toast(c.wishLow.replace('[titel]', prod.title), { label: t.show, run: () => { window.location.href = w.url; } });
              return;
            }
          } catch (_) { /* nächstes Produkt */ }
        }
      }
    },

    /* Theme-Editor: Zeitplan als Zeitstrahl und Warnung, wenn etwas bald endet */
    overview() {
      if (!this.cfg.overview) return;
      const t = theme.strings.tm;
      const items = [...(this.cfg.schedule || [])];
      $$('.tm-sec').forEach((s) => items.push({ label: `Abschnitt: ${s.dataset.tmLabel || ''}`, from: s.dataset.tmFrom, to: s.dataset.tmTo }));
      $$('[data-tm-drop]').forEach((s) => items.push({ label: 'Drop', from: null, to: s.dataset.tmDrop }));
      const n = this.now();
      const rows = items.map((it) => {
        const f = it.from ? this.parse(it.from) : null;
        const e = it.to ? this.parse(it.to, true) : null;
        const on = this.win(it.from, it.to);
        let state = on ? t.now_on : (f && f.ms > n ? t.upcoming : t.past);
        if (on && e && e.ms - n < 864e5) state = `⚠︎ ${t.ends_soon}`;
        return { ...it, f, e, on, state, warn: on && e && e.ms - n < 864e5 };
      }).sort((a, b) => (a.f?.ms || 0) - (b.f?.ms || 0));
      const fmt = (p) => (p ? new Intl.DateTimeFormat('de', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: p.yearly ? undefined : '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(p.ms)) : '…');
      const warn = rows.some((r) => r.warn);
      const box = document.createElement('div');
      box.className = `tm-overview${warn ? ' has-warn' : ''}`;
      box.innerHTML = `<button type="button" class="tm-overview__btn" data-tm-ov>${warn ? '⚠︎ ' : ''}${escapeHtml(t.schedule)}${this.cfg.preview ? ` · ${escapeHtml(t.preview)} ${escapeHtml(this.cfg.preview)}` : ''}</button>`
        + `<div class="tm-overview__panel" hidden>${rows.length ? `<ol>${rows.map((r) => `<li class="${r.on ? 'is-on' : ''}${r.warn ? ' is-warn' : ''}"><b>${escapeHtml(r.label)}</b><span>${fmt(r.f)} – ${fmt(r.e)}</span><em>${escapeHtml(r.state)}</em></li>`).join('')}</ol>` : '<p>–</p>'}</div>`;
      document.body.append(box);
      $('[data-tm-ov]', box).addEventListener('click', () => { const p = $('.tm-overview__panel', box); p.hidden = !p.hidden; });
    }
  };

  /* ---------- Easter Egg: Ort und Auslöser kommen aus den Theme-Einstellungen ---------- */
  function initSkullEgg() {
    const egg = theme.skullEgg;
    if (!egg || !TM.eggOk()) return;

    const reveal = () => {
      if ($('.egg-toast')) return;
      const toast = document.createElement('div');
      toast.className = 'egg-toast';
      toast.setAttribute('role', 'status');
      const text = document.createElement('p');
      text.textContent = egg.text;
      const code = document.createElement('code');
      code.textContent = egg.code;
      const copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'btn btn--signal egg-toast__copy';
      copy.textContent = theme.strings.copy;
      copy.addEventListener('click', () => navigator.clipboard?.writeText(egg.code).then(() => { copy.textContent = theme.strings.copied; }));
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'egg-toast__close';
      close.setAttribute('aria-label', theme.strings.close);
      close.textContent = '×';
      close.addEventListener('click', () => toast.remove());
      toast.append(text, code, copy, close);
      document.body.append(toast);
      $$('.to-top__skull, .mood__skull').forEach((s) => s.classList.add('is-party'));
    };

    /* Wort tippen: irgendwo auf der Seite, nicht in Eingabefeldern */
    if (egg.trigger === 'word') {
      const word = String(egg.word || '').trim().toLowerCase();
      if (!word) return;
      let typed = '';
      document.addEventListener('keydown', (e) => {
        if (e.ctrlKey || e.metaKey || e.altKey || e.key.length !== 1) return;
        if (e.target.closest?.('input, textarea, select, [contenteditable]')) return;
        typed = (typed + e.key.toLowerCase()).slice(-word.length);
        if (typed === word) { typed = ''; reveal(); }
      });
      return;
    }

    const selector = egg.targets;
    if (!selector) return;
    const isLink = (el) => el.closest('a, button');
    /* Skull-Dame als Bild-Platzhalter in Kacheln zählt nicht */
    const skip = (el) => el.matches('.figure') && Boolean(isLink(el));
    let replaying = false;
    let swallowClick = false;

    /* Antippen: Links und Buttons warten kurz, damit man mehrmals tippen kann */
    let taps = 0;
    let last = 0;
    let follow;
    document.addEventListener('click', (e) => {
      if (replaying) return;
      const target = e.target.closest?.(selector);
      if (!target || skip(target)) return;
      const link = isLink(target);
      if (swallowClick) {
        swallowClick = false;
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (egg.trigger !== 'taps') return;
      const now = Date.now();
      taps = now - last < 1300 ? taps + 1 : 1;
      last = now;
      if (link) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearTimeout(follow);
      }
      if (taps >= egg.taps) {
        taps = 0;
        reveal();
        return;
      }
      if (link) {
        follow = setTimeout(() => {
          taps = 0;
          replaying = true;
          link.click();
          replaying = false;
        }, 700);
      }
    }, true);

    /* Gedrückt halten */
    if (egg.trigger === 'hold') {
      let timer;
      const stop = () => clearTimeout(timer);
      document.addEventListener('pointerdown', (e) => {
        const target = e.target.closest?.(selector);
        if (!target || skip(target)) return;
        stop();
        timer = setTimeout(() => {
          if (isLink(target)) swallowClick = true;
          reveal();
        }, (egg.hold || 2) * 1000);
      });
      ['pointerup', 'pointercancel', 'pointerleave', 'scroll'].forEach((type) => document.addEventListener(type, stop, { passive: true, capture: true }));
      document.addEventListener('contextmenu', (e) => {
        if (e.target.closest?.(selector)) e.preventDefault();
      });
      $$(selector).forEach((el) => { el.style.webkitTouchCallout = 'none'; el.style.userSelect = 'none'; });
    }
  }

  /* ---------- Stimmungs-Finder: Tabs ---------- */
  function initMood(root = document) {
    $$('[data-mood]', root).forEach((mood) => {
      if (mood.dataset.ready) return;
      mood.dataset.ready = '1';
      const tabs = $$('[role="tab"]', mood);
      const select = (tab, focus = false) => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !active;
            if (active) initCards(panel);
          }
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          const dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
          else if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
          else if (dir) { e.preventDefault(); select(tabs[(i + dir + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  /* ---------- Land, Währung, Sprache im Header ---------- */
  function initLocalization() {
    const loc = $('[data-loc]');
    if (!loc) return;
    const toggle = $('[data-loc-toggle]', loc);
    const panel = $('[data-loc-panel]', loc);
    const search = $('[data-loc-search]', loc);

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (open) (search || $('[aria-current="true"]', panel) || $('button', panel))?.focus();
    };
    toggle.addEventListener('click', () => setOpen(panel.hidden));
    document.addEventListener('click', (e) => { if (!panel.hidden && !loc.contains(e.target)) setOpen(false); });
    loc.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });
    search?.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase();
      let hits = 0;
      $$('[data-loc-name]', panel).forEach((li) => {
        const match = !q || li.dataset.locName.includes(q);
        li.hidden = !match;
        if (match) hits += 1;
      });
      const empty = $('[data-loc-empty]', panel);
      if (empty) empty.hidden = hits > 0;
    });
  }

  /* ---------- Leiste unter Reihen: rollende Figur, Zündschnur, Film, Mini-Vorschau, Lineal, Zähler ---------- */
  function initRailBar(rail, list, page) {
    const el = $('[data-rail-progress]', rail);
    const look = el?.dataset.railProgress;
    if (!el || !look || look === 'classic') return null;
    const t = theme.strings.rail;
    const items = () => $$(':scope > li', list);
    const showCount = el.hasAttribute('data-rb-count');
    const party = el.hasAttribute('data-rb-end') && !reducedMotion.matches;
    const counter = '<span class="rb-count" data-rb-num></span>';

    // Aufbau je Look
    if (look === 'roll') {
      el.insertAdjacentHTML('afterbegin', '<span class="rb-track" data-rb-track></span>');
      $('[data-rb-track]', el).append($('[data-rb-figure]', el));
    } else if (look === 'fuse') {
      const link = el.dataset.rbLink;
      el.innerHTML = '<span class="rb-track" data-rb-track><span class="rb-fuse__ash"></span><span class="rb-fuse__rope"></span><span class="rb-fuse__spark" data-rb-handle><i></i><i></i><i></i></span></span>'
        + (el.hasAttribute('data-rb-end') ? `<${link ? `a href="${escapeHtml(link)}"` : 'span'} class="rb-fuse__sticker" data-rb-sticker>${escapeHtml(t.done)}${link ? ` <b>${escapeHtml(t.all)} →</b>` : ''}</${link ? 'a' : 'span'}>` : '');
    } else if (look === 'film') {
      el.innerHTML = `<span class="rb-track rb-film" data-rb-track>${items().map(() => '<i></i>').join('')}</span>${showCount ? `<span class="rb-count">${escapeHtml(t.scene)} <b data-rb-num></b></span>` : ''}`;
    } else if (look === 'minimap') {
      el.innerHTML = `<span class="rb-track rb-map" data-rb-track>${items().map((li, i) => {
        const img = $('img', li);
        const src = img?.currentSrc || img?.src || $('video', li)?.poster || '';
        return `<i data-rb-go="${i}"${src ? ` style="background-image:url('${src.replace(/'/g, '%27')}')"` : ''}></i>`;
      }).join('')}<span class="rb-map__frame" data-rb-frame></span></span>${showCount ? counter : ''}`;
    } else if (look === 'ruler') {
      el.innerHTML = `<span class="rb-track rb-ruler" data-rb-track style="--n: ${items().length}"><span class="rb-ruler__pin" data-rb-handle><b data-rb-pin></b></span></span>${showCount ? counter : ''}`;
    } else if (look === 'count') {
      el.innerHTML = `<span class="rb-hand scribble"><span data-rb-num></span> <button type="button" class="rb-hand__next" data-rb-next tabindex="-1">${escapeHtml(t.next)} →</button><span class="rb-hand__done">${escapeHtml(t.done)}</span></span>`;
    }
    const track = $('[data-rb-track]', el);
    const fig = $('[data-rb-figure]', el);

    // Fortschritt anzeigen
    let wasEnd = false;
    const update = () => {
      const max = list.scrollWidth - list.clientWidth;
      const p = max > 0 ? Math.min(1, Math.max(0, list.scrollLeft / max)) : 0;
      const kids = items();
      const n = kids.length;
      const step = kids[1] ? kids[1].offsetLeft - kids[0].offsetLeft : list.clientWidth;
      const seen = Math.min(n, Math.max(1, Math.round((list.scrollLeft + list.clientWidth - (parseFloat(getComputedStyle(list).paddingLeft) || 0)) / Math.max(1, step))));
      const shown = p > 0.995 ? n : seen;
      const vis = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
      el.style.setProperty('--p', p);
      el.style.setProperty('--vis', vis);
      $$('[data-rb-num]', el).forEach((num) => {
        num.textContent = look === 'count' ? `${shown} ${t.of} ${n}` : `${shown} / ${n}`;
      });
      const pin = $('[data-rb-pin]', el);
      if (pin) pin.textContent = shown;
      if (fig && track) {
        const travel = Math.max(0, track.clientWidth - fig.offsetWidth);
        fig.style.transform = `translateX(${p * travel}px)${el.hasAttribute('data-rb-spin') ? ` rotate(${(p * travel) / (fig.offsetWidth / 2 || 1)}rad)` : ''}`;
      }
      if (look === 'film') {
        const first = Math.max(0, shown - Math.max(1, Math.round(list.clientWidth / Math.max(1, step))));
        $$('i', track).forEach((f, i) => f.classList.toggle('is-on', i >= first && i < shown));
      }
      const end = max > 4 && p > 0.995;
      el.classList.toggle('is-end', end);
      if (end && !wasEnd && party) {
        el.classList.remove('is-party');
        void el.offsetWidth;
        el.classList.add('is-party');
      }
      wasEnd = end;
    };

    // Ziehen: Position auf der Leiste → Scrollposition der Reihe
    if (track && el.classList.contains('is-draggable')) {
      let dragging = false;
      const toScroll = (clientX) => {
        const r = track.getBoundingClientRect();
        const max = list.scrollWidth - list.clientWidth;
        let ratio = (clientX - r.left) / r.width;
        if (look === 'minimap') {
          const vis = list.clientWidth / list.scrollWidth;
          ratio = (ratio - vis / 2) / Math.max(0.01, 1 - vis);
        }
        list.scrollLeft = Math.min(1, Math.max(0, ratio)) * max;
      };
      track.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        dragging = true;
        el.classList.add('is-dragging');
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
        track.setPointerCapture(e.pointerId);
        toScroll(e.clientX);
        e.preventDefault();
      });
      track.addEventListener('pointermove', (e) => { if (dragging) toScroll(e.clientX); });
      const stop = () => {
        if (!dragging) return;
        dragging = false;
        el.classList.remove('is-dragging');
        list.style.scrollSnapType = '';
        list.style.scrollBehavior = '';
      };
      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', stop);
    } else if (look === 'minimap') {
      // Ohne Ziehen: Klick auf ein Mini-Bild springt zur Karte
      track?.addEventListener('click', (e) => {
        const go = e.target.closest('[data-rb-go]');
        const li = go && items()[Number(go.dataset.rbGo)];
        if (li) list.scrollTo({ left: li.offsetLeft - (parseFloat(getComputedStyle(list).paddingLeft) || 0), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
    }
    $('[data-rb-next]', el)?.addEventListener('click', () => page(1));
    el.removeAttribute('aria-hidden');
    return update;
  }

  /* ---------- Karussell: Produktreihen zum Durchscrollen ---------- */
  function initRails(root = document) {
    $$('[data-rail]', root).forEach((rail) => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = '1';
      const list = $('[data-rail-list]', rail);
      const prev = $('[data-rail-prev]', rail);
      const next = $('[data-rail-next]', rail);
      const bar = $('[data-rail-bar]', rail);
      if (!list) return;

      let barUpdate = null;
      const update = () => {
        const max = list.scrollWidth - list.clientWidth;
        const atStart = list.scrollLeft <= 4;
        const atEnd = list.scrollLeft >= max - 4;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
        rail.classList.toggle('is-scrollable', max > 4);
        if (bar) {
          const size = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
          bar.style.width = `${Math.min(100, size * 100)}%`;
          bar.style.transform = `translateX(${max > 0 ? (list.scrollLeft / max) * ((1 / size) - 1) * 100 : 0}%)`;
        }
        barUpdate?.();
      };
      const page = (dir) => {
        const card = $('li', list);
        const step = card ? Math.max(card.offsetWidth, list.clientWidth - card.offsetWidth) : list.clientWidth * 0.9;
        list.scrollBy({ left: dir * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      barUpdate = initRailBar(rail, list, page);
      prev?.addEventListener('click', () => page(-1));
      next?.addEventListener('click', () => page(1));
      list.addEventListener('keydown', (e) => {
        if (e.target !== list) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); page(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); page(-1); }
      });
      list.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- Footer: Sticker-Wand zum Verschieben ---------- */
  function initStickerWall(root = document) {
    $$('[data-sticker-wall]', root).forEach((wall) => {
      if (wall.dataset.ready) return;
      wall.dataset.ready = '1';
      let z = 10;
      const key = (st) => `softriot:sticker:${st.dataset.sticker}`;

      $$('[data-sticker]', wall).forEach((st) => {
        // Position innerhalb des Besuchs merken
        if (!window.Shopify?.designMode) {
          try {
            const saved = JSON.parse(sessionStorage.getItem(key(st)) || 'null');
            if (saved) {
              st.style.setProperty('--x', `${saved.x}%`);
              st.style.setProperty('--y', `${saved.y}%`);
            }
          } catch (_) { /* Speicher blockiert */ }
        }

        st.addEventListener('pointerdown', (e) => {
          if (e.button !== 0) return;
          e.preventDefault();
          st.setPointerCapture(e.pointerId);
          const area = wall.getBoundingClientRect();
          const box = st.getBoundingClientRect();
          const grabX = e.clientX - (box.left + box.width / 2);
          const grabY = e.clientY - (box.top + box.height / 2);
          let lastX = e.clientX;
          let pos = null;
          st.classList.add('is-dragging');
          document.body.classList.add('is-dragging-sticker');
          window.getSelection()?.removeAllRanges();
          st.style.zIndex = String(++z);

          const move = (ev) => {
            const cx = Math.min(Math.max(ev.clientX - grabX - area.left, box.width / 2), area.width - box.width / 2);
            const cy = Math.min(Math.max(ev.clientY - grabY - area.top, box.height / 2), area.height - box.height / 3);
            pos = { x: +(cx / area.width * 100).toFixed(2), y: +(cy / area.height * 100).toFixed(2) };
            st.style.setProperty('--x', `${pos.x}%`);
            st.style.setProperty('--y', `${pos.y}%`);
            const tilt = Math.max(-16, Math.min(16, (ev.clientX - lastX) * 1.4));
            st.style.setProperty('--tilt', `${tilt}deg`);
            lastX = ev.clientX;
          };
          const up = () => {
            st.removeEventListener('pointermove', move);
            st.classList.remove('is-dragging');
            document.body.classList.remove('is-dragging-sticker');
            st.style.setProperty('--tilt', '0deg');
            if (!reducedMotion.matches) {
              st.classList.remove('is-dropped');
              void st.offsetWidth;
              st.classList.add('is-dropped');
            }
            if (pos) {
              try { sessionStorage.setItem(key(st), JSON.stringify(pos)); } catch (_) { /* egal */ }
            }
          };
          st.addEventListener('pointermove', move);
          st.addEventListener('pointerup', up, { once: true });
          st.addEventListener('pointercancel', up, { once: true });
        });
        st.addEventListener('animationend', () => st.classList.remove('is-dropped'));
        st.addEventListener('dragstart', (e) => e.preventDefault());
      });
    });
  }

  /* ---------- Footer: Gerade auf Usedom (Uhrzeit + Werkstatt-Status) ---------- */
  function initLive(root = document) {
    $$('[data-live]', root).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const out = $('[data-live-text]', el);
      const days = { 'mon-fri': [1, 2, 3, 4, 5], 'mon-sat': [1, 2, 3, 4, 5, 6], daily: [0, 1, 2, 3, 4, 5, 6] }[el.dataset.days] || [1, 2, 3, 4, 5];
      const open = Number(el.dataset.open);
      const close = Number(el.dataset.close);
      const zone = 'Europe/Berlin';
      let timeFmt;
      let partFmt;
      try {
        timeFmt = new Intl.DateTimeFormat(document.documentElement.lang || 'de', { timeZone: zone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
        partFmt = new Intl.DateTimeFormat('en-US', { timeZone: zone, weekday: 'short', hour: 'numeric', hourCycle: 'h23' });
      } catch (_) {
        return;
      }

      const tick = () => {
        const now = new Date();
        const parts = Object.fromEntries(partFmt.formatToParts(now).map((p) => [p.type, p.value]));
        const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
        const hour = Number(parts.hour) % 24;
        const isOpen = days.includes(weekday) && hour >= open && hour < close;
        el.classList.toggle('is-open', isOpen);

        const [before, after = ''] = (el.dataset.template || '[zeit]').split('[zeit]');
        const time = document.createElement('strong');
        time.textContent = timeFmt.format(now);
        out.replaceChildren(before, time, `${after} `, isOpen ? el.dataset.openText : el.dataset.closedText);
        el.hidden = false;
      };
      tick();
      setInterval(tick, 30000);
    });
  }

  /* ---------- Wünsche: Bestellanmerkung im Warenkorb speichern ---------- */
  function initCartNote(root = document) {
    $$('[data-cart-note]', root).forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const input = $('[data-cart-note-input]', box);
      const status = $('[data-cart-note-status]', box);
      let timer;
      input?.addEventListener('input', () => {
        if (status) status.textContent = '';
        clearTimeout(timer);
        timer = setTimeout(() => {
          fetch(`${theme.routes.cartUpdate}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: input.value })
          }).then((res) => { if (res.ok && status) status.textContent = theme.strings.mutSaved; }).catch(() => {});
        }, 700);
      });
    });
  }

  // Tolerant abgleichen: „S (36/38)“ in der Variante findet „S“ in der Maßtabelle und umgekehrt
  const sizeNorm = (s) => String(s).toLowerCase().replace(/\(.*?\)/g, '').trim();
  function sizeKey(keys, size) {
    if (!size) return null;
    const n = sizeNorm(size);
    const first = n.split(/[\s/,]+/)[0];
    return keys.find((k) => k.toLowerCase() === String(size).toLowerCase())
      || keys.find((k) => sizeNorm(k) === n)
      || keys.find((k) => sizeNorm(k).split(/[\s/,]+/)[0] === first)
      || null;
  }

  /* ---------- Größen-Spiegel ---------- */
  function initSizeMirror(root = document) {
    $$('[data-mirror]', root).forEach((mirror) => {
      if (mirror.dataset.ready) return;
      mirror.dataset.ready = '1';
      let lengths = {};
      try { lengths = JSON.parse(mirror.dataset.lengths || '{}'); } catch (_) { return; }
      const t = theme.strings.mirror;
      const input = $('[data-mirror-input]', mirror);
      const valueEl = $('[data-mirror-value]', mirror);
      const stage = $('[data-mirror-stage]', mirror);
      const result = $('[data-mirror-result]', mirror);
      const fieldset = mirror.closest('fieldset');
      const modelH = Number(mirror.dataset.modelHeight) || 168;
      const modelSize = mirror.dataset.modelSize || '';
      const key = 'softriot:height';
      try { const saved = Number(localStorage.getItem(key)); if (saved >= 140 && saved <= 200) input.value = saved; } catch (_) { /* egal */ }

      const findKey = (size) => sizeKey(Object.keys(lengths), size);
      const findLength = (size) => {
        const k = findKey(size);
        return k ? lengths[k] : null;
      };
      // Höhe des Saums über dem Boden im Verhältnis zur Körpergröße (Schulterhöhe ≈ 81,8 %)
      const where = (h, len) => {
        const r = (0.818 * h - len) / h;
        if (r > 0.62) return 'cropped';
        if (r > 0.55) return 'waist';
        if (r > 0.48) return 'hip';
        if (r > 0.40) return 'seat';
        if (r > 0.33) return 'thigh';
        return 'long';
      };
      const person = (h, len, cx, label, highlight) => {
        const floor = 206;
        const r = 0.062 * h;
        const top = floor - h;
        const sh = floor - 0.818 * h;
        const crotch = floor - 0.47 * h;
        const sw = 0.235 * h;
        const hw = 0.19 * h;
        const leg = 0.08 * h;
        const body = `<circle cx="${cx}" cy="${top + r}" r="${r}"/>`
          + `<rect x="${cx - sw / 2}" y="${sh}" width="${sw}" height="${crotch - sh}" rx="${sw * 0.18}"/>`
          + `<rect x="${cx - sw / 2 - 0.055 * h}" y="${sh + 2}" width="${0.05 * h}" height="${0.34 * h}" rx="${0.025 * h}"/>`
          + `<rect x="${cx + sw / 2 + 0.005 * h}" y="${sh + 2}" width="${0.05 * h}" height="${0.34 * h}" rx="${0.025 * h}"/>`
          + `<rect x="${cx - hw / 2}" y="${crotch - 6}" width="${leg}" height="${floor - crotch + 6}" rx="${leg / 2}"/>`
          + `<rect x="${cx + hw / 2 - leg}" y="${crotch - 6}" width="${leg}" height="${floor - crotch + 6}" rx="${leg / 2}"/>`;
        let shirt = '';
        if (len) {
          const hem = Math.min(floor - 4, sh + len);
          const w = sw * 1.12;
          shirt = `<path class="mirror__shirt${highlight ? '' : ' is-ref'}" d="M${cx - w / 2 - 0.07 * h} ${sh + 3} L${cx - w / 2} ${sh - 1} L${cx + w / 2} ${sh - 1} L${cx + w / 2 + 0.07 * h} ${sh + 3} L${cx + w / 2 + 0.07 * h} ${sh + 0.13 * h} L${cx + w / 2} ${sh + 0.13 * h} L${cx + w / 2} ${hem} L${cx - w / 2} ${hem} L${cx - w / 2} ${sh + 0.13 * h} L${cx - w / 2 - 0.07 * h} ${sh + 0.13 * h} Z"/>`;
        }
        return `<g class="mirror__person${highlight ? ' is-you' : ''}">${body}</g>${shirt}<text x="${cx}" y="216" text-anchor="middle" class="mirror__name">${label}</text>`;
      };

      // Saum-Markierung: gestrichelte Linie mit Größe und Länge, damit auch 2 cm Unterschied sichtbar sind
      const hemMark = (h, len, size, cx) => {
        if (!len) return '';
        const y = Math.min(202, 206 - 0.818 * h + len);
        return `<g class="mirror__hem"><line x1="${cx - 42}" x2="${cx + 42}" y1="${y}" y2="${y}"/><text x="${cx - 45}" y="${y + 3}" text-anchor="end">${escapeHtml(size)} · ${len} cm</text></g>`;
      };
      let lastSize = '';
      let lastLen = null;

      const render = () => {
        const h = Number(input.value);
        valueEl.textContent = h;
        const size = fieldset ? $('.opt__input:checked', fieldset)?.value : '';
        const len = findLength(size);
        const modelLen = findLength(modelSize);
        const oldShirt = $('.mirror__shirt:not(.is-ref)', stage)?.getAttribute('d');
        const oldY = Number($('.mirror__hem line', stage)?.getAttribute('y1')) || null;
        // Ohne bekannte Model-Größe steht „Du“ allein in der Mitte
        const youX = modelSize ? 72 : 120;
        stage.innerHTML = `<svg viewBox="0 0 240 222" role="presentation">`
          + `<line x1="10" y1="206" x2="230" y2="206" class="mirror__floor"/>`
          + person(h, len, youX, t.you, true)
          + (modelSize ? person(modelH, modelLen, 170, t.model, false) : '')
          + hemMark(h, len, findKey(size) || size, youX)
          + `</svg>`;
        // Vom alten zum neuen Saum gleiten (neu zeichnen würde die Animation sonst überspringen)
        const shirt = $('.mirror__shirt:not(.is-ref)', stage);
        const hem = $('.mirror__hem', stage);
        if (shirt && oldShirt && oldShirt !== shirt.getAttribute('d')) {
          const next = shirt.getAttribute('d');
          shirt.setAttribute('d', oldShirt);
          shirt.style.d = `path("${oldShirt}")`;
          void shirt.getBoundingClientRect();
          shirt.style.d = `path("${next}")`;
        }
        if (hem && oldY) {
          const newY = Number($('line', hem).getAttribute('y1'));
          hem.style.transform = `translateY(${oldY - newY}px)`;
          void hem.getBoundingClientRect();
          hem.style.transform = '';
          if (Math.abs(oldY - newY) > 0.1) { hem.classList.remove('is-flash'); void hem.getBoundingClientRect(); hem.classList.add('is-flash'); }
        }
        if (!len) { result.textContent = t.pick; lastSize = ''; lastLen = null; return; }
        let text = t.result.replace('[height]', h).replace('[size]', size).replace('[where]', t.where[where(h, len)]);
        if (lastLen !== null && lastSize && lastSize !== size && lastLen !== len) {
          const diff = Math.round(Math.abs(len - lastLen) * 10) / 10;
          text += ' ' + (len > lastLen ? t.longer : t.shorter).replace('[diff]', String(diff).replace('.', ',')).replace('[size]', lastSize);
        }
        if (modelSize && modelLen) text += ' ' + t.modelLine.replace('[height]', modelH).replace('[size]', modelSize).replace('[where]', t.where[where(modelH, modelLen)]);
        result.textContent = text;
        lastSize = size;
        lastLen = len;
      };
      input.addEventListener('input', () => {
        render();
        try { localStorage.setItem(key, input.value); } catch (_) { /* egal */ }
      });
      fieldset?.addEventListener('change', render);
      render();
    });
  }

  /* ---------- „Wie fällt's aus?“: Maßbänder, Skizze, Vergleich, Tabelle ---------- */
  function initFitGuide(panel, fieldset) {
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = '1';
    const table = $('[data-sg-table]', panel);
    if (!table) return;
    const t = theme.strings.sg;
    const num = (txt) => { const n = parseFloat(String(txt).replace(',', '.')); return Number.isFinite(n) ? n : null; };
    const head = [...table.rows[0].cells].map((c) => c.textContent.trim());
    const rows = [...table.rows].slice(1).map((r) => ({ size: r.cells[0].textContent.trim(), row: r, vals: [...r.cells].slice(1).map((c) => num(c.textContent)) }));
    if (!rows.length) return;
    // Spalten mit Zahlen in jeder Zeile (Breite, Länge, Ärmel …)
    const cols = head.slice(1).map((name, i) => ({ name, i })).filter((c) => rows.every((r) => r.vals[c.i] !== null));
    const colFind = (re) => cols.find((c) => re.test(c.name.toLowerCase()));
    const colW = colFind(/breit|width|brust|chest|weite/);
    const colL = colFind(/länge|laenge|length|lang/);
    const keys = rows.map((r) => r.size);
    const byKey = (k) => rows.find((r) => r.size === k);
    const store = 'softriot:myshirt';
    let unit = 'cm';
    let current = null;
    let mine = {};
    try { mine = JSON.parse(localStorage.getItem(store) || '{}') || {}; } catch (_) { mine = {}; }

    const round = (v) => Math.round(v * 10) / 10;
    const toUnit = (cm) => (unit === 'in' ? round(cm / 2.54) : round(cm));
    const fmt = (cm) => `${String(toUnit(cm)).replace('.', t.decimal)} ${unit === 'in' ? 'in' : 'cm'}`;
    const selectedKey = () => sizeKey(keys, fieldset ? $('.opt__input:checked', fieldset)?.value : '') || keys[0];

    // Maßbänder: ein Band pro Zahlenspalte, Marker pro Größe, Cursor gleitet zur gewählten Größe
    const tapesEl = $('[data-sg-tapes]', panel);
    const tapes = cols.map((c) => {
      const vals = rows.map((r) => r.vals[c.i]);
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      const pad = Math.max(2, (max - min) * 0.18);
      const lo = Math.floor(min - pad);
      const hi = Math.ceil(max + pad);
      const pct = (v) => ((v - lo) / (hi - lo)) * 100;
      return { ...c, lo, hi, pct };
    });
    if (tapesEl) {
      tapesEl.innerHTML = tapes.map((tp, ti) => `<div class="sg-tape" data-tape="${ti}">`
        + `<div class="sg-tape__head"><span class="sg-tape__name">${escapeHtml(tp.name)}</span><strong data-tape-value></strong></div>`
        + `<div class="sg-tape__band" style="--cm: calc(100% / ${tp.hi - tp.lo})">`
        + `<span class="sg-tape__cursor" data-tape-cursor></span>`
        + `<span class="sg-tape__you" data-tape-you hidden><span>${escapeHtml(t.you)}</span></span>`
        + rows.map((r, ri) => `<button type="button" class="sg-tape__mark${ri % 2 ? ' is-low' : ''}" style="left:${tp.pct(r.vals[tp.i])}%" data-sg-pick="${escapeHtml(r.size)}" aria-label="${escapeHtml(`${r.size}: ${tp.name} ${r.vals[tp.i]} cm`)}">${escapeHtml(r.size)}</button>`).join('')
        + `</div>`
        + `<div class="sg-tape__steps" aria-hidden="true">${rows.slice(1).map((r, ri) => `<span style="left:${(tp.pct(rows[ri].vals[tp.i]) + tp.pct(r.vals[tp.i])) / 2}%" data-step="${ri}"></span>`).join('')}</div>`
        + `</div>`).join('');
    }

    // Skizze: flach liegendes Teil, Breite und Länge wachsen mit der Größe
    const sketchEl = $('[data-sg-sketch]', panel);
    const shape = ['shirt', 'longsleeve', 'hoodie', 'tank'].includes(panel.dataset.shape) ? panel.dataset.shape : 'shirt';
    const maxW = colW ? Math.max(...rows.map((r) => r.vals[colW.i])) : 1;
    const maxL = colL ? Math.max(...rows.map((r) => r.vals[colL.i])) : 1;
    const garment = (W, L) => {
      const cx = 120;
      const top = shape === 'hoodie' ? 46 : 30;
      const x0 = cx - W / 2;
      const x1 = cx + W / 2;
      const nw = W * (shape === 'tank' ? 0.42 : 0.34);
      const hem = top + L;
      const pit = top + W * 0.38;
      const neck = `M${cx - nw / 2} ${top} Q${cx} ${top + (shape === 'tank' ? 26 : 14)} ${cx + nw / 2} ${top}`;
      let d;
      if (shape === 'tank') {
        d = `${neck} L${cx + nw / 2 + W * 0.1} ${top} Q${x1 - 4} ${pit - 10} ${x1} ${pit} L${x1} ${hem} L${x0} ${hem} L${x0} ${pit} Q${x0 + 4} ${pit - 10} ${cx - nw / 2 - W * 0.1} ${top} Z`;
      } else {
        const long = shape !== 'shirt';
        const sx = long ? W * 0.34 : W * 0.3;
        const sy = long ? L * 0.86 : W * 0.4;
        const cuff = long ? W * 0.17 : W * 0.15;
        d = `${neck} L${x1} ${top + 6} L${x1 + sx} ${top + 6 + sy} L${x1 + sx - cuff} ${top + 14 + sy} L${x1} ${pit + (long ? 8 : 0)} L${x1} ${hem} L${x0} ${hem} L${x0} ${pit + (long ? 8 : 0)} L${x0 - sx + cuff} ${top + 14 + sy} L${x0 - sx} ${top + 6 + sy} L${x0} ${top + 6} Z`;
      }
      const hood = shape === 'hoodie' ? `M${cx - nw / 2 - 6} ${top + 4} C${cx - nw / 2 - 18} ${top - 30} ${cx + nw / 2 + 18} ${top - 30} ${cx + nw / 2 + 6} ${top + 4} Q${cx} ${top + 22} ${cx - nw / 2 - 6} ${top + 4} Z` : '';
      const pocket = shape === 'hoodie' ? `M${cx - W * 0.3} ${hem - L * 0.08} L${cx - W * 0.22} ${hem - L * 0.3} L${cx + W * 0.22} ${hem - L * 0.3} L${cx + W * 0.3} ${hem - L * 0.08}` : '';
      const wy = pit + 10;
      const lx = cx + nw / 2 + 6;
      return { d, hood, pocket, wArrow: `M${x0 + 3} ${wy} L${x1 - 3} ${wy}`, lArrow: `M${lx} ${top + 4} L${lx} ${hem - 3}`, wy, lx, top, hem, x0, x1 };
    };
    let sk = null;
    if (sketchEl && (colW || colL)) {
      sketchEl.innerHTML = `<div class="sg-sketch__head"><span>${escapeHtml(t.size)}</span><strong data-sk-size></strong></div>`
        + `<svg viewBox="0 0 240 ${shape === 'hoodie' ? 240 : 224}" role="img" data-sk-svg>`
        + `<path class="sg-sketch__hood" data-sk="hood"/><path class="sg-sketch__body" data-sk="d"/><path class="sg-sketch__pocket" data-sk="pocket"/>`
        + (colW ? `<path class="sg-sketch__arrow" data-sk="wArrow" marker-start="url(#sgA-${panel.id})" marker-end="url(#sgA-${panel.id})"/><text class="sg-sketch__label" text-anchor="middle" data-sk-w></text>` : '')
        + (colL ? `<path class="sg-sketch__arrow" data-sk="lArrow" marker-start="url(#sgA-${panel.id})" marker-end="url(#sgA-${panel.id})"/><text class="sg-sketch__label" data-sk-l></text>` : '')
        + `<defs><marker id="sgA-${panel.id}" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse"><path d="M0 1 L9 5 L0 9 z"/></marker></defs>`
        + `</svg>`;
      sk = sketchEl;
    }
    const setPath = (el, d) => {
      if (!el) return;
      if (!d) { el.removeAttribute('d'); el.style.d = ''; return; }
      // Über style.d gleitet der Umriss sanft zur neuen Größe (wo der Browser es kann)
      if (el.getAttribute('d')) el.style.d = `path("${d}")`;
      el.setAttribute('d', d);
    };

    const table_wrap = $('[data-sg-table-wrap]', panel);
    const cells = [...table.querySelectorAll('td')].map((td) => ({ td, raw: td.textContent, v: num(td.textContent) }));

    const render = () => {
      const r = byKey(current) || rows[0];
      rows.forEach((x) => x.row.classList.toggle('is-current', x === r));
      $$('[data-sg-pick]', panel).forEach((b) => b.classList.toggle('is-on', b.dataset.sgPick === r.size));
      tapes.forEach((tp, ti) => {
        const el = tapesEl && $(`[data-tape="${ti}"]`, tapesEl);
        if (!el) return;
        $('[data-tape-cursor]', el).style.left = `${tp.pct(r.vals[tp.i])}%`;
        $('[data-tape-value]', el).textContent = `${r.size} · ${fmt(r.vals[tp.i])}`;
        $$('[data-step]', el).forEach((s) => {
          const i = Number(s.dataset.step);
          const diff = rows[i + 1].vals[tp.i] - rows[i].vals[tp.i];
          s.textContent = diff ? `+${String(toUnit(diff)).replace('.', t.decimal)}` : '±0';
        });
        const you = $('[data-tape-you]', el);
        const mv = Number(mine[tp.name]);
        you.hidden = !(mv > 0);
        if (mv > 0) you.style.left = `${Math.min(100, Math.max(0, tp.pct(mv)))}%`;
      });
      if (sk) {
        const W = colW ? 120 * (r.vals[colW.i] / maxW) : 110;
        const L = colL ? 166 * (r.vals[colL.i] / maxL) : 150;
        const g = garment(W, L);
        $$('[data-sk]', sk).forEach((el) => setPath(el, g[el.dataset.sk]));
        $('[data-sk-size]', sk).textContent = r.size;
        const wt = $('[data-sk-w]', sk);
        if (wt) { wt.setAttribute('x', g.x0 + 6); wt.setAttribute('y', g.wy - 6); wt.textContent = `${colW.name} ${fmt(r.vals[colW.i])}`; }
        const lt = $('[data-sk-l]', sk);
        if (lt) { lt.setAttribute('x', g.lx + 6); lt.setAttribute('y', g.hem - 10); lt.textContent = `${colL.name} ${fmt(r.vals[colL.i])}`; }
        $('[data-sk-svg]', sk).setAttribute('aria-label', [colW && `${colW.name} ${fmt(r.vals[colW.i])}`, colL && `${colL.name} ${fmt(r.vals[colL.i])}`].filter(Boolean).join(', '));
      }
      cells.forEach((c) => { c.td.textContent = unit === 'in' && c.v !== null ? fmt(c.v) : c.raw; });
    };

    // Klick auf einen Marker zeigt diese Größe zur Ansicht, ohne die Variante zu wechseln
    panel.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-sg-pick]');
      if (pick) { current = pick.dataset.sgPick; render(); return; }
      const u = e.target.closest('[data-sg-unit]');
      if (u) {
        unit = u.dataset.sgUnit;
        $$('[data-sg-unit]', panel).forEach((b) => b.setAttribute('aria-pressed', String(b === u)));
        $$('[data-sg-unit-label]', panel).forEach((l) => { l.textContent = unit === 'in' ? 'in' : 'cm'; });
        $$('[data-sg-field]', panel).forEach((inp) => { const v = Number(mine[inp.dataset.sgField]); inp.value = v > 0 ? toUnit(v) : ''; });
        render();
        return;
      }
      const choose = e.target.closest('[data-sg-choose]');
      if (choose && fieldset) {
        const input = $$('.opt__input', fieldset).find((i) => sizeKey(keys, i.value) === choose.dataset.sgChoose);
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      if (e.target.closest('[data-sg-run]')) compare();
    });
    fieldset?.addEventListener('change', () => { current = selectedKey(); render(); });

    // „Mit meinem Shirt vergleichen“: nächstgelegene Größe über alle eingetragenen Maße
    const fieldsEl = $('[data-sg-fields]', panel);
    const resultEl = $('[data-sg-result]', panel);
    const compareCols = [colW, colL, ...cols].filter((c, i, a) => c && a.indexOf(c) === i).slice(0, 3);
    if (fieldsEl) {
      fieldsEl.innerHTML = compareCols.map((c) => `<label class="sg-compare__field"><span>${escapeHtml(c.name)}</span>`
        + `<span class="sg-compare__input"><input type="number" inputmode="decimal" min="1" step="0.5" data-sg-field="${escapeHtml(c.name)}" value="${Number(mine[c.name]) > 0 ? mine[c.name] : ''}"><em data-sg-unit-label>cm</em></span></label>`).join('');
      fieldsEl.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); compare(); } });
    }
    function compare() {
      const got = {};
      $$('[data-sg-field]', panel).forEach((inp) => {
        const v = num(inp.value);
        if (v && v > 0) got[inp.dataset.sgField] = unit === 'in' ? v * 2.54 : v;
      });
      const used = compareCols.filter((c) => got[c.name]);
      if (!used.length) { resultEl.innerHTML = `<p>${escapeHtml(t.empty)}</p>`; return; }
      mine = got;
      try { localStorage.setItem(store, JSON.stringify(mine)); } catch (_) { /* egal */ }
      let best = rows[0];
      let bestD = Infinity;
      rows.forEach((r) => {
        const d = used.reduce((sum, c) => sum + (r.vals[c.i] - got[c.name]) ** 2, 0);
        if (d < bestD) { bestD = d; best = r; }
      });
      const lines = used.map((c) => {
        const diff = best.vals[c.i] - got[c.name];
        const txt = Math.abs(diff) < 0.5 ? t.equal : (diff > 0 ? t.more : t.less).replace('[diff]', fmt(Math.abs(diff)));
        return `<li><span>${escapeHtml(c.name)}:</span> ${escapeHtml(txt)}</li>`;
      }).join('');
      resultEl.innerHTML = `<p class="sg-compare__best">${escapeHtml(t.best.replace('[size]', best.size))}</p><ul>${lines}</ul>`
        + (fieldset ? `<button type="button" class="btn btn--ink sg-compare__choose" data-sg-choose="${escapeHtml(best.size)}">${escapeHtml(t.choose.replace('[size]', best.size))}</button>` : '');
      current = best.size;
      render();
    }

    current = selectedKey();
    render();
    if (table_wrap && !table_wrap.hidden && $('[data-sg-tapes]', panel)) table_wrap.classList.add('is-secondary');
  }

  /* ---------- Social-Wand: Videos stumm abspielen, sobald sie im Bild sind ---------- */
  function initSocialWall(root = document) {
    $$('[data-sw]', root).forEach((wall) => {
      if (wall.dataset.ready) return;
      wall.dataset.ready = '1';
      const auto = wall.hasAttribute('data-sw-autoplay') && !reducedMotion.matches;
      const videos = $$('.sw__video', wall);
      const play = (v) => { v.play().then(() => v.closest('.sw__media')?.classList.add('is-playing')).catch(() => {}); };
      const pause = (v) => { v.pause(); v.closest('.sw__media')?.classList.remove('is-playing'); };
      videos.forEach((v) => {
        v.muted = true;
        v.playsInline = true;
        v.loop = true;
        v.removeAttribute('controls');
        v.closest('.sw__media')?.querySelector('[data-sw-toggle]')?.addEventListener('click', () => (v.paused ? play(v) : pause(v)));
      });
      if (!auto || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? play(e.target) : pause(e.target)));
      }, { threshold: 0.6 });
      videos.forEach((v) => io.observe(v));
    });
  }

  /* ---------- Shop the Look (Startseite) ---------- */
  function initShopLook(root = document) {
    $$('[data-stl]', root).forEach((stl) => {
      if (stl.dataset.ready) return;
      stl.dataset.ready = '1';
      const pins = $$('[data-stl-pin]', stl);
      const items = $$('[data-stl-item]', stl);
      const narrow = window.matchMedia('(max-width: 989px)');
      const activate = (n) => {
        pins.forEach((p) => p.classList.toggle('is-active', p.dataset.stlPin === n));
        items.forEach((i) => i.classList.toggle('is-active', i.dataset.stlItem === n));
      };
      pins.forEach((pin) => {
        pin.addEventListener('mouseenter', () => activate(pin.dataset.stlPin));
        pin.addEventListener('click', () => {
          activate(pin.dataset.stlPin);
          const item = items.find((i) => i.dataset.stlItem === pin.dataset.stlPin);
          if (item && narrow.matches) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
      items.forEach((item) => {
        item.addEventListener('mouseenter', () => activate(item.dataset.stlItem));
        item.addEventListener('focusin', () => activate(item.dataset.stlItem));
      });
      stl.addEventListener('mouseleave', () => activate(null));
    });
  }

  /* ---------- Komplett-Look ---------- */
  function initLook(root = document) {
    $$('[data-look]', root).forEach((look) => {
      if (look.dataset.ready) return;
      look.dataset.ready = '1';
      const info = $('product-info');
      const currentCheck = $('[data-look-current]', look);
      const currentPrice = $('[data-look-current-price]', look);
      const totalEl = $('[data-look-total]', look);
      const hintEl = $('[data-look-hint]', look);
      const errorEl = $('[data-look-error]', look);
      let tiers = [];
      try { tiers = JSON.parse(look.dataset.tiers || '[]'); } catch (_) { tiers = []; }

      const currentVariant = () => {
        const id = Number($('[data-variant-id]', info || document)?.value);
        const json = $('[data-variants]', info || document);
        const variants = json ? JSON.parse(json.textContent) : [];
        return variants.find((v) => v.id === id) || null;
      };
      const priceOf = (sel) => Number(sel.tagName === 'SELECT' ? sel.selectedOptions[0]?.dataset.price : sel.dataset.price) || 0;

      const update = () => {
        const cur = currentVariant();
        if (cur && currentPrice) currentPrice.textContent = formatMoney(cur.price);
        if (currentCheck) currentCheck.disabled = cur ? !cur.available : true;
        let total = cur && currentCheck?.checked && cur.available ? cur.price : 0;
        $$('[data-look-item]', look).forEach((item) => {
          const sel = $('[data-look-variant]', item);
          const price = priceOf(sel);
          const link = $('[data-look-price]', item);
          if (link) link.textContent = formatMoney(price);
          item.classList.toggle('is-off', !$('[data-look-check]', item).checked);
          if ($('[data-look-check]', item).checked) total += price;
        });
        $('.look__item--current', look)?.classList.toggle('is-off', !currentCheck?.checked);
        totalEl.textContent = formatMoney(total);

        // Staffel-Hinweis: Was bringt der Look zusammen mit dem Warenkorb?
        hintEl.textContent = '';
        if (tiers.length && total > 0) {
          const subtotal = Number(look.dataset.subtotal) || 0;
          const conv = tiers.map((t) => ({ pct: t.pct, min: Currency.isForeign() ? Currency.convert(t.min) : t.min })).sort((a, b) => a.min - b.min);
          const before = conv.filter((t) => subtotal >= t.min).pop();
          const after = conv.filter((t) => subtotal + total >= t.min).pop();
          const next = conv.find((t) => subtotal + total < t.min);
          if (after && (!before || after.pct > before.pct)) hintEl.textContent = theme.strings.look.unlock.replace('[percent]', after.pct);
          else if (next) hintEl.textContent = theme.strings.look.next.replace('[amount]', formatMoney(next.min - subtotal - total)).replace('[percent]', next.pct);
        }
      };

      look.addEventListener('change', update);
      info?.addEventListener('change', () => setTimeout(update, 0));

      $('[data-look-add]', look)?.addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        const items = [];
        const cur = currentVariant();
        if (cur && cur.available && currentCheck?.checked) items.push({ id: cur.id, quantity: 1 });
        $$('[data-look-item]', look).forEach((item) => {
          if ($('[data-look-check]', item).checked) items.push({ id: Number($('[data-look-variant]', item).value), quantity: 1 });
        });
        errorEl.hidden = true;
        if (!items.length) { errorEl.textContent = theme.strings.look.none; errorEl.hidden = false; return; }
        btn.classList.add('is-loading');
        try {
          await Cart.add(items);
          const cart = await fetch(`${theme.routes.cart}.js`).then((r) => r.json()).catch(() => null);
          if (cart) { look.dataset.subtotal = String(cart.items_subtotal_price); update(); }
        } catch (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } finally {
          btn.classList.remove('is-loading');
        }
      });
      update();
    });
  }

  /* ---------- Mut-Satz zum Freirubbeln ---------- */
  // Rubbelschicht auf einem Canvas über card. Gibt reveal() zurück oder null ohne Canvas-Unterstützung.
  function scratchFoil(card, canvas, label, onReveal) {
    const ctx = canvas.getContext?.('2d');
    if (!ctx) return null;
    let done = false;
    let drawing = false;
    let last = null;
    let moves = 0;

    const reveal = () => {
      if (done) return;
      done = true;
      card.classList.add('is-revealed');
      document.dispatchEvent(new CustomEvent('scratch:revealed'));
      onReveal?.();
      setTimeout(() => canvas.remove(), 700);
    };

    const paint = () => {
      const rect = card.getBoundingClientRect();
      if (!rect.width) return;
      const dpr = window.devicePixelRatio || 1;
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      const g = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      g.addColorStop(0, '#c9c4c8'); g.addColorStop(0.5, '#efeaee'); g.addColorStop(1, '#b8b2b7');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, rect.width, rect.height);
      ctx.fillStyle = 'rgba(0,0,0,.08)';
      for (let i = 0; i < 160; i++) ctx.fillRect(Math.random() * rect.width, Math.random() * rect.height, 2, 2);
      ctx.fillStyle = '#5c5660';
      ctx.font = `${Math.round(Math.min(34, rect.width / 9))}px ${getComputedStyle(document.documentElement).getPropertyValue('--font-accent') || 'cursive'}`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(label, rect.width / 2, rect.height / 2);
    };
    paint();
    card.classList.add('is-covered');

    const pos = (e) => { const r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
    const checkCleared = () => {
      const { width, height } = canvas;
      if (!width || !height) return;
      const data = ctx.getImageData(0, 0, width, height).data;
      let clear = 0;
      let total = 0;
      for (let i = 3; i < data.length; i += 4 * 24) { total++; if (data[i] === 0) clear++; }
      if (clear / total > 0.45) reveal();
    };
    const scratch = (p) => {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 42;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo((last || p).x, (last || p).y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      last = p;
      if (++moves % 12 === 0) checkCleared();
    };
    canvas.addEventListener('pointerdown', (e) => { drawing = true; last = null; canvas.setPointerCapture(e.pointerId); scratch(pos(e)); });
    canvas.addEventListener('pointermove', (e) => { if (drawing) scratch(pos(e)); });
    const stop = () => { drawing = false; last = null; if (!done) checkCleared(); };
    canvas.addEventListener('pointerup', stop);
    canvas.addEventListener('pointercancel', stop);
    // Neu malen, wenn sich die Größe ändert (z. B. Schublade geht auf), solange noch nicht gerubbelt wurde
    if ('ResizeObserver' in window) new ResizeObserver(() => { if (!done && moves === 0) paint(); }).observe(card);
    document.fonts?.ready.then(() => { if (!done && moves === 0) paint(); });
    return reveal;
  }

  function initScratch(root = document) {
    $$('[data-scratch]', root).forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const card = $('[data-scratch-card]', box);
      const textEl = $('[data-scratch-text]', box);
      const codeEl = $('[data-scratch-code]', box);
      const live = $('[data-scratch-live]', box);
      const revealBtn = $('[data-scratch-reveal]', box);

      // Satz wählen: fester Satz aus dem Produkt, sonst zufällig
      let pool = [];
      try { pool = JSON.parse(box.dataset.sentences || '[]').filter(Boolean); } catch (_) { pool = []; }
      const sentence = box.dataset.fixed || pool[Math.floor(Math.random() * pool.length)] || textEl.textContent;
      textEl.textContent = sentence;
      const win = box.dataset.code && Math.random() * 100 < Number(box.dataset.chance || 0);
      if (win) $('[data-scratch-code-value]', box).textContent = box.dataset.code;

      const reveal = scratchFoil(card, $('[data-scratch-canvas]', box), `✦ ${theme.strings.scratch.cover} ✦`, () => {
        revealBtn.hidden = true;
        if (win) codeEl.hidden = false;
        live.textContent = `${theme.strings.scratch.revealed} ${sentence}${win ? ` – ${box.dataset.code}` : ''}`;
      });
      if (!reveal) return;
      revealBtn.hidden = false;
      revealBtn.addEventListener('click', reveal);
      $('[data-scratch-copy]', box)?.addEventListener('click', (e) => {
        const btn = e.currentTarget;
        navigator.clipboard?.writeText(box.dataset.code).then(() => { btn.textContent = btn.dataset.copied; });
      });
    });
  }

  /* ---------- Reiter (Produktdetails) ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const tabs = $$('[role="tab"]', wrap);
      const select = (tab, focus = false) => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (dir) { e.preventDefault(); select(tabs[(i + dir + tabs.length) % tabs.length], true); }
          if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
          if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
        });
      });
    });
  }

  /* ---------- Fokusfalle für Dialoge ---------- */
  function trapFocus(container, event) {
    if (event.key !== 'Tab') return;
    const focusables = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter((el) => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* ---------- Header: schrumpft beim Scrollen, Laufband verschwindet ---------- */
  function initHeader() {
    let ticking = false;
    const update = () => {
      document.body.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Header-Extras: lebendige Pille, Werkstatt-Status, schlafender Skull, Daumen-Leiste ---------- */
  const HeaderExtras = {
    config: null,
    island: null,
    pane: null,
    hideTimer: null,
    buyVisible: false,
    total: 0,
    timers: [],
    bound: false,

    init() {
      const json = $('[data-header-extras]');
      if (!json) return;
      try { this.config = JSON.parse(json.textContent); } catch (e) { return; }
      this.island = $('[data-island]');
      this.pane = null;
      this.buyVisible = false;
      this.total = Number(this.config.cartTotal) || 0;
      this.timers.forEach(clearInterval);
      this.timers = [];
      this.initStatus();
      this.initSleep();
      this.initThumb();
      /* Dokument-Ereignisse nur einmal anmelden (der Editor lädt den Header neu) */
      if (!this.bound) {
        this.bound = true;
        document.addEventListener('cart:added', (e) => { if (this.island && this.config.added) this.showAdded(e.detail); });
        document.addEventListener('cart:changed', () => { if (this.island && this.config.ship && this.config.shipThreshold > 0) this.refreshTotal(); });
        document.addEventListener('stickybuy:change', (e) => this.onBuyState?.(e.detail.visible));
      }
      if (!this.island) return;
      if (this.config.ship && this.config.shipThreshold > 0 && this.total > 0) setTimeout(() => this.showShip(), 900);
      if (this.config.buy) this.initBuy();
    },

    /* Zeigt eine Ansicht der Pille; ohne Dauer bleibt sie, bis etwas anderes kommt */
    show(name, ms) {
      clearTimeout(this.hideTimer);
      this.pane = name;
      $$('[data-island-pane]', this.island).forEach((p) => p.classList.toggle('is-active', p.dataset.islandPane === name));
      this.island.classList.add('is-open');
      document.body.classList.add('has-island');
      const btn = $('[data-island-buy-btn]', this.island);
      if (btn) btn.tabIndex = name === 'buy' ? 0 : -1;
      if (ms) this.hideTimer = setTimeout(() => this.settle(), ms);
    },

    hide() {
      this.pane = null;
      this.island.classList.remove('is-open');
      document.body.classList.remove('has-island');
      const btn = $('[data-island-buy-btn]', this.island);
      if (btn) btn.tabIndex = -1;
    },

    /* Nach einer kurzen Meldung zurück zur Kaufleiste oder ausblenden */
    settle() {
      if (this.buyVisible) this.show('buy');
      else this.hide();
    },

    showAdded(data) {
      const item = data?.items?.[0];
      if (!item) return;
      $('[data-island-title]', this.island).textContent = item.product_title || item.title;
      const img = $('[data-island-img]', this.island);
      img.innerHTML = '';
      if (item.image) {
        const el = document.createElement('img');
        el.src = `${item.image}${item.image.includes('?') ? '&' : '?'}width=120&height=120&crop=center`;
        el.alt = '';
        el.width = 40;
        el.height = 40;
        img.append(el);
      }
      this.show('added', 4500);
    },

    async refreshTotal() {
      try {
        const res = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        this.total = cart.total_price;
        if (this.pane === 'added') setTimeout(() => this.showShip(), 4600);
        else this.showShip();
      } catch (e) { /* ohne Fortschritt weiter */ }
    },

    showShip() {
      if (this.total <= 0) return;
      if (this.pane === 'added') return;
      const goal = Currency.convert(this.config.shipThreshold);
      const missing = goal - this.total;
      const text = missing > 0
        ? String(this.config.shipText || '').replace('[betrag]', formatMoney(missing))
        : this.config.shipDone;
      $('[data-island-ship-text]', this.island).textContent = text;
      $('[data-island-ship-bar]', this.island).style.width = `${Math.min(100, Math.round((this.total / goal) * 100))}%`;
      this.island.classList.toggle('is-done', missing <= 0);
      this.show('ship', 5000);
    },

    initBuy() {
      if (!window.matchMedia('(min-width: 990px)').matches || !('IntersectionObserver' in window)) return;
      const mainBtn = $('.pdp-form [data-add-button]');
      const sticky = $('[data-sticky-buy]');
      if (!mainBtn || !sticky) return;
      const title = $('[data-island-buy-title]', this.island);
      const price = $('[data-island-buy-price]', this.island);
      const btn = $('[data-island-buy-btn]', this.island);
      const sync = () => {
        title.textContent = $('.sticky-buy__title', sticky)?.textContent || '';
        price.textContent = $('[data-sticky-price]', sticky)?.textContent || '';
        const stickyBtn = $('[data-add-button]', sticky);
        btn.disabled = Boolean(stickyBtn?.disabled);
        btn.textContent = $('[data-add-label]', sticky)?.textContent.trim() || btn.textContent;
      };
      btn.addEventListener('click', () => $('[data-add-button]', sticky)?.click());
      // Sichtbar, wenn die Kaufleiste sichtbar wäre (inkl. „nach dem Hinzufügen ausblenden“, Theme-Einstellungen → Produktseite)
      this.onBuyState = (visible) => {
        this.buyVisible = visible;
        if (visible) {
          sync();
          if (!this.pane || this.pane === 'buy') this.show('buy');
        } else if (this.pane === 'buy') {
          this.hide();
        }
      };
      if (sticky.dataset.visible) this.onBuyState(true);
    },

    /* Uhrzeit und Wochentag in deutscher Zeit */
    berlinNow() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
      const get = (type) => parts.find((p) => p.type === type)?.value;
      const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
      return { day, hour: Number(get('hour')) % 24 };
    },

    initStatus() {
      const el = $('[data-pill-status]');
      const cfg = this.config.status;
      if (!el || !cfg) return;
      const update = () => {
        const { day, hour } = this.berlinNow();
        const [first, last] = String(cfg.days).split('-').map(Number);
        const isWorkday = (d) => d >= first && d <= last;
        const workday = isWorkday(day);
        const open = workday && hour >= cfg.from && hour < cfg.to;
        /* Freie Tage (z. B. Wochenende) haben einen eigenen Text, auch schon am Abend davor */
        const offNext = workday && hour >= cfg.to && !isWorkday((day + 1) % 7);
        const early = workday && hour < cfg.from;
        let text = cfg.closed;
        if (open) text = cfg.open;
        else if ((!workday || offNext) && cfg.off) text = cfg.off;
        else if (early && cfg.early) text = cfg.early;
        el.classList.toggle('is-open', open);
        $('[data-pill-status-text]', el).textContent = text;
        el.hidden = !text;
      };
      update();
      this.timers.push(setInterval(update, 5 * 60 * 1000));
    },

    initSleep() {
      if (!this.config.sleep) return;
      const update = () => {
        const { hour } = this.berlinNow();
        const night = hour >= 22 || hour < 6;
        $$('[data-skull-sleep]').forEach((el) => el.classList.toggle('is-sleeping', night));
      };
      update();
      this.timers.push(setInterval(update, 5 * 60 * 1000));
    },

    /* Daumen-Leiste: oben bleibt nur das Logo, es verschwindet beim Runterscrollen */
    initThumb() {
      if (!this.config.thumb || this.thumbBound) return;
      this.thumbBound = true;
      let lastY = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (Math.abs(y - lastY) < 6) return;
        document.body.classList.toggle('is-scrolling-down', y > lastY && y > 120);
        lastY = y;
      }, { passive: true });
    }
  };

  /* ---------- Fullscreen-Menü ---------- */
  function initMenu() {
    const menu = $('[data-menu]');
    const openBtns = $$('[data-menu-open]');
    if (!menu || !openBtns.length) return;
    let lastFocus = null;

    menu.setAttribute('inert', '');

    const open = (btn) => {
      lastFocus = btn || document.activeElement;
      /* Skull-Menü: das Menü wächst aus dem Mund des Skulls */
      const mouthBtn = btn?.matches('[data-menu-mouth]');
      /* Eine gewählte Menü-Animation (Bewegung) hat Vorrang; der Kiefer klappt trotzdem auf */
      const mouth = mouthBtn && menu.classList.contains('menu--anim-classic') ? $('.jaw-skull', btn) : null;
      /* Startpunkt ohne Übergang setzen, dann aufgehen lassen */
      menu.style.transition = 'none';
      menu.classList.toggle('menu--mouth', Boolean(mouth));
      /* Zine-Rücken behält sein Aufklappen */
      menu.classList.toggle('menu--spine', Boolean(btn?.closest('.spine')));
      menu.classList.remove('is-settled');
      if (mouth) {
        const r = mouth.getBoundingClientRect();
        menu.style.setProperty('--mouth-x', `${r.left + r.width / 2}px`);
        menu.style.setProperty('--mouth-y', `${r.top + r.height * 0.75}px`);
      }
      if (mouthBtn) btn.classList.add('is-open');
      void menu.offsetWidth;
      menu.style.transition = '';
      menu.removeAttribute('inert');
      menu.classList.add('is-open');
      /* Skull-Blick: nach dem Aufgehen die Maske entfernen, damit das Menü ganz frei ist */
      clearTimeout(menu._settle);
      const tempo = parseFloat(getComputedStyle(menu).getPropertyValue('--menu-tempo')) || 1;
      menu._settle = setTimeout(() => { if (menu.classList.contains('is-open')) menu.classList.add('is-settled'); }, 1800 * tempo + 100);
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('is-locked');
      setTimeout(() => $('[data-menu-close]', menu)?.focus(), 60);
    };
    const close = () => {
      clearTimeout(menu._settle);
      if (menu.classList.contains('is-settled')) {
        /* Maske ohne Sprung zurückholen, dann schließen */
        menu.style.transition = 'none';
        menu.classList.remove('is-settled');
        void menu.offsetWidth;
        menu.style.transition = '';
      }
      menu.classList.remove('is-open');
      menu.setAttribute('inert', '');
      openBtns.forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
        b.classList.remove('is-open');
      });
      document.body.classList.remove('is-locked');
      (lastFocus || openBtns[0]).focus();
    };

    openBtns.forEach((btn) => btn.addEventListener('click', () => open(btn)));
    $$('[data-menu-close]', menu).forEach((btn) => btn.addEventListener('click', close));
    menu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      trapFocus(menu, e);
    });
  }

  /* ---------- Einblenden beim Scrollen ---------- */
  function initReveal(root = document) {
    const items = $$('[data-reveal]:not(.is-in)', root);
    if (!document.documentElement.classList.contains('motion-ok') || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => io.observe(el));
  }

  /* ---------- Produktkarten: Wisch-Punkte, Farbpunkt-Vorschau, Quick-Add ---------- */
  function initCards(root = document) {
    if (HeaderIcons.cfg?.wish) HeaderIcons.syncWish();
    $$('[data-card]', root).forEach((card) => {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';

      const slides = $('[data-card-slides]', card);
      const dots = $$('.card__dots span', card);
      if (slides && dots.length) {
        slides.addEventListener('scroll', () => {
          const index = Math.round(slides.scrollLeft / slides.clientWidth);
          dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        }, { passive: true });
      }

      const mainImg = $('.card__img--1', card);
      if (mainImg) {
        const original = { src: mainImg.src, srcset: mainImg.srcset };
        $$('[data-swatch-img]', card).forEach((sw) => {
          sw.addEventListener('mouseenter', () => {
            mainImg.srcset = '';
            mainImg.src = sw.dataset.swatchImg;
          });
          sw.addEventListener('mouseleave', () => {
            mainImg.src = original.src;
            mainImg.srcset = original.srcset;
          });
        });
      }
    });
  }

  document.addEventListener('click', (e) => {
    // Quick-Add-Panel schließen, wenn außerhalb geklickt wird
    $$('[data-qa][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });

    const qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    qa.classList.add('is-loading');
    Cart.add([{ id: Number(qa.dataset.quickAdd), quantity: 1 }])
      .then(() => {
        qa.closest('[data-qa]')?.removeAttribute('open');
        const trigger = qa.closest('.card')?.querySelector('.card__qa');
        const flash = trigger || (qa.closest('[data-stl]') ? qa : null);
        if (flash) {
          flash.classList.add('is-done');
          setTimeout(() => flash.classList.remove('is-done'), 1400);
        }
      })
      .catch((err) => window.alert(err.message))
      .finally(() => qa.classList.remove('is-loading'));
  });

  /* ---------- Warenkorb ---------- */
  const Cart = {
    drawer: null,
    lastFocus: null,

    init() {
      this.drawer = $('[data-drawer]');
      document.addEventListener('click', (e) => {
        const openLink = e.target.closest('[data-cart-open]');
        if (openLink && this.drawer && theme.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
          e.preventDefault();
          this.open();
        }
        if (e.target.closest('[data-drawer-close]')) this.close();

        const change = e.target.closest('[data-line-change]');
        if (change) {
          e.preventDefault();
          this.change(Number(change.dataset.lineChange), Number(change.dataset.qty), change.closest('.line'));
        }
      });
      document.addEventListener('change', (e) => {
        const input = e.target.closest('[data-line-input]');
        if (input) this.change(Number(input.dataset.lineInput), Math.max(0, Number(input.value) || 0), input.closest('.line'));
      });
      this.drawer?.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        trapFocus(this.drawer, e);
      });
    },

    open() {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      document.body.classList.add('is-locked');
      setTimeout(() => $('.drawer__head .icon-btn', this.drawer)?.focus(), 80);
    },

    close() {
      if (!this.drawer?.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      this.lastFocus?.focus();
    },

    sectionsParam() {
      const ids = ['cart-drawer'];
      if ($('[data-cart-page]')) ids.push(this.cartPageSectionId());
      return ids.filter(Boolean);
    },

    cartPageSectionId() {
      const el = $('[data-cart-page]')?.closest('.shopify-section');
      return el ? el.id.replace('shopify-section-', '') : null;
    },

    render(sections) {
      if (!sections) return;
      const drawerHtml = sections['cart-drawer'];
      if (drawerHtml && this.drawer) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const fresh = $('[data-drawer-inner]', doc);
        const current = $('[data-drawer-inner]', this.drawer);
        if (fresh && current) {
          current.replaceWith(fresh);
          initPromos(fresh);
          initMut(fresh);
          initCartNote(fresh);
          restoreCartUi(fresh);
          this.updateCount(Number(fresh.dataset.count || 0));
        }
      }
      document.dispatchEvent(new CustomEvent('cart:changed'));
      const pageId = this.cartPageSectionId();
      if (pageId && sections[pageId]) {
        const doc = new DOMParser().parseFromString(sections[pageId], 'text/html');
        const fresh = $('[data-cart-page]', doc);
        const current = $('[data-cart-page]');
        if (fresh && current) {
          current.replaceWith(fresh);
          initPromos(fresh);
          initMut(fresh);
          initCartNote(fresh);
          restoreCartUi(fresh);
        }
      }
    },

    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });
    },

    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.sectionsParam(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || theme.strings?.cartError || 'Error');
      }
      return data;
    },

    async add(items) {
      const data = await this.request(`${theme.routes.cartAdd}.js`, { items });
      if (theme.cartType === 'page') {
        window.location.href = theme.routes.cart;
        return data;
      }
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      if (!HeaderExtras.config?.added) this.open();
      return data;
    },

    async change(line, quantity, lineEl) {
      lineEl?.classList.add('is-updating');
      try {
        const data = await this.request(`${theme.routes.cartChange}.js`, { line, quantity });
        this.render(data.sections);
      } catch (err) {
        lineEl?.classList.remove('is-updating');
        window.alert(err.message);
      }
    }
  };

  /* ---------- Produktseite ---------- */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.form = $('[data-product-form]', this);
      this.variantInput = $('[data-variant-id]', this);
      const json = $('[data-variants]', this);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.fieldsets = $$('fieldset[data-option]', this);

      this.addEventListener('change', (e) => {
        if (e.target.matches('.opt__input')) this.onOptionChange();
      });
      this.form?.addEventListener('submit', (e) => {
        if ($('[data-tm-release]', this)) { e.preventDefault(); return; }
        this.onSubmit(e);
      });
      this.initQty();
      this.initWish();
      this.initSizeGuide();
      this.initGallery();
      this.initStickyBuy();
      this.updateAvailability();
    }

    selectedOptions() {
      return this.fieldsets.map((fs) => $('.opt__input:checked', fs)?.value);
    }

    onOptionChange() {
      const selected = this.selectedOptions();
      this.fieldsets.forEach((fs, i) => {
        const label = $('[data-selected]', fs);
        if (label) label.textContent = selected[i] || '';
      });
      const variant = this.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      this.updateAvailability();
      this.setVariant(variant);
    }

    updateAvailability() {
      // Markiert Werte, die in Kombination mit der übrigen Auswahl nicht lieferbar sind
      const selected = this.selectedOptions();
      this.fieldsets.forEach((fs, index) => {
        $$('.opt__input', fs).forEach((input) => {
          const combo = [...selected];
          combo[index] = input.value;
          const match = this.variants.find((v) => v.options.every((o, i) => o === combo[i]));
          const label = input.nextElementSibling;
          label?.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    setVariant(variant) {
      const buttons = $$('[data-add-button]', this);
      const setButtons = (text, disabled) => buttons.forEach((btn) => {
        btn.disabled = disabled;
        const label = $('[data-add-label]', btn);
        if (label) label.textContent = text;
      });

      if (!variant) {
        setButtons(theme.strings.unavailable, true);
        return;
      }

      this.variantInput.value = variant.id;
      setButtons(variant.available ? theme.strings.addToCart : theme.strings.soldOut, !variant.available);

      // Preis
      const priceWrap = $('[data-price-wrap]', this);
      if (priceWrap) {
        const onSale = variant.compare > variant.price;
        priceWrap.innerHTML = `<div class="price${onSale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${onSale ? `<s class="price__compare">${formatMoney(variant.compare)}</s>` : ''}</div>`;
        const sale = $('[data-sale]', this);
        if (sale) {
          const value = Number(sale.dataset.saleValue) || 0;
          const off = sale.dataset.saleType === 'eur' ? Currency.convert(value * 100) : Math.round((variant.price * value) / 100);
          $('[data-sale-text]', sale).innerHTML = fill(sale.dataset.saleTemplate, { price: formatMoney(Math.max(0, variant.price - off)) });
        }
      }
      const stickyPrice = $('[data-sticky-price]', this);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      // Benachrichtigen
      const notify = $('[data-notify]', this);
      if (notify) notify.hidden = variant.available;
      const notifyBody = $('[data-notify-body]', this);
      if (notifyBody) notifyBody.value = notifyBody.value.replace(/–.*$/, `– ${variant.title}`);

      // Bild
      if (variant.media) this.showMedia(variant.media);

      // URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    async onSubmit(e) {
      e.preventDefault();
      const error = $('[data-form-error]', this);
      const buttons = $$('[data-add-button]', this);
      buttons.forEach((b) => b.classList.add('is-loading'));
      if (error) error.hidden = true;
      try {
        const qty = Number($('.qty__input', this.form)?.value || 1);
        const item = { id: Number(this.variantInput.value), quantity: qty };
        // Wunsch-Angaben (properties[...]) mitschicken, auch Felder außerhalb des Formulars (form="…")
        const properties = {};
        for (const [name, value] of new FormData(this.form).entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && String(value).trim()) properties[match[1]] = String(value).trim();
        }
        if (Object.keys(properties).length) item.properties = properties;
        await Cart.add([item]);
        this.resetWish();
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      } finally {
        buttons.forEach((b) => b.classList.remove('is-loading'));
      }
    }

    initWish() {
      const wish = $('[data-wish]', this);
      if (!wish) return;
      const combo = $('[data-wish-combo]', wish);
      const comboImg = $('[data-wish-combo-img]', wish);
      const summary = $('[data-wish-summary]', wish);
      wish.addEventListener('change', (e) => {
        if (!e.target.matches('[data-wish-motif]')) return;
        if (comboImg) comboImg.src = e.target.dataset.img || '';
        if (summary) summary.textContent = theme.strings.wishSelected.replace('[title]', e.target.value);
        if (combo) combo.hidden = false;
      });
      $('[data-wish-reset]', wish)?.addEventListener('click', () => this.resetWish());

      const search = $('[data-wish-search]', wish);
      if (search) {
        const items = $$('[data-wish-item]', wish);
        const grid = $('[data-wish-grid]', wish);
        const empty = $('[data-wish-empty]', wish);
        const count = $('[data-wish-count]', wish);
        const norm = (t) => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
        items.forEach((item) => { item.dataset.search = norm(item.dataset.search || ''); });
        const filter = () => {
          const words = norm(search.value.trim()).split(/\s+/).filter(Boolean);
          let shown = 0;
          items.forEach((item) => {
            const hit = words.every((w) => item.dataset.search.includes(w));
            item.hidden = !hit;
            if (hit) shown += 1;
          });
          if (empty) empty.hidden = shown > 0;
          if (grid) { grid.hidden = shown === 0; grid.scrollLeft = 0; }
          if (count) count.textContent = words.length ? String(shown) : '';
        };
        search.addEventListener('input', filter);
        search.addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
      }
    }

    resetWish() {
      const wish = $('[data-wish]', this);
      if (!wish) return;
      $$('[data-wish-motif]', wish).forEach((r) => { r.checked = false; });
      const search = $('[data-wish-search]', wish);
      if (search && search.value) { search.value = ''; search.dispatchEvent(new Event('input')); }
      const note = $('.wish__note', wish);
      if (note) note.value = '';
      const combo = $('[data-wish-combo]', wish);
      if (combo) combo.hidden = true;
    }

    initQty() {
      $$('[data-qty-step]', this).forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = $('.qty__input', btn.parentElement);
          input.value = Math.max(1, Number(input.value || 1) + Number(btn.dataset.qtyStep));
        });
      });
    }

    initSizeGuide() {
      const toggle = $('[data-size-toggle]', this);
      const panel = $('[data-size-guide]', this);
      if (!toggle || !panel) return;
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
      initFitGuide(panel, panel.closest('fieldset'));
    }

    initGallery() {
      this.galleryList = $('[data-gallery-list]', this);
      if (!this.galleryList) return;
      const list = this.galleryList;
      const counter = $('[data-gallery-index]', this);
      const prev = $('[data-gallery-prev]', this);
      const next = $('[data-gallery-next]', this);
      const thumbs = $$('[data-gallery-thumb]', this);
      const slides = () => $$('.gallery__item', list);

      const current = () => Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
      const update = () => {
        const i = current();
        const count = slides().length;
        if (counter) counter.textContent = i + 1;
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= count - 1;
        thumbs.forEach((t, n) => {
          const active = n === i;
          t.classList.toggle('is-active', active);
          if (active) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      };
      this.goToSlide = (i) => {
        const item = slides()[Math.max(0, Math.min(i, slides().length - 1))];
        if (!item) return;
        list.scrollTo({ left: item.offsetLeft - list.offsetLeft - parseFloat(getComputedStyle(list).paddingLeft), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };

      prev?.addEventListener('click', () => this.goToSlide(current() - 1));
      next?.addEventListener('click', () => this.goToSlide(current() + 1));
      thumbs.forEach((t) => t.addEventListener('click', () => this.goToSlide(Number(t.dataset.galleryThumb))));
      list.setAttribute('tabindex', '0');
      list.addEventListener('keydown', (e) => {
        if (e.target !== list) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goToSlide(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goToSlide(current() - 1); }
      });
      list.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    showMedia(mediaId) {
      if (!this.galleryList || !this.goToSlide) return;
      const index = $$('.gallery__item', this.galleryList).findIndex((el) => el.dataset.mediaId === String(mediaId));
      if (index >= 0) this.goToSlide(index);
    }

    initStickyBuy() {
      const bar = $('[data-sticky-buy]', this);
      const mainBtn = $('.pdp-form [data-add-button]', this);
      if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
      // Nach dem Hinzufügen: „until_up“ = weg, bis der Haupt-Button wieder im Bild war; „page“ = für diesen Seitenbesuch weg
      const after = bar.dataset.after || 'keep';
      let done = false;
      let below = false;
      const apply = () => {
        // Vor dem Erscheinungsdatum gibt es nichts zu kaufen
        const visible = below && !done && !$('[data-tm-release]', this);
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
        $('[data-add-button]', bar).tabIndex = visible ? 0 : -1;
        // Die Kaufleiste in der Header-Pille (Desktop) folgt demselben Zustand
        bar.dataset.visible = visible ? '1' : '';
        document.dispatchEvent(new CustomEvent('stickybuy:change', { detail: { visible } }));
      };
      const io = new IntersectionObserver(([entry]) => {
        below = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (entry.isIntersecting && after === 'until_up') done = false;
        apply();
      });
      io.observe(mainBtn);
      document.addEventListener('tm:released', apply);
      if (after !== 'keep') {
        document.addEventListener('cart:added', () => { done = true; apply(); });
        // Wieder aus dem Warenkorb genommen? Dann gehört die Leiste wieder her.
        const ids = new Set(this.variants.map((v) => v.id));
        document.addEventListener('cart:changed', async () => {
          if (!done) return;
          const cart = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
          if (cart && !cart.items.some((item) => ids.has(item.variant_id))) { done = false; apply(); }
        });
      }
    }
  }
  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  /* ---------- Empfehlungen nachladen ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.children.length) return;
      const io = new IntersectionObserver(async ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        try {
          const html = await fetch(this.dataset.url).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = $('product-recommendations', doc);
          if (fresh && fresh.innerHTML.trim()) {
            this.innerHTML = fresh.innerHTML;
            initCards(this);
            initRails(this);
          }
        } catch (_) { /* Empfehlungen sind optional */ }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Filter: sofort anwenden ---------- */
  function initFacets() {
    const form = $('[data-facets]');
    if (!form) return;
    let timer;
    form.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const params = new URLSearchParams(new FormData(form));
        for (const [key, value] of [...params.entries()]) {
          if (value === '') params.delete(key);
        }
        window.location.search = params.toString();
      }, 350);
    });
    document.addEventListener('click', (e) => {
      $$('[data-facet][open]', form).forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    $$('[data-facet]', form).forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) $$('[data-facet][open]', form).forEach((o) => { if (o !== d) o.removeAttribute('open'); });
    }));
  }

  /* ---------- Kleinkram ---------- */
  /* Cookie-Einstellungen im Footer: nur sichtbar, wenn Shopifys Banner geladen ist (er lädt nach dem Theme). */
  function initCookieLink() {
    const item = $('[data-cookie-prefs]');
    if (!item) return;
    let tries = 0;
    const check = () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        item.hidden = false;
        $('button', item).addEventListener('click', () => window.privacyBanner.showPreferences());
      } else if (++tries < 20) {
        setTimeout(check, 500);
      }
    };
    check();
  }

  /* Cookies abgelehnter Kategorien aufräumen: Nach einem Widerruf liegen alte Cookies von Google, Meta & Co. sonst
     bis zum Ablauf herum (ungenutzt, aber gespeichert). Läuft beim Laden und nach jeder Banner-Antwort.
     Shopifys eigene Cookies räumt Shopify selbst; HttpOnly-Cookies sind von hier aus nicht erreichbar. */
  const ConsentCleanup = {
    analytics: (n) => n === '_ga' || n.startsWith('_ga_') || n === '_gid' || n.startsWith('_gat') || n === '_clck' || n === '_clsk' || n.startsWith('_hj'),
    marketing: (n) => ['_fbp', '_fbc', '_ttp', '_tt_enable_cookie', '_pin_unauth', '_uetsid', '_uetvid', '_scid', '_sctr'].includes(n)
      || n.startsWith('_gcl_') || n.startsWith('ttcsid'),
    remove(name) {
      // Domain-Varianten durchprobieren: Pixel setzen ihre Cookies oft auf die Hauptdomain (.shop.de), nicht auf www.
      const parts = location.hostname.split('.');
      const domains = [''];
      for (let i = 0; i < parts.length - 1; i++) domains.push(`; domain=.${parts.slice(i).join('.')}`);
      domains.forEach((d) => { document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`; });
    },
    run() {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.analyticsProcessingAllowed || !cp.marketingAllowed) return;
      const analytics = cp.analyticsProcessingAllowed();
      const marketing = cp.marketingAllowed();
      if (analytics && marketing) return;
      document.cookie.split(';').map((c) => c.split('=')[0].trim()).filter(Boolean).forEach((name) => {
        if ((!analytics && this.analytics(name)) || (!marketing && this.marketing(name))) this.remove(name);
      });
    },
    init() {
      document.addEventListener('visitorConsentCollected', () => this.run());
      const load = () => {
        if (!window.Shopify || !window.Shopify.loadFeatures) return false;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) this.run(); });
        return true;
      };
      if (!load()) window.addEventListener('load', load, { once: true });
    }
  };

  function initMisc() {
    $$('[data-autosubmit]').forEach((el) => el.addEventListener('change', () => el.form?.submit()));

    $('[data-to-top]')?.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      $('#MainContent')?.focus({ preventScroll: true });
    });
  }

  /* ---------- Glücksrad im Pop-up ----------
     Gewichteter Zufall, Ergebnis wird im Browser gemerkt, damit niemand beliebig oft dreht. */
  function initWheel(popup) {
    const wheel = $('[data-wheel]', popup);
    if (!wheel) return;
    let segs = [];
    try { segs = JSON.parse(wheel.dataset.wheel); } catch (_) { return; }
    if (segs.length < 2) return;

    const disc = $('[data-wheel-disc]', wheel);
    const spinBtn = $('[data-wheel-spin]', wheel);
    const result = $('[data-wheel-result]', wheel);
    const applyBtn = $('[data-wheel-apply]', wheel);
    const step = 360 / segs.length;
    const tones = [1, 2, 3].map((n) => [`var(--wheel-${n})`, `var(--wheel-${n}-fg)`]);
    const palette = segs.length % 2 === 0 ? tones.slice(0, 2) : tones;
    const color = (i) => palette[i % palette.length];
    disc.style.setProperty('--step', `${step}deg`);
    disc.style.background = `conic-gradient(${segs.map((seg, i) => `${color(i)[0]} ${i * step}deg ${(i + 1) * step}deg`).join(', ')})`;
    disc.innerHTML = segs.map((seg, i) => `<span class="wheel__label" style="--rot: ${i * step + step / 2}deg; color: ${color(i)[1]};"><span>${escapeHtml(seg.label)}</span></span>`).join('');

    const key = `softriot:wheel:${popup.dataset.popup}`;
    const rotateTo = (index, turns) => (turns * 360) - (index * step + step / 2);

    const showResult = (index) => {
      const seg = segs[index];
      result.hidden = false;
      spinBtn.hidden = true;
      $('[data-wheel-text]', wheel).innerHTML = seg.code
        ? fill(wheel.dataset.win, { label: escapeHtml(seg.label) })
        : escapeHtml(wheel.dataset.lose);
      const codeBox = $('[data-wheel-code]', wheel);
      codeBox.hidden = !seg.code;
      $('[data-popup-code]', codeBox).textContent = seg.code;
      if (applyBtn) applyBtn.hidden = !seg.code;
    };

    try {
      const saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (saved && segs[saved.index]) {
        disc.style.transform = `rotate(${rotateTo(saved.index, 1)}deg)`;
        showResult(saved.index);
      }
    } catch (_) { /* Speicher blockiert */ }

    spinBtn.addEventListener('click', () => {
      // Optional erst Treffer oder Niete auswürfeln, dann innerhalb davon nach Chance pro Feld
      let pool = segs.map((seg, i) => i);
      const rate = wheel.dataset.winRate;
      if (rate !== undefined) {
        const win = Math.random() * 100 < Number(rate);
        const picked = pool.filter((i) => Boolean(segs[i].code) === win);
        if (picked.length) pool = picked;
      }
      const total = pool.reduce((sum, i) => sum + Math.max(0, segs[i].weight), 0);
      let index = pool[Math.floor(Math.random() * pool.length)];
      if (total > 0) {
        let r = Math.random() * total;
        index = pool.find((i) => (r -= Math.max(0, segs[i].weight)) < 0) ?? pool[pool.length - 1];
      }
      const jitter = (Math.random() - 0.5) * step * 0.6;
      spinBtn.disabled = true;
      spinBtn.textContent = wheel.dataset.spinning;
      const ms = reducedMotion.matches ? 600 : (Number(wheel.dataset.spinSeconds) || 5) * 1000 - 400;
      disc.style.transition = `transform ${ms}ms cubic-bezier(.15, .7, .12, 1)`;
      disc.style.transform = `rotate(${rotateTo(index, 6) + jitter}deg)`;
      try { localStorage.setItem(key, JSON.stringify({ index, t: Date.now() })); } catch (_) { /* Speicher blockiert */ }
      setTimeout(() => {
        showResult(index);
        Popups.remember(popup, true);
      }, ms + 150);
    });

    applyBtn?.addEventListener('click', async () => {
      const code = $('[data-popup-code]', wheel).textContent.trim();
      if (!code) return;
      applyBtn.classList.add('is-loading');
      try {
        const cart = await fetch(`${theme.routes.cart}.js`).then((r) => r.json());
        const codes = (cart.discount_codes || []).map((c) => c.code).filter((c) => c.toLowerCase() !== code.toLowerCase());
        await applyCodes([...codes, code]);
        applyBtn.textContent = wheel.dataset.applied;
        applyBtn.disabled = true;
      } catch (err) {
        window.alert(err.message);
      } finally {
        applyBtn.classList.remove('is-loading');
      }
    });
  }

  /* ---------- Pop-ups ----------
     Höchstens eins gleichzeitig. Häufigkeit wird pro Pop-up im Browser gemerkt. */
  const Popups = {
    current: null,
    queue: [],
    lastFocus: null,

    init(root = document) {
      $$('[data-popup]', root).forEach((popup) => {
        if (popup.dataset.ready) return;
        popup.dataset.ready = '1';
        popup.setAttribute('inert', '');

        $$('[data-popup-close]', popup).forEach((btn) => btn.addEventListener('click', () => this.close(popup)));
        popup.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close(popup);
          if (this.isModal(popup)) trapFocus(popup, e);
        });
        $('[data-popup-cta]', popup)?.addEventListener('click', () => this.remember(popup, true));
        initWheel(popup);
        $('[data-copy-code]', popup)?.addEventListener('click', (e) => {
          const btn = e.currentTarget;
          const code = $('[data-popup-code]', popup)?.textContent.trim();
          navigator.clipboard?.writeText(code).then(() => {
            const label = btn.textContent;
            btn.textContent = btn.dataset.copied;
            setTimeout(() => { btn.textContent = label; }, 1800);
          });
        });

        // Nach erfolgreicher Anmeldung: Bestätigung zeigen, danach nie wieder
        if ($('[data-popup-success]', popup)) {
          this.remember(popup, true);
          this.show(popup);
          return;
        }
        if (window.Shopify?.designMode) return;
        if (this.isDue(popup) && this.deviceOk(popup) && TM.popupOk(popup)) this.arm(popup);
      });
    },

    key(popup) { return `softriot:popup:${popup.dataset.popup}`; },

    /* Einstellung „Anzeigen“: nur in der App bzw. nur im Browser */
    deviceOk(popup) {
      const app = document.documentElement.classList.contains('is-app');
      const on = popup.dataset.showOn;
      return !(on === 'app' && !app) && !(on === 'web' && app);
    },

    isModal(popup) {
      if (!popup.classList.contains('popup--center')) return false;
      return !(popup.classList.contains('popup--mobile-corner') && window.matchMedia('(max-width: 749px)').matches);
    },

    isDue(popup) {
      try {
        if (sessionStorage.getItem(this.key(popup))) return false;
        const saved = JSON.parse(localStorage.getItem(this.key(popup)) || 'null');
        if (!saved) return true;
        if (saved.done) return false;
        return Date.now() - saved.t > Number(popup.dataset.days) * 864e5;
      } catch (_) {
        return true;
      }
    },

    remember(popup, done = false) {
      if (window.Shopify?.designMode) return;
      try {
        sessionStorage.setItem(this.key(popup), '1');
        if (done || Number(popup.dataset.days) > 0) {
          localStorage.setItem(this.key(popup), JSON.stringify({ t: Date.now(), done }));
        }
      } catch (_) { /* Speicher blockiert: Pop-up erscheint dann ggf. erneut */ }
    },

    arm(popup) {
      const delay = Number(popup.dataset.delay || 0) * 1000;
      const trigger = popup.dataset.trigger;
      const fire = () => this.show(popup);

      if (trigger === 'scroll') {
        const target = Number(popup.dataset.scroll || 40) / 100;
        const onScroll = () => {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          if (max <= 0 || window.scrollY / max >= target) {
            window.removeEventListener('scroll', onScroll);
            fire();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      } else if (trigger === 'exit' && window.matchMedia('(hover: hover)').matches) {
        const onLeave = (e) => {
          if (e.clientY > 0 || e.relatedTarget) return;
          document.removeEventListener('mouseout', onLeave);
          fire();
        };
        setTimeout(() => document.addEventListener('mouseout', onLeave), 3000);
      } else {
        setTimeout(fire, trigger === 'exit' ? Math.max(delay, 15000) : delay);
      }
    },

    show(popup) {
      if (this.current === popup) return;
      // Nicht über offenes Menü, Warenkorb oder ein anderes Pop-up legen
      if (this.current || document.body.classList.contains('is-locked')) {
        if (!this.queue.includes(popup)) this.queue.push(popup);
        if (!this.current) setTimeout(() => this.next(), 4000);
        return;
      }
      this.current = popup;
      this.lastFocus = document.activeElement;
      popup.removeAttribute('inert');
      popup.setAttribute('aria-modal', String(this.isModal(popup)));
      popup.classList.add('is-open');
      if (this.isModal(popup)) {
        document.body.classList.add('is-locked');
        setTimeout(() => $('.popup__close', popup)?.focus(), 60);
      }
    },

    close(popup, { remember = true } = {}) {
      if (!popup.classList.contains('is-open')) return;
      popup.classList.remove('is-open');
      popup.setAttribute('inert', '');
      if (popup.getAttribute('aria-modal') === 'true') {
        document.body.classList.remove('is-locked');
        this.lastFocus?.focus?.();
      }
      if (remember) this.remember(popup);
      this.current = null;
      setTimeout(() => this.next(), 600);
    },

    next() {
      const popup = this.queue.shift();
      if (popup) this.show(popup);
    }
  };

  // Theme-Editor: ausgewählte Stimmung im Stimmungs-Finder zeigen
  document.addEventListener('shopify:block:select', (e) => {
    if (e.target.matches?.('.mood__tab, .pdp-tabs__tab, .stl__pin')) e.target.click();
  });

  // Theme-Editor: Pop-up zeigen, solange sein Block ausgewählt ist
  document.addEventListener('shopify:block:select', (e) => {
    const popup = e.target.closest?.('[data-popup]');
    if (!popup) return;
    if (Popups.current && Popups.current !== popup) Popups.close(Popups.current, { remember: false });
    Popups.show(popup);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const popup = e.target.closest?.('[data-popup]');
    if (popup) Popups.close(popup, { remember: false });
  });

  /* ---------- Theme-Editor ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target);
    initCards(e.target);
    initPromos(e.target);
    Popups.init(e.target);
    initMood(e.target);
    initTabs(e.target);
    initSizeMirror(e.target);
    initLook(e.target);
    initShopLook(e.target);
    initSocialWall(e.target);
    initScratch(e.target);
    initRails(e.target);
    initStickerWall(e.target);
    initLive(e.target);
    if (e.target.querySelector('[data-menu]')) {
      initMenu();
      HeaderExtras.init();
      HeaderIcons.init();
      HeaderVariant.init();
    }
  });

  /* ---------- Header-Extras: Versand-Ring, Plumps-Zahl, scheue Icons, Merkzettel, Zuletzt angesehen,
     Status-Punkt, Lieferuhr, Wisch-Header, Fächermenü (Theme-Einstellungen → Header: Icons / Extras) ---------- */
  const HeaderIcons = {
    cfg: null,
    bound: false,
    store(key, fallback) {
      try { return JSON.parse(localStorage.getItem(key) || 'null') || fallback; } catch (_) { return fallback; }
    },
    save(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* egal */ }
    },

    init() {
      const json = $('[data-hx-config]');
      if (!json) return;
      try { this.cfg = JSON.parse(json.textContent); } catch (_) { return; }
      this.total = Number(this.cfg.cartTotal) || 0;
      this.initPops();
      this.ring();
      this.initWish();
      this.initRecent();
      this.initDot();
      this.initClock();
      this.initShy();
      this.initSwipe();
      this.initFan();
      if (this.cfg.flicker) $$('.hx-look--neon').forEach((el) => el.classList.add('hx-flicker'));
      /* Dokument-Ereignisse nur einmal (der Editor lädt den Header neu) */
      if (this.bound) return;
      this.bound = true;
      document.addEventListener('cart:added', (e) => this.drop(e.detail));
      document.addEventListener('cart:changed', () => this.refreshCart());
      document.addEventListener('click', (e) => {
        const w = e.target.closest('[data-wish-toggle]');
        if (w) { e.preventDefault(); this.toggleWish(w); }
      });
    },

    /* Aufklapp-Fenster unter den Icons */
    initPops() {
      // Fenster an <body> hängen: der Header kann verschoben oder gefiltert sein
      $$('[data-hx-pop]').forEach((pop) => {
        $$(`body > [data-hx-pop="${pop.dataset.hxPop}"]`).forEach((old) => { if (old !== pop) old.remove(); });
        if (pop.parentElement !== document.body) document.body.append(pop);
      });
      $$('[data-hx-open]').forEach((btn) => {
        if (btn.dataset.hxReady) return;
        btn.dataset.hxReady = '1';
        btn.addEventListener('click', () => {
          const pop = $(`[data-hx-pop="${btn.dataset.hxOpen}"]`);
          if (!pop) return;
          const open = pop.hidden;
          this.closePops();
          if (!open) return;
          if (btn.dataset.hxOpen === 'wish') this.renderWish();
          if (btn.dataset.hxOpen === 'recent') this.renderRecent();
          if (btn.dataset.hxOpen === 'clock') this.renderClock();
          const r = btn.getBoundingClientRect();
          const bar = btn.closest('.thumbbar');
          pop.style.setProperty('--x', `${bar ? window.innerWidth - 12 : Math.min(window.innerWidth - 12, r.right)}px`);
          pop.style.setProperty('--y', `${r.bottom + 10}px`);
          pop.hidden = false;
          // Aus der Daumen-Leiste: Fenster über der Leiste öffnen
          if (bar) pop.style.setProperty('--y', `${Math.max(12, bar.getBoundingClientRect().top - pop.offsetHeight - 12)}px`);
          btn.setAttribute('aria-expanded', 'true');
        });
      });
      if (this.popsBound) return;
      this.popsBound = true;
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-hx-pop], [data-hx-open]')) this.closePops();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closePops(); });
    },
    closePops() {
      $$('[data-hx-pop]').forEach((p) => { p.hidden = true; });
      $$('[data-hx-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    },
    listHtml(items, removable) {
      return items.map((it) => `<li class="hx-item"><a href="${escapeHtml(it.url)}">`
        + `<span class="hx-item__img">${it.img ? `<img src="${escapeHtml(it.img)}" alt="" width="56" height="56" loading="lazy">` : ''}</span>`
        + `<span class="hx-item__text"><span class="hx-item__title">${escapeHtml(it.title)}</span><span class="hx-item__price">${escapeHtml(it.price || '')}</span></span></a>`
        + (removable ? `<button type="button" class="hx-item__remove" data-wish-remove="${escapeHtml(it.handle)}" aria-label="${escapeHtml(theme.strings.hx.wish_remove)}">×</button>` : '')
        + '</li>').join('');
    },

    /* Versand-Ring: füllt sich bis zur Gratis-Versand-Grenze */
    ring() {
      const min = Number(this.cfg.ring) || 0;
      const rings = $$('[data-hx-cart]');
      if (!min || !rings.length) return;
      const goal = Currency.convert(min);
      const p = Math.min(1, this.total / goal);
      const done = p >= 1;
      const key = 'softriot:ship-done';
      let was = false;
      try { was = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, done ? '1' : '0'); } catch (_) { /* egal */ }
      const label = done ? theme.strings.hx.ring_done : theme.strings.hx.ring_left.replace('[betrag]', formatMoney(goal - this.total));
      rings.forEach((el) => {
        el.classList.toggle('has-ring', this.total > 0);
        el.classList.toggle('is-ship-done', done);
        el.style.setProperty('--ship', p);
        el.title = this.total > 0 ? label : '';
        if (done && !was) { el.classList.remove('is-ship-party'); void el.offsetWidth; el.classList.add('is-ship-party'); }
      });
    },
    async refreshCart() {
      try {
        const cart = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        this.total = cart.total_price;
        this.ring();
        $$('[data-hx-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        $$('[data-hx-cart-total]').forEach((el) => { el.textContent = formatMoney(cart.total_price); });
      } catch (_) { /* ohne Ring weiter */ }
    },

    /* „+1“ fällt in die Tasche */
    drop(data) {
      if (!this.cfg?.drop || reducedMotion.matches) return;
      const target = $$('[data-hx-cart]').find((el) => { const r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight; });
      if (!target) return;
      const qty = (data?.items || []).reduce((n, it) => n + (Number(it.quantity) || 1), 0) || 1;
      const r = target.getBoundingClientRect();
      const el = document.createElement('span');
      el.className = 'hx-drop';
      el.textContent = `+${qty}`;
      el.style.left = `${r.left + r.width / 2}px`;
      el.style.top = `${r.top + r.height / 2}px`;
      document.body.append(el);
      el.addEventListener('animationend', () => {
        el.remove();
        target.classList.remove('is-plop');
        void target.offsetWidth;
        target.classList.add('is-plop');
      }, { once: true });
    },

    /* Scheue Icons: weichen der Maus ein paar Pixel aus */
    initShy() {
      if (!this.cfg.shy || this.shyBound || reducedMotion.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      this.shyBound = true;
      document.documentElement.classList.add('hx-shy');
      let raf = 0;
      document.addEventListener('pointermove', (e) => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          $$('.header-pill__end .icon-btn, .header-pill__end .loc-btn').forEach((btn) => {
            const r = btn.getBoundingClientRect();
            const dx = r.left + r.width / 2 - e.clientX;
            const dy = r.top + r.height / 2 - e.clientY;
            const d = Math.hypot(dx, dy);
            const k = d > 22 && d < 90 ? (1 - d / 90) * 6 : 0;
            btn.style.setProperty('--shy-x', `${(dx / (d || 1)) * k}px`);
            btn.style.setProperty('--shy-y', `${(dy / (d || 1)) * k}px`);
          });
        });
      }, { passive: true });
    },

    /* Merkzettel */
    wishes() { return this.store('softriot:wish', []); },
    initWish() {
      if (!this.cfg.wish) return;
      this.syncWish();
      const list = $('[data-hx-list="wish"]');
      if (list && !list.dataset.hxReady) {
        list.dataset.hxReady = '1';
        list.addEventListener('click', (e) => {
          const rm = e.target.closest('[data-wish-remove]');
          if (!rm) return;
          e.preventDefault();
          e.stopPropagation();
          this.save('softriot:wish', this.wishes().filter((w) => w.handle !== rm.dataset.wishRemove));
          this.syncWish();
          this.renderWish();
        });
      }
    },
    toggleWish(btn) {
      const all = this.wishes();
      const has = all.some((w) => w.handle === btn.dataset.handle);
      const next = has ? all.filter((w) => w.handle !== btn.dataset.handle)
        : [{ handle: btn.dataset.handle, title: btn.dataset.title, url: btn.dataset.url, img: btn.dataset.img, price: btn.dataset.price }, ...all].slice(0, 40);
      this.save('softriot:wish', next);
      this.syncWish();
      if (!has && !reducedMotion.matches) {
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
        $$('.hx-wish').forEach((h) => { h.classList.remove('is-plop'); void h.offsetWidth; h.classList.add('is-plop'); });
      }
    },
    syncWish() {
      const all = this.wishes();
      const set = new Set(all.map((w) => w.handle));
      $$('[data-wish-toggle]').forEach((b) => {
        const on = set.has(b.dataset.handle);
        b.setAttribute('aria-pressed', String(on));
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-label', `${on ? theme.strings.hx.wish_remove : theme.strings.hx.wish_add}: ${b.dataset.title}`);
      });
      $$('.hx-wish').forEach((h) => h.style.setProperty('--fill', Math.min(1, all.length / 5)));
      $$('[data-hx-wish-count]').forEach((c) => { c.textContent = all.length; c.hidden = !all.length; });
    },
    renderWish() {
      const all = this.wishes();
      const list = $('[data-hx-list="wish"]');
      if (list) list.innerHTML = this.listHtml(all, true);
      const empty = $('[data-hx-empty="wish"]');
      if (empty) empty.hidden = all.length > 0;
    },

    /* Zuletzt angesehen: Produktseite merkt sich das Produkt, das Auge zeigt die letzten */
    initRecent() {
      const item = $('[data-hx-recent-item]');
      let all = this.store('softriot:recent', []);
      if (item) {
        try {
          const it = JSON.parse(item.textContent);
          all = [it, ...all.filter((r) => r.handle !== it.handle)].slice(0, 12);
          this.save('softriot:recent', all);
          this.currentHandle = it.handle;
        } catch (_) { /* egal */ }
      }
      const others = all.filter((r) => r.handle !== this.currentHandle);
      $$('.hx-recent').forEach((b) => { b.hidden = !this.cfg.recent || !others.length; });
    },
    renderRecent() {
      const list = $('[data-hx-list="recent"]');
      if (!list) return;
      const all = this.store('softriot:recent', []).filter((r) => r.handle !== this.currentHandle).slice(0, this.cfg.recent || 3);
      list.innerHTML = this.listHtml(all, false);
      const empty = $('[data-hx-empty="recent"]');
      if (empty) empty.hidden = all.length > 0;
    },

    /* Werkstatt-Status als Punkt am Logo oder Konto */
    initDot() {
      const dots = $$('[data-hx-dot]');
      const cfg = HeaderExtras.config?.status;
      if (!dots.length || !cfg) return;
      const update = () => {
        const { day, hour } = HeaderExtras.berlinNow();
        const [first, last] = String(cfg.days).split('-').map(Number);
        const vac = TM.vacation();
        const open = !vac && day >= first && day <= last && hour >= cfg.from && hour < cfg.to;
        dots.forEach((d) => {
          d.hidden = false;
          d.classList.toggle('is-open', open);
          d.classList.toggle('is-vacation', Boolean(vac));
          d.title = open ? (cfg.open || '') : (cfg.closed || '');
        });
      };
      update();
      clearInterval(this.dotTimer);
      this.dotTimer = setInterval(update, 5 * 60 * 1000);
    },

    /* Lieferuhr: „Jetzt bestellt, Versand morgen“ */
    shipDay() {
      const c = this.cfg.clock;
      const [first, last] = String(c.days).split('-').map(Number);
      const isShip = (d) => d >= first && d <= last;
      let { day, hour } = HeaderExtras.berlinNow();
      let add = 0;
      // Im Werkstatt-Urlaub zählt erst der Tag nach dem Urlaub (Zeit: Seite & Tageszeit)
      const vac = TM.vacation();
      if (vac) {
        const back = TM.parts(vac.endMs + 60000);
        const nowP = TM.parts();
        add = Math.round((Date.UTC(back.y, back.m - 1, back.d) - Date.UTC(nowP.y, nowP.m - 1, nowP.d)) / 864e5);
        day = (day + add) % 7;
        hour = 0;
      }
      if (!(isShip(day) && hour < c.cutoff)) { add += 1; day = (day + 1) % 7; while (!isShip(day)) { add += 1; day = (day + 1) % 7; } }
      if (Number(c.offset) === 1) { add += 1; day = (day + 1) % 7; while (!isShip(day)) { add += 1; day = (day + 1) % 7; } }
      const t = theme.strings.hx;
      if (add === 0) return t.today;
      if (add === 1) return t.tomorrow;
      const when = new Date(Date.now() + add * 864e5);
      const name = new Intl.DateTimeFormat(document.documentElement.lang || 'de', { weekday: 'long', timeZone: 'Europe/Berlin' }).format(when);
      return t.on_day.replace('[tag]', name);
    },
    initClock() {
      if (this.cfg.clock) this.renderClock();
    },
    renderClock() {
      const c = this.cfg.clock;
      if (!c) return;
      const text = $('[data-hx-clock-text]');
      const note = $('[data-hx-clock-note]');
      if (text) text.textContent = String(c.text || '').replace('[tag]', this.shipDay()).replace('[uhrzeit]', c.cutoff);
      if (note) note.textContent = String(c.note || '').replace('[uhrzeit]', c.cutoff).replace('[tag]', this.shipDay());
      const btn = $('.hx-clock');
      if (btn && text) btn.title = text.textContent;
    },

    /* Wisch-Header (Handy): Konto ← Suche ← Start → Warenkorb */
    /* In der App meldet man sich über das native Kundenkonto an; der Shop selbst kennt die Anmeldung dann nicht.
       Ist man in der App angemeldet, zeigt das Konto-Feld den Gruß (Vorname von der Kontoseite, nur auf dem Gerät). */
    appGreeting(wrap) {
      const acct = $('[data-hx-panel="account"]', wrap);
      const C = window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Checkout;
      const target = document.documentElement.getAttribute('data-app-account');
      if (!acct || !C || !C.authState || !target) return;
      C.authState().then((r) => {
        let name = '';
        try {
          if (!r || !r.signedIn) { localStorage.removeItem('lorayn:first-name'); return; }
          name = localStorage.getItem('lorayn:first-name') || '';
        } catch (e) {
          if (!r || !r.signedIn) return;
        }
        const a = document.createElement('a');
        a.href = target;
        a.className = 'hx-swipe__link';
        a.tabIndex = acct.classList.contains('is-on') ? 0 : -1;
        const icon = acct.querySelector('svg');
        if (icon) a.append(icon.cloneNode(true));
        a.append(name ? acct.dataset.hxHi.replace('[name]', name) : acct.dataset.hxHiNone);
        acct.replaceChildren(a);
      }).catch(() => {});
    },

    initSwipe() {
      const wrap = $('[data-hx-swipe]');
      if (!this.cfg.swipe || !wrap || wrap.dataset.hxReady) return;
      wrap.dataset.hxReady = '1';
      const pill = wrap.closest('.header-pill');
      this.appGreeting(wrap);
      const order = ['account', 'search', 'home', 'cart'];
      let idx = 2;
      let timer = 0;
      const dots = $$('.hx-swipe__dots i', wrap);
      const show = (i) => {
        idx = Math.max(0, Math.min(order.length - 1, i));
        const name = order[idx];
        pill.dataset.hxPanel = name;
        $$('[data-hx-panel]', wrap).forEach((p) => {
          const on = p.dataset.hxPanel === name;
          p.classList.toggle('is-on', on);
          $$('input, a', p).forEach((f) => { f.tabIndex = on ? 0 : -1; });
        });
        dots.forEach((d, j) => d.classList.toggle('is-on', j === idx));
        clearTimeout(timer);
        if (name !== 'home') timer = setTimeout(() => { if (!wrap.contains(document.activeElement)) show(2); }, 8000);
      };
      let x0 = null;
      let y0 = 0;
      pill.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      pill.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        show(idx + (dx > 0 ? -1 : 1));
        if (navigator.vibrate) navigator.vibrate(8);
      }, { passive: true });
      document.addEventListener('click', (e) => { if (idx !== 2 && !pill.contains(e.target)) show(2); });
    },

    /* Fächermenü: lange auf „Menü“ in der Daumen-Leiste drücken */
    initFan() {
      const btn = $('[data-hx-fan-btn]');
      const fan = $('[data-hx-fan]');
      if (!this.cfg.fan || !btn || !fan || btn.dataset.hxReady) return;
      btn.dataset.hxReady = '1';
      // Knöpfe auf zwei versetzten Bögen, damit sich auch lange Namen nicht überlappen
      const links = $$('.hx-fan__link', fan);
      const place = () => {
        const step = links.length > 1 ? 150 / (links.length - 1) : 0;
        const half = window.innerWidth / 2;
        links.forEach((a, i) => {
          const ang = ((links.length > 1 ? -165 + i * step : -90) * Math.PI) / 180;
          const r = links.length > 3 && i % 2 ? 178 : 112;
          const w = a.offsetWidth / 2 + 10;
          const x = Math.max(-half + w, Math.min(half - w, Math.cos(ang) * r * 1.1));
          a.style.setProperty('--fx', `${x}px`);
          a.style.setProperty('--fy', `${Math.sin(ang) * r}px`);
        });
      };
      let timer = 0;
      let opened = false;
      const close = () => { fan.hidden = true; fan.classList.remove('is-open'); };
      btn.addEventListener('pointerdown', () => {
        opened = false;
        timer = setTimeout(() => {
          opened = true;
          fan.hidden = false;
          place();
          requestAnimationFrame(() => fan.classList.add('is-open'));
          if (navigator.vibrate) navigator.vibrate(12);
        }, 450);
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach((ev) => btn.addEventListener(ev, () => clearTimeout(timer)));
      btn.addEventListener('contextmenu', (e) => e.preventDefault());
      // Nach langem Drücken öffnet der Klick nicht das große Menü
      document.addEventListener('click', (e) => {
        if (opened && e.target.closest('[data-hx-fan-btn]')) { e.preventDefault(); e.stopImmediatePropagation(); opened = false; return; }
        if (!fan.hidden && !e.target.closest('[data-hx-fan]')) close();
      }, true);
    }
  };

  /* ---------- Header-Varianten (Theme-Einstellungen → Header: Variante) ---------- */
  const HeaderVariant = {
    bound: false,
    init() {
      const header = $('[data-header]');
      if (!header) return;
      this.header = header;
      this.pill = $('.header-pill', header);
      this.initToggles();
      this.initSplit();
      this.initDial();
      this.initShape();
      if (this.bound) return;
      this.bound = true;
      // Offene Insel, Reiter oder Wählscheibe schließen: Klick daneben oder Escape
      document.addEventListener('click', (e) => {
        $$('[data-hv-island].is-open, [data-hv-tab].is-open, [data-hv-dial].is-open').forEach((box) => {
          if (!box.contains(e.target)) this.setOpen(box, false);
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') $$('[data-hv-island].is-open, [data-hv-tab].is-open, [data-hv-dial].is-open').forEach((box) => this.setOpen(box, false));
      });
    },
    setOpen(box, open) {
      box.classList.toggle('is-open', open);
      const btn = $('[data-hv-toggle]', box);
      if (btn) btn.setAttribute('aria-expanded', String(open));
      const panel = $('[data-hv-panel]', box);
      if (panel) panel.hidden = !open;
    },
    initToggles() {
      // Der Reiter hängt am <body>, damit er auch bei verschobenem Header am Rand klebt
      $$('body > [data-hv-tab]').forEach((old) => old.remove());
      const tab = $('[data-hv-tab]', this.header);
      if (tab) document.body.append(tab);
      $$('[data-hv-island], [data-hv-tab], [data-hv-dial]').forEach((box) => {
        const btn = $('[data-hv-toggle]', box);
        if (!btn || btn.dataset.hvReady) return;
        btn.dataset.hvReady = '1';
        btn.addEventListener('click', () => this.setOpen(box, !box.classList.contains('is-open')));
        // Nach einem Klick auf einen Eintrag (Menü, Suche …) wieder zuklappen
        box.addEventListener('click', (e) => {
          if (e.target.closest('a, [data-menu-open], [data-cart-open]') && !e.target.closest('[data-hv-toggle]')) this.setOpen(box, false);
        });
      });
    },

    /* Geteilt: Breite der beiden Glas-Flächen messen, beim Scrollen verschmelzen */
    initSplit() {
      if (!this.header.classList.contains('hv--split')) return;
      const measure = () => {
        const pill = this.pill;
        const logo = $('.logo', pill);
        const end = $('.header-pill__end', pill);
        if (!logo || !end) return;
        const p = pill.getBoundingClientRect();
        pill.style.setProperty('--hv-l', `${Math.round(logo.getBoundingClientRect().right - p.left + 18)}px`);
        pill.style.setProperty('--hv-r', `${Math.round(p.right - end.getBoundingClientRect().left + 8)}px`);
      };
      const update = () => {
        const merged = document.body.classList.contains('is-scrolled');
        if (merged !== this.header.classList.contains('is-merged')) this.header.classList.toggle('is-merged', merged);
        if (!merged) measure();
      };
      measure();
      document.fonts?.ready.then(measure);
      window.addEventListener('resize', measure, { passive: true });
      new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      update();
    },

    /* Wählscheibe: Menüpunkte auf einem Viertelkreis unter dem Knopf verteilen */
    initDial() {
      const dial = $('[data-hv-dial]', this.header);
      if (!dial) return;
      const links = $$('.hv-link', dial);
      const small = window.matchMedia('(max-width: 749px)').matches;
      const r = small ? 70 : 92;
      const from = -12;
      const to = 80;
      links.forEach((a, i) => {
        const ang = ((links.length > 1 ? from + ((to - from) * i) / (links.length - 1) : 40) * Math.PI) / 180;
        // Spirale: jeder Punkt etwas weiter außen, so überlappen sich auch lange Namen nicht
        const rr = r + i * (small ? 16 : 22);
        a.style.setProperty('--dx', `${Math.cos(ang) * rr + (a.offsetWidth || 80) / 2 - 10}px`);
        a.style.setProperty('--dy', `${Math.sin(ang) * rr}px`);
        a.style.setProperty('--i', i);
      });
    },

    /* Formwandler: Produkt mit Kaufen-Knopf bzw. Versand-Fortschritt in der Pille */
    initShape() {
      const shape = $('[data-hv-shape]', this.header);
      if (!shape || shape.dataset.hvReady) return;
      shape.dataset.hvReady = '1';
      const pill = this.pill;
      const pdp = $('[data-hv-pane="pdp"]', shape);
      const cartPane = $('[data-hv-pane="cart"]', shape);
      const set = (name) => {
        if (name) pill.dataset.hvPane = name;
        else delete pill.dataset.hvPane;
        const buy = $('[data-hv-buy]', shape);
        if (buy) buy.tabIndex = name === 'pdp' ? 0 : -1;
      };
      if (pdp) {
        const sticky = $('[data-sticky-buy]');
        $('[data-hv-buy]', pdp)?.addEventListener('click', () => $('[data-add-button]', sticky)?.click());
        document.addEventListener('stickybuy:change', (e) => set(e.detail.visible ? 'pdp' : null));
        const price = $('[data-sticky-price]', sticky);
        const btnSrc = $('[data-add-button]', sticky);
        const sync = () => {
          $('[data-hv-price]', pdp).textContent = price?.textContent || '';
          const b = $('[data-hv-buy]', pdp);
          b.disabled = Boolean(btnSrc?.disabled);
          b.textContent = $('[data-add-label]', sticky)?.textContent.trim() || b.textContent;
        };
        if (price) new MutationObserver(sync).observe(sticky, { subtree: true, childList: true, characterData: true, attributes: true });
        if (sticky?.dataset.visible) set('pdp');
      }
      if (cartPane) {
        const goal = Currency.convert(Number(cartPane.dataset.goal) || 0);
        let total = Number(cartPane.dataset.total) || 0;
        const render = () => {
          const missing = goal - total;
          $('[data-hv-ship-text]', cartPane).textContent = missing > 0
            ? theme.strings.hx.ring_left.replace('[betrag]', formatMoney(missing))
            : theme.strings.hx.ring_done;
          cartPane.style.setProperty('--p', Math.min(1, total / goal));
        };
        const onScroll = () => set(document.body.classList.contains('is-scrolled') ? 'cart' : null);
        new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        document.addEventListener('cart:changed', async () => {
          try { total = (await fetch(`${theme.routes.cart}.js`).then((r) => r.json())).total_price; render(); } catch (_) { /* egal */ }
        });
        render();
        onScroll();
      }
    }
  };

  /* ---------- App-Modus (App „Lorayn Brawley“, html.is-app) ----------
     Die App fängt „Zur Kasse“ ab und öffnet die Kasse nativ; die Seite wird dabei nie verlassen.
     Damit der Knopf nicht hängen bleibt, meldet die App den Zustand als Ereignis „lorayn:checkout“
     (opened, canceled, failed, completed). Ohne Meldung wird der Knopf nach 12 s zurückgesetzt. */
  /* ---------- App: Extras (Theme-Einstellungen „App: Extras“) ----------
     In der App: Willkommenscode und Aktionscode (automatisch im Warenkorb), Schütteln/Glücksrad, Aktions-Countdown als
     Live-Aktivität, Saison-Icon, Schnellaktionen, Spotlight, Siri-Pfade, Werkstatt-Ping, Usedom-Moment, Stempelkarte.
     Im Browser: Hinweis auf die App und „Drops zuerst in der App“. Jede App-Funktion prüft, ob die App sie kennt. */
  const AppExtras = {
    cfg: null,

    init() {
      try { this.cfg = JSON.parse($('#AppExtrasConfig')?.textContent || 'null'); } catch (_) { this.cfg = null; }
      if (!this.cfg) return;
      const app = document.documentElement.classList.contains('is-app');
      if (!app) {
        this.early();
        this.owl(false);
        this.webHint();
        return;
      }
      this.P = (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.AppBridge) || null;
      this.owl(true);
      this.earlyApp();
      this.yearHint();
      this.codes();
      this.game();
      this.sale();
      this.native();
      const via = new URLSearchParams(location.search).get('app');
      if (via === 'wish' || via === 'recent') {
        setTimeout(() => $(`[data-hx-open="${via}"]`)?.click(), 400);
      } else if (via === 'mood') {
        setTimeout(() => $('[data-mood]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 400);
      }
    },

    store(key, value) {
      try {
        if (value === undefined) return JSON.parse(localStorage.getItem(`lb_x_${key}`) || 'null');
        localStorage.setItem(`lb_x_${key}`, JSON.stringify(value));
      } catch (_) { /* Speicher blockiert */ }
      return null;
    },

    /* Kleine Karte unten (Code, Gewinn, Hinweis). `html` ist schon escaped. */
    card(html, cls = '') {
      $('.app-x-card')?.remove();
      const el = document.createElement('div');
      el.className = `app-x-card ${cls}`;
      el.setAttribute('role', 'dialog');
      el.innerHTML = `<button type="button" class="app-x-card__close" aria-label="${escapeHtml(this.cfg.strings.close)}">×</button>${html}`;
      document.body.appendChild(el);
      requestAnimationFrame(() => el.classList.add('is-open'));
      const close = () => { el.classList.remove('is-open'); setTimeout(() => el.remove(), 300); };
      $('.app-x-card__close', el).addEventListener('click', close);
      $$('[data-x-copy]', el).forEach((b) => b.addEventListener('click', () => {
        navigator.clipboard?.writeText(b.dataset.xCopy).then(() => { b.textContent = this.cfg.strings.copied; }).catch(() => {});
      }));
      return el;
    },

    codeHtml(code) {
      const c = escapeHtml(code);
      return `<p class="app-x-card__code"><span>${c}</span><button type="button" data-x-copy="${c}">${escapeHtml(this.cfg.strings.copy)}</button></p>`;
    },

    /* Codes, die in der App automatisch im Warenkorb landen (Willkommen, Aktion, Gewinne). Die Kasse der App übernimmt
       die Codes des Warenkorbs; Shopify entscheidet, welche zusammen gelten. */
    wanted() {
      const list = [];
      const w = this.store('welcome');
      if (w && w.code) list.push(w.code);
      const p = this.cfg.promo;
      if (p.code && TM.win(p.from, p.to)) list.push(p.code);
      const g = this.store('prize');
      if (g && g.code && g.until > Date.now()) list.push(g.code);
      const o = this.cfg.owl;
      if (o && o.on && o.code && this.owlOpen()) list.push(o.code);
      return list;
    },

    async sync() {
      const want = this.wanted();
      if (!want.length) return;
      try {
        const cart = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        if (!cart.item_count) return;
        const have = (cart.discount_codes || []).map((c) => c.code);
        const missing = want.filter((c) => !have.some((h) => h.toLowerCase() === c.toLowerCase()));
        if (missing.length) await applyCodes([...have, ...missing]);
      } catch (_) { /* nächster Versuch beim nächsten Warenkorb-Ereignis */ }
    },

    codes() {
      const c = this.cfg;
      const sync = () => this.sync();
      document.addEventListener('cart:added', sync);
      document.addEventListener('cart:changed', sync);
      // Vor der Kasse noch einmal, falls der Warenkorb aus einer älteren Sitzung stammt
      document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('[name="checkout"]')) sync(); }, true);

      if (c.welcome && this.P && this.P.welcomeCode) {
        const known = this.store('welcome');
        const show = (code) => {
          if (this.store('welcome_seen')) return;
          this.store('welcome_seen', true);
          this.card(`<p class="app-x-card__title">${escapeHtml(c.welcomeTitle)}</p><p>${escapeHtml(c.welcomeText)}</p>${this.codeHtml(code)}`, 'is-gift');
        };
        if (known && known.code) {
          show(known.code);
        } else {
          this.P.welcomeCode().then((r) => {
            if (!r || !r.code) return;
            this.store('welcome', { code: r.code });
            show(r.code);
            sync();
          }).catch(() => {});
        }
      }

      const p = c.promo;
      if (p.code && TM.win(p.from, p.to) && !$('.app-x-promo')) {
        const bar = document.createElement('div');
        bar.className = 'app-x-promo';
        const text = escapeHtml(p.text || '{code}').split('{code}').join(`<b>${escapeHtml(p.code)}</b>`);
        bar.innerHTML = `<span>${text}</span>`;
        document.body.appendChild(bar);
      }
      sync();
    },

    /* Gewinne: „Text | CODE | Gewicht“ je Zeile */
    prizes() {
      return String(this.cfg.game.prizes || '').split(/\r?\n/).map((line) => {
        const [label, code, weight] = line.split('|').map((x) => (x || '').trim());
        return { label, code, weight: Math.max(0, Number(weight) || 1) };
      }).filter((p) => p.label);
    },

    nextPlay() {
      const last = this.store('played');
      if (!last) return 0;
      const every = this.cfg.game.every;
      if (every === 'once') return Infinity;
      const p = TM.parts(last);
      const days = every === 'week' ? 7 : 1;
      return TM.at(p.y, p.m, p.d) + days * 864e5;
    },

    game() {
      const g = this.cfg.game;
      const s = this.cfg.strings;
      const prizes = this.prizes();
      if (g.kind === 'off' || !prizes.length || !TM.win(g.from, g.to)) return;
      const draw = () => {
        const total = prizes.reduce((n, p) => n + p.weight, 0) || 1;
        let r = Math.random() * total;
        return prizes.find((p) => (r -= p.weight) < 0) || prizes[prizes.length - 1];
      };
      const result = (prize) => {
        this.store('played', TM.now());
        if (prize.code) {
          this.store('prize', { code: prize.code, until: Date.now() + 7 * 864e5 });
          this.sync();
        }
        const haptic = window.Capacitor?.Plugins?.Haptics;
        haptic?.notification({ type: prize.code ? 'SUCCESS' : 'WARNING' }).catch(() => {});
        const next = this.nextPlay();
        const again = Number.isFinite(next) ? `<p class="app-x-card__small">${escapeHtml(s.again.replace('{date}', TM.dateText(next)))}</p>` : '';
        this.card(`<p class="app-x-card__title">${escapeHtml(prize.label)}</p>${prize.code ? `<p>${escapeHtml(s.won)}</p>${this.codeHtml(prize.code)}` : ''}${again}`, prize.code ? 'is-gift' : '');
      };
      const ready = () => TM.now() >= this.nextPlay();

      // Knopf unten links; im Glücksrad-Modus öffnet er das Rad, beim Schütteln erklärt er das Spiel
      const fab = document.createElement('button');
      fab.type = 'button';
      fab.className = 'app-x-fab';
      fab.textContent = g.kind === 'wheel' ? '🎡' : '📳';
      fab.setAttribute('aria-label', g.title);
      fab.hidden = !ready();
      document.body.appendChild(fab);

      if (g.kind === 'shake') {
        let busy = false;
        const onShake = () => {
          if (busy || !ready()) return;
          busy = true;
          fab.hidden = true;
          window.Capacitor?.Plugins?.Haptics?.vibrate({ duration: 400 }).catch(() => {});
          setTimeout(() => { result(draw()); busy = false; }, 700);
        };
        if (this.P && this.P.shake) {
          this.P.addListener('shake', onShake);
          this.P.shake({ on: true }).catch(() => {});
        }
        fab.addEventListener('click', () => {
          this.card(`<p class="app-x-card__title">${escapeHtml(g.title)}</p><p>${escapeHtml(s.shake)} 📳</p>`);
        });
        return;
      }

      // Glücksrad: Felder aus den Gewinnen, Drehung per CSS
      fab.addEventListener('click', () => {
        const n = prizes.length;
        const colors = ['var(--c-accent)', 'var(--c-text)'];
        const stops = prizes.map((_, i) => `${colors[i % 2]} ${(i * 360) / n}deg ${((i + 1) * 360) / n}deg`).join(',');
        const labels = prizes.map((p, i) => `<span style="--a:${(i + 0.5) * (360 / n)}deg;color:${i % 2 ? 'var(--c-bg)' : 'var(--c-on-accent)'}">${escapeHtml(p.label.slice(0, 18))}</span>`).join('');
        const el = this.card(`<p class="app-x-card__title">${escapeHtml(g.title)}</p><div class="app-x-wheel"><div class="app-x-wheel__disc" style="background:conic-gradient(${stops})">${labels}</div><i class="app-x-wheel__pin"></i></div><button type="button" class="button app-x-wheel__go">${escapeHtml(s.spin)}</button>`, 'is-wheel');
        $('.app-x-wheel__go', el).addEventListener('click', (e) => {
          e.currentTarget.disabled = true;
          const prize = draw();
          const i = prizes.indexOf(prize);
          const disc = $('.app-x-wheel__disc', el);
          disc.style.transform = `rotate(${5 * 360 + 360 - (i + 0.5) * (360 / n)}deg)`;
          const H = window.Capacitor?.Plugins?.Haptics;
          let ticks = 0;
          const t = setInterval(() => { H?.selectionChanged?.().catch(() => {}); if (++ticks > 20) clearInterval(t); }, 150);
          fab.hidden = true;
          setTimeout(() => result(prize), 4200);
        });
      });
    },

    /* Aktions-Countdown: Leiste in den letzten 8 Stunden, „Live verfolgen“ startet die Live-Aktivität */
    sale() {
      const c = this.cfg.sale;
      const s = this.cfg.strings;
      const end = c.title && c.to ? TM.parse(c.to, true) : null;
      if (!end || end.ms <= TM.now() || end.ms - TM.now() > 8 * 3600e3) return;
      const bar = document.createElement('div');
      bar.className = 'app-x-sale';
      bar.innerHTML = `<span><b>${escapeHtml(c.title)}</b> ${escapeHtml(s.endsIn)} <time></time></span>`;
      const time = $('time', bar);
      const tick = () => {
        const left = end.ms - TM.now();
        if (left <= 0) { bar.remove(); return; }
        time.textContent = TM.left(left);
        setTimeout(tick, 1000);
      };
      tick();
      if (c.link) bar.addEventListener('click', (e) => { if (!e.target.closest('button')) location.href = c.link; });
      document.body.appendChild(bar);
      if (!this.P || !this.P.saleLive) return;
      const args = { title: c.title, at: end.ms, url: new URL(c.link || '/', location.origin).toString(), color: getComputedStyle(document.documentElement).getPropertyValue('--c-accent').trim() };
      const btn = document.createElement('button');
      btn.type = 'button';
      const show = (r) => {
        btn.textContent = r && r.active ? s.liveOn : s.live;
        btn.setAttribute('aria-pressed', r && r.active ? 'true' : 'false');
      };
      this.P.saleLive({ ...args, action: 'status' }).then((r) => {
        if (!r || !r.supported) return;
        show(r);
        bar.appendChild(btn);
        btn.addEventListener('click', () => {
          const action = btn.getAttribute('aria-pressed') === 'true' ? 'stop' : 'start';
          this.P.saleLive({ ...args, action }).then(show).catch(() => {});
        });
      }).catch(() => {});
    },

    /* Saison-Icon nach den Zeitfenstern; '' = keins (dann gilt „App-Icon“ aus der Gruppe App) */
    seasonIcon() {
      if (!this.cfg) { try { this.cfg = JSON.parse($('#AppExtrasConfig')?.textContent || 'null'); } catch (_) { return ''; } }
      const se = this.cfg && this.cfg.season;
      if (!se || !se.on) return '';
      return ['xmas', 'halloween', 'valentine'].find((k) => se[k] && (se[k][0] || se[k][1]) && TM.win(se[k][0], se[k][1])) || '';
    },

    /* Daten für native Teile: Schnellaktionen, Spotlight, Siri, Werkstatt-Ping, Usedom-Moment */
    native() {
      if (!this.P || !this.P.extras) return;
      const c = this.cfg;
      const st = HeaderExtras.config && HeaderExtras.config.status;
      const abs = (u) => { try { return new URL(u, location.origin).pathname + new URL(u, location.origin).search; } catch (_) { return ''; } };
      this.P.extras({
        quick: c.quick.map((q) => ({ title: q.title, path: abs(q.url) })).filter((q) => q.path),
        spotlight: c.spotlight,
        paths: c.paths,
        ping: c.ping.on && st ? { days: String(st.days), from: Number(st.from), title: c.ping.title, text: c.ping.text } : null,
        geo: c.geo.on && c.geo.lat && c.geo.lng ? { lat: c.geo.lat, lng: c.geo.lng, radius: c.geo.radius, title: c.geo.title, text: c.geo.text, path: c.geo.link ? abs(c.geo.link) : '' } : null,
        status: st ? { days: String(st.days), from: Number(st.from), to: Number(st.to), open: st.open || '', closed: st.closed || '' } : null,
        vacation: !!TM.vacation(),
        owl: !!this.owlVisit
      }).catch(() => {});
    },

    /* Browser: Drop zuerst in der App → Hinweis statt Inhalt bis „Im Browser erst ab“ */
    early() {
      const e = this.cfg.early;
      if (!e.here && !this.earlyMissing()) return;
      const until = TM.parse(e.until);
      if (!until || TM.now() >= until.ms) return;
      const main = $('#MainContent') || $('main');
      if (!main) return;
      const box = document.createElement('div');
      box.className = 'app-x-early';
      box.innerHTML = `<p>${escapeHtml(e.text.replace('{date}', `${TM.dateText(until.ms)}, ${TM.parts(until.ms).h}:${String(TM.parts(until.ms).mi).padStart(2, '0')}`))}</p>${this.storeLinks()}`;
      main.classList.add('is-app-only');
      main.prepend(box);
    },

    /* Nachteulen-Shop: Kollektion nur im Zeitfenster (deutsche Zeit) und nur in der App */
    owlOpen(ms = TM.now()) {
      const o = this.cfg.owl;
      const h = TM.parts(ms).h;
      return o.from < o.to ? h >= o.from && h < o.to : h >= o.from || h < o.to;
    },

    /* nächste Öffnungen (für Erinnerungen), höchstens `n` */
    owlStarts(n) {
      const o = this.cfg.owl;
      const p = TM.parts();
      const list = [];
      for (let i = 0; i <= n && list.length < n; i += 1) {
        const ms = TM.at(p.y, p.m, p.d, o.from % 24) + i * 864e5;
        if (ms > TM.now()) list.push(ms);
      }
      return list;
    },

    owl(app) {
      const o = this.cfg.owl;
      if (!o || !o.on) return;
      const s = this.cfg.strings;
      const open = app && this.owlOpen();
      if (open) {
        this.owlVisit = true;
        // Banner einmal pro Nacht, auf der Kollektion selbst nicht
        const night = TM.parts(TM.now() - 12 * 3600e3);
        const key = `${night.y}-${night.m}-${night.d}`;
        if (!o.here && this.store('owl_seen') !== key) {
          this.store('owl_seen', key);
          const link = o.url ? `<p class="app-x-card__links"><a class="button" href="${escapeHtml(o.url)}">${escapeHtml(s.owlGo)}</a></p>` : '';
          const el = this.card(`<p class="app-x-card__title">${escapeHtml(o.title)}</p><p>${escapeHtml(o.text)}</p>${o.code ? this.codeHtml(o.code) : ''}${link}`, 'is-owl');
          el.style.cssText = 'background:#11132a;color:#f4efe6;border-color:#2c2f5a';
          window.Capacitor?.Plugins?.Haptics?.impact({ style: 'LIGHT' }).catch(() => {});
        }
        return;
      }
      if (!o.here) return;
      // Kollektion bzw. Produkt außerhalb der Zeit oder im Browser: Hinweis statt Inhalt
      const main = $('#MainContent') || $('main');
      if (!main) return;
      const box = document.createElement('div');
      box.className = 'app-x-early is-owl';
      box.innerHTML = `<p>🦉 ${escapeHtml(o.hint.replace('{from}', o.from).replace('{to}', o.to))}</p>${app ? '' : this.storeLinks()}`;
      main.classList.add('is-app-only');
      main.prepend(box);
      if (!app || !o.push || !this.P || !this.P.reminders) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button';
      const set = (on) => { btn.setAttribute('aria-pressed', String(on)); btn.textContent = on ? s.owlRemindOn : s.owlRemind; };
      set(false);
      box.appendChild(btn);
      this.P.reminders({ id: 'owl', query: true }).then((r) => set(!!(r && r.count))).catch(() => {});
      btn.addEventListener('click', () => {
        const on = btn.getAttribute('aria-pressed') !== 'true';
        const path = new URL(o.url || location.pathname, location.origin).pathname;
        const items = on ? this.owlStarts(14).map((at) => ({ at, title: o.title, text: s.owlPush, path })) : [];
        this.P.reminders({ id: 'owl', items }).then((r) => {
          set(!!(r && r.count));
          if (on && r && r.count) window.Capacitor?.Plugins?.Haptics?.impact({ style: 'MEDIUM' }).catch(() => {});
        }).catch(() => {});
      });
    },

    /* Seite nicht gefunden, weil das Teil noch nur im Kanal „Headless“ ist: Produkt- bzw. Early-Kollektions-Adresse
       während des Early Access → Handle des Produkts ('' = Kollektion), sonst null */
    earlyMissing() {
      const e = this.cfg.early;
      if (!e.missing || !e.coll) return null;
      const from = TM.parse(e.from || e.until);
      const until = TM.parse(e.until);
      if (!from || TM.now() < from.ms - 3600e3 || (until && TM.now() >= until.ms)) return null;
      const m = e.path.match(/\/products\/([a-z0-9-]+)\/?$/);
      if (m) return m[1];
      return e.path.replace(/\/$/, '').endsWith(`/collections/${e.coll}`) ? '' : null;
    },

    /* App: Early Access (Einstellung „Early Access in der App ab“). Auf der Kollektion bzw. auf einem noch nicht
       veröffentlichten Produkt übernimmt die eigene Ansicht (assets/early-access.js), sonst einmal ein Hinweis. */
    earlyApp() {
      const e = this.cfg.early;
      const C = window.Capacitor?.Plugins?.Checkout;
      if (!e.coll || !e.from || !C || !C.early) return;
      const from = TM.parse(e.from);
      const until = TM.parse(e.until);
      if (!from || (until && TM.now() >= until.ms)) return;
      const missing = this.earlyMissing();
      if (e.here || missing !== null) {
        const main = $('#MainContent') || $('main');
        if (!main) return;
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = e.css;
        document.head.appendChild(css);
        const js = document.createElement('script');
        js.src = e.js;
        js.onload = () => window.LoraynEarly && window.LoraynEarly.mount(main, {
          collection: e.coll, product: missing || '', from: from.ms, strings: this.cfg.strings, codes: this.wanted(),
          dateText: (ms) => `${TM.dateText(ms)}, ${TM.parts(ms).h}:${String(TM.parts(ms).mi).padStart(2, '0')}`, now: () => TM.now()
        });
        document.head.appendChild(js);
        return;
      }
      if (TM.now() < from.ms || this.store('early_seen') === e.from) return;
      this.store('early_seen', e.from);
      const link = e.url ? `<p class="app-x-card__links"><a class="button" href="${escapeHtml(e.url)}">${escapeHtml(this.cfg.strings.earlyGo)}</a></p>` : '';
      this.card(`<p class="app-x-card__title">${escapeHtml(e.title)}</p>${link}`, 'is-gift');
    },

    /* „Dein Jahr bei Lorayn“: vom 1.12. bis 15.1. einmal pro Saison eine Karte */
    yearHint() {
      const y = this.cfg.year;
      if (!y || !y.url || !TM.win('01.12.', '15.01.') || location.pathname === y.url || $('.app-x-card')) return;
      const p = TM.parts();
      const season = p.m === 1 ? p.y - 1 : p.y;
      if (this.store('year_seen') === season) return;
      this.store('year_seen', season);
      this.card(`<p class="app-x-card__title">${escapeHtml(y.text)}</p><p class="app-x-card__links"><a class="button" href="${escapeHtml(y.url)}">${escapeHtml(this.cfg.strings.yearGo)}</a></p>`, 'is-gift');
    },

    storeLinks() {
      const w = this.cfg.web;
      const a = (url, label) => (url ? `<a class="button" href="${escapeHtml(url)}" target="_blank" rel="noopener">${escapeHtml(label)}</a>` : '');
      const ua = navigator.userAgent;
      if (/iPhone|iPad|iPod/.test(ua)) return a(w.ios, this.cfg.strings.get);
      if (/Android/.test(ua)) return a(w.android, this.cfg.strings.get);
      return `${a(w.ios, 'App Store')}${a(w.android, 'Google Play')}`;
    },

    /* Browser: Hinweis auf den App-Rabatt, schließbar (merkt sich das für 14 Tage) */
    webHint() {
      const w = this.cfg.web;
      if (!w.on || !(w.ios || w.android)) return;
      const closed = this.store('hint');
      if (closed && Date.now() - closed < 14 * 864e5) return;
      const links = this.storeLinks();
      if (!links) return;
      const el = this.card(`<p class="app-x-card__title">${escapeHtml(w.text)}</p><p class="app-x-card__links">${links}</p>`, 'is-hint');
      $('.app-x-card__close', el).addEventListener('click', () => this.store('hint', Date.now()));
    }
  };

  const AppMode = {
    init() {
      if (!document.documentElement.classList.contains('is-app')) return;
      this.accountLinks();
      this.native();
      this.push();
      this.settings();
      this.bridge();
      let timer;
      const reset = () => {
        clearTimeout(timer);
        $$('[name="checkout"].is-loading').forEach((b) => {
          b.classList.remove('is-loading');
          b.removeAttribute('aria-busy');
        });
      };
      document.addEventListener('submit', (e) => {
        const btn = e.submitter;
        if (!btn || btn.name !== 'checkout') return;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        clearTimeout(timer);
        timer = setTimeout(reset, 12000);
      });
      window.addEventListener('lorayn:checkout', reset);
      window.addEventListener('pageshow', reset);
    },

    /* Native Extras der App (Plugins Share, Haptics, Badge, AppBridge). Jede Funktion prüft, ob ihr Plugin da ist,
       damit ältere App-Versionen einfach ohne sie weiterlaufen. */
    native() {
      const P = (window.Capacitor && window.Capacitor.Plugins) || {};
      const absolute = (u) => { try { return new URL(u, location.origin).toString(); } catch (e) { return location.href; } };

      // Teilen auf der Produktseite
      if (P.Share) {
        $$('[data-app-share]').forEach((btn) => {
          btn.hidden = false;
          btn.addEventListener('click', () => {
            P.Share.share({ title: btn.dataset.title, url: absolute(btn.dataset.url), dialogTitle: btn.getAttribute('aria-label') }).catch(() => {});
          });
        });
      }

      // Haptik: kurzes Tippen beim Merken, Erfolg beim Hinzufügen zum Warenkorb
      if (P.Haptics) {
        document.addEventListener('cart:added', () => { P.Haptics.notification({ type: 'SUCCESS' }).catch(() => {}); });
        document.addEventListener('scratch:revealed', () => { P.Haptics.notification({ type: 'SUCCESS' }).catch(() => {}); });
        document.addEventListener('click', (e) => {
          if (e.target.closest && e.target.closest('[data-wish-toggle]')) P.Haptics.impact({ style: 'LIGHT' }).catch(() => {});
        });
      }

      // Zahl am App-Icon = Teile im Warenkorb. iOS zeigt sie nur mit Mitteilungs-Erlaubnis; um die fragt die App erst
      // beim Push, hier wird nie gefragt.
      if (P.Badge) {
        const sync = () => {
          P.Badge.checkPermissions().then((perm) => {
            if (perm.display !== 'granted') return;
            fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json())
              .then((cart) => (cart.item_count > 0 ? P.Badge.set({ count: cart.item_count }) : P.Badge.clear())).catch(() => {});
          }).catch(() => {});
        };
        sync();
        document.addEventListener('cart:added', sync);
        document.addEventListener('cart:changed', sync);
      }

      // Drop in den Kalender (nur solange er noch bevorsteht)
      if (P.AppBridge) {
        $$('[data-app-calendar]').forEach((btn) => {
          const box = btn.closest('[data-tm-drop]');
          const when = box && TM.parse(box.dataset.tmDrop);
          if (!when || when.ms <= TM.now()) return;
          btn.hidden = false;
          btn.addEventListener('click', () => {
            P.AppBridge.addToCalendar({ title: btn.dataset.title, start: when.ms, minutes: 30, url: absolute(btn.dataset.url) })
              .then((r) => {
                if (r && r.saved) btn.lastChild.textContent = ` ${btn.dataset.saved}`;
              }).catch(() => {});
          });
        });
      }

      // Drop-Wecker: „Weck mich zum Drop“ stellt einen Wecker (iPhone ab iOS 26.1 AlarmKit, sonst Mitteilung mit Glockenton);
      // nochmal tippen löscht ihn. Android ohne Erlaubnis für exakte Wecker: Hinweis-Knopf zur Systemseite.
      if (P.AppBridge && P.AppBridge.dropAlarm) {
        $$('[data-app-alarm]').forEach((btn) => {
          const box = btn.closest('[data-tm-drop]');
          const when = box && TM.parse(box.dataset.tmDrop);
          if (!when || when.ms - TM.now() < 60 * 1000) return;
          const label = btn.lastChild.textContent;
          const args = { title: btn.dataset.title, at: when.ms, url: absolute(btn.dataset.url) };
          let hint = null;
          const show = (r) => {
            const on = !!(r && r.active);
            btn.lastChild.textContent = on ? ` ${btn.dataset.on}` : (r && r.denied ? ` ${btn.dataset.denied}` : label);
            btn.setAttribute('aria-pressed', String(on));
            if (on && r.exact === false && !hint) {
              hint = document.createElement('button');
              hint.type = 'button';
              hint.className = 'link drop__exact';
              hint.style.cssText = 'display:block;margin-top:6px;padding:0;border:0;background:none;color:inherit;font:inherit;font-size:.9em;text-decoration:underline;cursor:pointer';
              hint.textContent = btn.dataset.exact;
              hint.addEventListener('click', () => P.AppBridge.dropAlarm({ action: 'exact' }).catch(() => {}));
              btn.after(hint);
            } else if ((!on || r.exact) && hint) {
              hint.remove();
              hint = null;
            }
          };
          P.AppBridge.dropAlarm({ ...args, action: 'status' }).then((r) => {
            if (!r || !r.supported) return;
            btn.hidden = false;
            show(r);
            btn.addEventListener('click', () => {
              const action = btn.getAttribute('aria-pressed') === 'true' ? 'off' : 'set';
              P.AppBridge.dropAlarm({ ...args, action }).then((res) => {
                show(res);
                if (res && res.active) P.Haptics?.notification({ type: 'SUCCESS' }).catch(() => {});
              }).catch(() => {});
            });
          }).catch(() => {});
        });
      }

      // Drop live verfolgen: Countdown auf Sperrbildschirm/Dynamic Island (iPhone) bzw. als Mitteilung (Android).
      // Das System begrenzt die Laufzeit (iOS 8 Std.), deshalb erscheint der Knopf erst in den letzten 8 Stunden.
      if (P.AppBridge && P.AppBridge.liveDrop) {
        $$('[data-app-live]').forEach((btn) => {
          const box = btn.closest('[data-tm-drop]');
          const when = box && TM.parse(box.dataset.tmDrop);
          if (!when || when.ms <= TM.now()) return;
          const label = btn.lastChild.textContent;
          const probe = document.createElement('i');
          probe.style.cssText = 'position:absolute;visibility:hidden;color:var(--c-accent)';
          document.body.appendChild(probe);
          const color = getComputedStyle(probe).color;
          probe.remove();
          const args = { title: btn.dataset.title, at: when.ms, url: absolute(btn.dataset.url), color };
          const show = (r) => {
            btn.lastChild.textContent = r && r.active ? ` ${btn.dataset.on}` : label;
            btn.setAttribute('aria-pressed', r && r.active ? 'true' : 'false');
          };
          P.AppBridge.liveDrop({ ...args, action: 'status' }).then((r) => {
            if (!r || !r.supported) return;
            const reveal = () => { btn.hidden = false; show(r); };
            const wait = when.ms - TM.now() - (r.maxLead || 8 * 3600 * 1000);
            if (wait <= 0) reveal();
            else if (wait < 24 * 3600 * 1000) setTimeout(reveal, wait);
            btn.addEventListener('click', () => {
              const action = btn.getAttribute('aria-pressed') === 'true' ? 'stop' : 'start';
              P.AppBridge.liveDrop({ ...args, action }).then(show).catch(() => {});
            });
          }).catch(() => {});
        });
      }
    },

    /* Mitteilungs-Themen ([data-app-push-topic]: drops, sale, back_<Produkt-ID>). Erscheinen nur, wenn die App Push
       eingerichtet hat (Firebase); nach der Erlaubnis fragt die App erst beim ersten Einschalten. Abschnitte mit
       [data-app-push-box] werden sichtbar, sobald einer ihrer Schalter es ist. */
    push() {
      const P = (window.Capacitor && window.Capacitor.Plugins) || {};
      const btns = $$('[data-app-push-topic]');
      if (!P.AppBridge || !P.AppBridge.push || !btns.length) return;
      P.AppBridge.push({ action: 'status' }).then((st) => {
        if (!st || !st.available) return;
        let topics = st.topics || [];
        btns.forEach((btn) => {
          const topic = btn.dataset.appPushTopic;
          const label = btn.lastChild.textContent;
          const show = (note) => {
            const on = topics.includes(topic);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            btn.lastChild.textContent = note ? ` ${note}` : on ? ` ${btn.dataset.on}` : label;
          };
          show();
          btn.hidden = false;
          const box = btn.closest('[data-app-push-box]');
          if (box) box.hidden = false;
          btn.addEventListener('click', () => {
            const on = btn.getAttribute('aria-pressed') !== 'true';
            P.AppBridge.push({ action: 'topic', topic, on, title: btn.dataset.title }).then((r) => {
              topics = (r && r.topics) || topics;
              show(on && r && r.permission === 'denied' ? btn.dataset.denied : '');
              btns.forEach((b) => { if (b !== btn && b.dataset.appPushTopic === topic) b.setAttribute('aria-pressed', topics.includes(topic) ? 'true' : 'false'); });
            }).catch(() => {});
          });
        });
      }).catch(() => {});
    },

    /* Native Einstellungsseite (AppBridge.openSettings). Öffnen über [data-app-settings] oder jeden Link auf
       #app-einstellungen (z. B. im Menü); Inhalt aus der Theme-Einstellung „App → Einstellungsseite“, Farben vom Theme.
       Links und Aktionen der Seite kommen als Ereignis „settings“ zurück und werden hier ausgeführt. */
    settings() {
      const P = (window.Capacitor && window.Capacitor.Plugins) || {};
      const box = document.getElementById('AppBridgeConfig');
      if (!P.AppBridge || !P.AppBridge.openSettings || !box) return;
      let cfg;
      try { cfg = JSON.parse(box.textContent).settings; } catch (e) { return; }
      if (!cfg) return;
      const color = (v) => {
        const probe = document.createElement('i');
        probe.style.cssText = `position:absolute;visibility:hidden;color:var(${v})`;
        document.body.appendChild(probe);
        const c = getComputedStyle(probe).color;
        probe.remove();
        return c;
      };
      const open = () => P.AppBridge.openSettings({
        ...cfg,
        colors: { bg: color('--c-bg'), text: color('--c-text'), accent: color('--c-accent') },
        dark: document.documentElement.classList.contains('is-dark')
      }).catch(() => {});
      const cookies = () => { if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences(); };
      P.AppBridge.addListener('settings', (e) => {
        if (e.type === 'link' && e.url) window.location.href = e.url;
        else if (e.type === 'action' && e.id === 'cookies') cookies();
      });
      $$('[data-app-settings]').forEach((btn) => { btn.hidden = false; });
      document.addEventListener('click', (e) => {
        const el = e.target.closest && e.target.closest('[data-app-settings], a[href$="#app-einstellungen"]');
        if (!el) return;
        e.preventDefault();
        open();
      });
      // Von der Kontoseite (eigenes Layout ohne Cookie-Banner) kommend: Cookie-Auswahl zeigen
      if (location.hash === '#app-cookies') {
        history.replaceState(null, '', location.pathname + location.search);
        let tries = 0;
        const wait = () => { if (window.privacyBanner) cookies(); else if (++tries < 20) setTimeout(wait, 250); };
        wait();
      }
    },

    /* Zustand für die native Tab-Leiste (Plugin AppBridge.setState): Stil je Plattform, Tabs, Beschriftungen,
       Farben aus den Theme-Variablen (inkl. Dark Mode und Saison), Zahlen, aktiver Tab, Versand-Ring.
       Grafiken (Theme-Icons, Mittelknopf, Handschrift, Saison-Motiv) gehen einmal pro Seite als Bilder an die App
       (AppBridge.setAssets); kurze Effekte („+1“, Herz, Abtauchen) über AppBridge.tabbarFx.
       Tippt die Kundin einen Tab, meldet die App dessen ID (Ereignis „tab“) und das Theme öffnet die Seite. */
    bridge() {
      const P = (window.Capacitor && window.Capacitor.Plugins) || {};
      const box = document.getElementById('AppBridgeConfig');
      if (!P.AppBridge || !P.AppBridge.setState || !box) return;
      let cfg;
      try { cfg = JSON.parse(box.textContent); } catch (e) { return; }
      const html = document.documentElement;
      const on = cfg.tabbar && html.classList.contains('has-native-tabs');
      if (on) $$('.thumbbar').forEach((el) => el.remove());
      const fx = cfg.fx || {};

      // Stil: iPhone und Android getrennt; „Wie Header-Variante“ übersetzt die Header-Variante
      const byHeader = { pill: 'pill', emb_press: 'classic', emb_peel: 'sticker', emb_cut: 'stroke', tape: 'tape', neon: 'neon', split: 'classic', shape: 'pill', island: 'figure', tab: 'tabs', dial: 'monogram' };
      const st = cfg.style || {};
      const platform = window.Capacitor.getPlatform ? window.Capacitor.getPlatform() : 'ios';
      let style = platform === 'android' && st.android && st.android !== 'same' ? st.android : st.ios;
      if (!style || style === 'auto') style = byHeader[st.header] || 'classic';
      const centered = style === 'monogram' || style === 'figure';

      const color = (v) => {
        const probe = document.createElement('i');
        probe.style.cssText = `position:absolute;visibility:hidden;color:${v.startsWith('#') ? v : `var(${v})`}`;
        document.body.appendChild(probe);
        const c = getComputedStyle(probe).color;
        probe.remove();
        return c;
      };
      const wishCount = () => { try { return (JSON.parse(localStorage.getItem('softriot:wish')) || []).length; } catch (e) { return 0; } };
      const local = (u) => String(u || '').replace(/^https?:\/\/[^/]+/i, '').split(/[?#]/)[0].replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
      const path = local(location.pathname);
      // Seiten-Ziele (Advent, Neuheiten, freie Tabs …) erkennt der aktive Tab an ihrer Adresse
      const byPage = ['advent', 'walls', 'new', 'sale', 'gift', 'drop', 'owl', 'year', 'live', 'free1', 'free2', 'free3'];
      const active = () => {
        const page = tabs.find((id) => byPage.includes(id) && cfg.urls[id] && local(cfg.urls[id]) === path && local(cfg.urls[id]) !== '/');
        if (page) return page;
        if (path === '/' || path === '') return 'home';
        if (path.startsWith('/search')) return 'search';
        if (path.startsWith('/cart')) return 'cart';
        if (path.startsWith('/collections')) return 'collections';
        if (path.startsWith('/account') || path.startsWith('/pages/app-konto')) return 'account';
        return '';
      };
      let cartCount = cfg.cartCount;
      let cartTotal = cfg.cartTotal || 0;
      // Adventskalender und Hintergründe kennt die App erst ab 0.2, die weiteren Ziele und „Mehr“ erst ab 0.3
      const appVer = (navigator.userAgent.match(/LoraynApp\/(\d+)\.(\d+)/) || []).slice(1).map(Number);
      const atLeast = (minor) => appVer.length === 2 && (appVer[0] > 0 || appVer[1] >= minor);
      const v2 = ['advent', 'walls'];
      const v3 = ['new', 'sale', 'gift', 'recent', 'mood', 'drop', 'owl', 'year', 'live', 'parcel', 'free1', 'free2', 'free3'];
      const chosen = [...new Set((cfg.tabs || []).filter((id) => id && id !== 'none' && cfg.labels[id]
        && (!v2.includes(id) || (atLeast(2) && cfg.urls[id]))
        && (!v3.includes(id) || (atLeast(3) && cfg.urls[id]))))].slice(0, atLeast(3) ? 10 : 7);
      // Zeit-Tabs (deutsche Zeit, im Editor mit Vorschau-Uhr): Drop mit Countdown, Nachteule, Werkstatt offen
      const time = cfg.time || {};
      const dropLabel = () => {
        const at = TM.parse(time.drop && time.drop.at);
        if (!at) return '';
        const until = TM.parse(time.drop.until);
        const end = until && until.ms > at.ms ? until.ms : at.ms + 864e5;
        const now = TM.now();
        if (now < at.ms - 864e5 || now >= end) return '';
        if (now >= at.ms) return cfg.dropText.live;
        const min = Math.ceil((at.ms - now) / 6e4);
        return cfg.dropText.in.replace('[zeit]', min >= 60 ? `${Math.ceil(min / 60)}h` : `${min}m`);
      };
      const owlOpen = () => {
        const o = time.owl || {};
        const h = TM.parts().h;
        return o.from < o.to ? h >= o.from && h < o.to : h >= o.from || h < o.to;
      };
      const liveOpen = () => {
        let st = HeaderExtras.config && HeaderExtras.config.status;
        if (!st) { try { st = JSON.parse($('[data-header-extras]').textContent).status; } catch (e) { st = null; } }
        if (!st || TM.vacation()) return false;
        const p = TM.parts();
        const [first, last] = String(st.days).split('-').map(Number);
        return p.dow >= first && p.dow <= last && p.h >= Number(st.from) && p.h < Number(st.to);
      };
      const label = (id) => (id === 'drop' ? dropLabel() : cfg.labels[id]);
      const shown = () => chosen.filter((id) => (id === 'owl' ? owlOpen() : id === 'live' ? liveOpen() : !!label(id)));
      let tabs = shown();
      // Versand-Ring: Grenze aus den App-Einstellungen, sonst wie der Ring im Header
      const ringMin = fx.ring ? (cfg.ringMin || Number(HeaderIcons.cfg && HeaderIcons.cfg.ring) || 0) : 0;
      const ring = () => {
        if (!ringMin) return null;
        const goal = Currency.convert(ringMin);
        const p = Math.min(1, cartTotal / goal);
        return { p, done: p >= 1, show: cartTotal > 0, text: p >= 1 ? cfg.ringText.done : cfg.ringText.left.replace('[betrag]', formatMoney(goal - cartTotal)) };
      };
      const setInset = (r) => { if (r && typeof r.inset === 'number') html.style.setProperty('--app-tabbar-h', `${Math.round(r.inset)}px`); };
      const send = () => P.AppBridge.setState({
        tabbar: on && tabs.length > 0,
        style,
        tabs: tabs.map((id) => ({ id, label: label(id), badge: id === 'cart' ? cartCount : (id === 'wish' ? wishCount() : 0), url: cfg.urls[id] || '', icon: (cfg.sym && cfg.sym[id]) || '' })),
        moreLabel: cfg.more || '',
        active: active(),
        colors: {
          bg: color('--c-bg'), text: color('--c-text'), accent: color('--c-accent'), onAccent: color('--c-on-accent'), line: color('--c-line'),
          tape: color(cfg.tape && cfg.tape.bg || '--c-accent'), tapeText: color(cfg.tape && cfg.tape.text || '--c-text'),
          neon: color(cfg.neon || '#ff5fa2'), ringDone: color(cfg.ringDone || '#2fa36b')
        },
        dark: html.classList.contains('is-dark'),
        ring: ring(),
        season: !!fx.season,
        shy: !!fx.shy,
        icon: AppExtras.seasonIcon() || cfg.icon
      }).then(setInset).catch(() => {});
      send();
      // Die App meldet den Platz nach, sobald er feststeht (z. B. mit Home-Balken)
      P.AppBridge.addListener('tabbarInset', setInset);
      // Zeit-Tabs: jede Minute prüfen und nur bei Änderung neu schicken
      if (chosen.some((id) => ['drop', 'owl', 'live'].includes(id))) {
        let key = tabs.map(label).join('|');
        setInterval(() => {
          tabs = shown();
          const next = tabs.map(label).join('|');
          if (next !== key) { key = next; send(); }
        }, 60000);
      }

      // Grafiken als PNG (dreifache Größe); einfarbige Grafiken färbt die App selbst ein
      const toImage = (src, cross) => new Promise((ok, fail) => {
        const img = new Image();
        if (cross) img.crossOrigin = 'anonymous';
        img.onload = () => ok(img);
        img.onerror = fail;
        img.src = src;
      });
      const raster = (img, w, h) => {
        const c = document.createElement('canvas');
        c.width = w;
        c.height = h || w;
        const x = c.getContext('2d');
        const r = Math.min(c.width / (img.naturalWidth || img.width || c.width), c.height / (img.naturalHeight || img.height || c.height));
        const dw = (img.naturalWidth || img.width || c.width) * r;
        const dh = (img.naturalHeight || img.height || c.height) * r;
        x.drawImage(img, (c.width - dw) / 2, (c.height - dh) / 2, dw, dh);
        return c.toDataURL('image/png');
      };
      const svgImage = (svg) => {
        const clone = svg.cloneNode(true);
        clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        clone.setAttribute('width', '72');
        clone.setAttribute('height', '72');
        const src = new XMLSerializer().serializeToString(clone).replace(/currentColor/g, '#000');
        return toImage(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(src)}`);
      };
      const cssUrl = (v) => { const m = String(v || '').match(/url\(["']?([^"')]+)["']?\)/); return m ? m[1] : ''; };
      const iconAsset = async (el) => {
        const svg = el.querySelector('svg');
        if (svg) return { img: raster(await svgImage(svg), 72), tint: true };
        const mask = el.querySelector('.icon--mask');
        const src = mask ? cssUrl(mask.style.getPropertyValue('--icon-src')) : (el.querySelector('img') || {}).src;
        if (!src) return null;
        return { img: raster(await toImage(src, true), 72), tint: !!mask };
      };
      const handAsset = async (text) => {
        const font = getComputedStyle(html).getPropertyValue('--font-accent').trim() || 'cursive';
        try { await document.fonts.load(`66px ${font}`, text); } catch (e) { /* Systemschrift */ }
        const c = document.createElement('canvas');
        const x = c.getContext('2d');
        x.font = `66px ${font}`;
        c.width = Math.ceil(x.measureText(text).width) + 12;
        c.height = 96;
        x.font = `66px ${font}`;
        x.textBaseline = 'middle';
        x.fillStyle = '#000';
        x.fillText(text, 6, 50);
        return { img: c.toDataURL('image/png'), tint: true };
      };
      // Saison-Motiv (wie die Effekte): Blüte im Frühling, Falter im Sommer, Blatt im Herbst, Fledermaus zu Halloween …
      const seasonAsset = () => {
        const p = TM.parts ? TM.parts() : { m: new Date().getMonth() + 1, d: new Date().getDate() };
        const md = p.m * 100 + p.d;
        const motif = md >= 1201 && md <= 1226 ? ['M12 1.5l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.6 5.6 21.1 7 14l-5.3-5 7.2-.9Z', '#d4ac0d']
          : md >= 1227 || md < 301 ? ['M11 2h2v20h-2zM2 11h20v2H2zM4.2 5.6l1.4-1.4 14.2 14.2-1.4 1.4zM18.4 4.2l1.4 1.4L5.6 19.8l-1.4-1.4z', '#8cc8f0']
          : md < 601 ? ['M12 7.2c-1.2-3-4.6-5-8-4.6C2 2.9 2.4 6.7 3.6 8.8c1 1.6 3 2.3 4.6 2.4-2.6.6-4.2 2.6-3.6 4.8.7 2.6 4.1 3.3 6 1.4.6-.6 1.1-1.6 1.4-2.6.3 1 .8 2 1.4 2.6 1.9 1.9 5.3 1.2 6-1.4.6-2.2-1-4.2-3.6-4.8 1.6-.1 3.6-.8 4.6-2.4 1.2-2.1 1.6-5.9-.4-6.2-3.4-.4-6.8 1.6-8 4.6Z', '#f7a1b5']
          : md < 901 ? ['M12 1c.6 5.3 2.7 7.6 11 11-8.3 3.4-10.4 5.7-11 11-.6-5.3-2.7-7.6-11-11 8.3-3.4 10.4-5.7 11-11Z', '#ffc928']
          : fx.halloween && md >= 1015 && md <= 1031 ? ['M12 8.6c-.5-1-1.2-1.6-1.2-1.6l-.4 1.4C8.7 7.2 5.4 6.8 1.5 8.8c2.1.6 3.2 2.1 3.4 3.8.9-.8 2.3-.9 3.2 0 .7-1 2.1-1.2 3-.3L12 14.6l.9-2.3c.9-.9 2.3-.7 3 .3.9-.9 2.3-.8 3.2 0 .2-1.7 1.3-3.2 3.4-3.8-3.9-2-7.2-1.6-8.9-.4l-.4-1.4s-.7.6-1.2 1.6Z', '#2b2230']
            : ['M19.5 2.5C10.5 3 4 7.8 4 15c0 2 .5 3.6 1.3 4.9L2.6 22.6l1.2 1.1 2.6-2.6c1.4 1 3.2 1.6 5.4 1.6 6.6 0 8.9-8.6 7.7-20.2ZM7.3 19.6c2.2-4.6 5.4-8.4 9.6-11.6-3.1 3.6-5.6 7.4-7.6 12.4l-2-.8Z', '#d35400'];
        const c = document.createElement('canvas');
        c.width = 48;
        c.height = 48;
        const x = c.getContext('2d');
        x.scale(2, 2);
        const shape = new Path2D(motif[0]);
        // heller Rand, damit das Motiv auf jeder Leistenfarbe sichtbar bleibt
        x.lineWidth = 2.4;
        x.lineJoin = 'round';
        x.strokeStyle = 'rgba(255,255,255,.9)';
        x.stroke(shape);
        x.fillStyle = motif[1];
        x.fill(shape);
        return { img: c.toDataURL('image/png'), tint: false };
      };
      const assets = async () => {
        const out = { icons: {}, hands: {} };
        const tpl = document.getElementById('AppBarIcons');
        if (tpl) {
          for (const el of tpl.content.querySelectorAll('[data-id]')) {
            if (!chosen.includes(el.dataset.id) && !(el.dataset.id === 'more' && chosen.length > 5)) continue;
            try { const a = await iconAsset(el); if (a) out.icons[el.dataset.id] = a; } catch (e) { /* Systemsymbol */ }
          }
        }
        if (style === 'sticker') {
          for (const id of chosen) { try { out.hands[id] = await handAsset(label(id) || cfg.labels[id]); } catch (e) { /* Systemschrift */ } }
          if (chosen.length > 5 && cfg.more) { try { out.hands.more = await handAsset(cfg.more); } catch (e) { /* Systemschrift */ } }
        }
        if (centered) {
          try {
            if (cfg.centerImg) out.center = { img: raster(await toImage(cfg.centerImg, true), 192), tint: false };
            else if (style === 'figure') {
              const head = cssUrl(getComputedStyle(html).getPropertyValue('--head'));
              if (head) out.center = { img: raster(await toImage(head, true), 192), tint: !html.classList.contains('icon-original') };
            }
          } catch (e) { /* Monogramm der App */ }
        }
        if (fx.season) out.season = seasonAsset();
        return out;
      };
      if (on && P.AppBridge.setAssets) assets().then((a) => P.AppBridge.setAssets(a)).catch(() => {});

      const refreshCart = () => fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => r.json()).then((c) => { cartCount = c.item_count; cartTotal = c.total_price; send(); }).catch(() => {});
      const effect = (type) => { if (on && P.AppBridge.tabbarFx) P.AppBridge.tabbarFx({ type }).catch(() => {}); };
      document.addEventListener('cart:added', () => { refreshCart(); if (fx.plus) effect('plus'); });
      document.addEventListener('cart:changed', refreshCart);
      document.addEventListener('click', (e) => {
        if (!(e.target.closest && e.target.closest('[data-wish-toggle]'))) return;
        setTimeout(send, 60);
        if (fx.heart) effect('heart');
      });
      // Dark-Mode-Umschalter und Zeitsteuerung ändern Klassen am <html>
      new MutationObserver(send).observe(html, { attributes: true, attributeFilter: ['class'] });

      // Abtauchen: runter scrollen versteckt die Leiste, hoch scrollen (oder ganz oben) holt sie zurück
      if (on && fx.shy) {
        let last = window.scrollY;
        let hidden = false;
        let ticking = false;
        window.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const y = window.scrollY;
            const d = y - last;
            if (Math.abs(d) < 12) return;
            last = y;
            const hide = d > 0 && y > 120;
            if (hide !== hidden) { hidden = hide; effect(hide ? 'collapse' : 'expand'); }
          });
        }, { passive: true });
      }

      // Merkzettel und „Zuletzt angesehen“: Fenster aus dem Header; ist das Symbol auf dem Handy ausgeblendet, unten über der Leiste
      const openPop = (name) => {
        const btn = $(`[data-hx-open="${name}"]`);
        const pop = $(`[data-hx-pop="${name}"]`);
        if (!btn || !pop) return false;
        btn.click();
        if (!pop.hidden && !btn.getBoundingClientRect().width) {
          const inset = parseFloat(getComputedStyle(html).getPropertyValue('--app-tabbar-h')) || 0;
          pop.style.setProperty('--x', `${window.innerWidth - 12}px`);
          pop.style.setProperty('--y', `${Math.max(12, window.innerHeight - inset - pop.offsetHeight - 12)}px`);
        }
        return true;
      };
      P.AppBridge.addListener('tab', ({ id }) => {
        if (id === 'menu') {
          const btn = $('[data-menu-open]');
          if (btn) btn.click();
        } else if (id === 'wish') {
          openPop('wish');
        } else if (id === 'recent') {
          if (!openPop('recent')) window.location.href = cfg.urls.recent;
        } else if (id === 'mood' && $('[data-mood]')) {
          $('[data-mood]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (id === 'cart' && theme.cartType === 'drawer' && $('[data-cart-open]')) {
          $('[data-cart-open]').click();
        } else if (cfg.urls[id]) {
          window.location.href = cfg.urls[id];
        }
      });
    },

    /* In der App führen Konto-Symbol, Daumenleiste und alle anderen Konto-Links zur eigenen Kontoseite
       (page.app-konto) statt zu Shopifys Kundenkonto. Ohne diese Seite bleibt alles beim Alten. */
    accountLinks() {
      const target = document.documentElement.getAttribute('data-app-account');
      if (!target) return;
      const isAccount = (a) => {
        try {
          const u = new URL(a.href, location.href);
          return /^account\./.test(u.hostname) || (u.hostname === location.hostname && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|customer_authentication\/redirect)(?:\/|$)/i.test(u.pathname));
        } catch (e) {
          return false;
        }
      };
      $$('a[href]').forEach((a) => { if (isAccount(a)) a.href = target; });
      document.addEventListener('click', (e) => {
        const a = e.target.closest && e.target.closest('a[href]');
        if (a && isAccount(a)) {
          e.preventDefault();
          window.location.href = target;
        }
      }, true);
    }
  };

  /* ---------- Start ---------- */
  const start = () => {
    AppMode.init();
    TM.init();
    initHeader();
    initMenu();
    HeaderExtras.init();
    AppExtras.init();
    HeaderIcons.init();
    HeaderVariant.init();
    initReveal();
    initCards();
    initFacets();
    initPromos();
    initMut();
    initCartNote();
    initSkullWatch();
    initSkullEgg();
    initMood();
    initTabs();
    initSizeMirror();
    initLook();
    initShopLook();
    initSocialWall();
    initScratch();
    initLocalization();
    initRails();
    initStickerWall();
    initLive();
    initMisc();
    initCookieLink();
    ConsentCleanup.init();
    Popups.init();
    Cart.init();
    initPromoCode();
    initCartUi();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
